//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { IAuthContext, AuthorizedApiBase } from './AuthorizedApiBase';

export interface IApiKeyRepository {

    /**
     * Lists API keys. Requires ApiKeys/Read only (class-level HasPrivilege default).
    Admins see every key. Other users see keys they created and keys assigned to them.
    Each key carries CanUpdate, CanExtend and CanDelete for the current user.
     * @param includeExpired (optional) 
     */
    list(includeExpired: boolean | undefined): Promise<ApiKeyDto[]>;

    create(request: CreateApiKeyRequest): Promise<ApiKeyDto>;

    /**
     * Updates an API key. Key admins may change every field. Other users (assigned user or creator) may change
    name, validity, email and institution; changing role, Allow Internal API or project access returns 403,
    and so does extending a key they could not have created (CanExtend).
    User-based keys always get the user's role.
    Omitted projects keeps the current project access.
     */
    update(id: number, key: ApiKeyDto): Promise<ApiKeyDto>;

    delete(id: number): Promise<void>;
}

export class ApiKeyRepository extends AuthorizedApiBase implements IApiKeyRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Lists API keys. Requires ApiKeys/Read only (class-level HasPrivilege default).
    Admins see every key. Other users see keys they created and keys assigned to them.
    Each key carries CanUpdate, CanExtend and CanDelete for the current user.
     * @param includeExpired (optional) 
     */
    list(includeExpired: boolean | undefined): Promise<ApiKeyDto[]> {
        let url_ = this.baseUrl + "/api/v1/api-keys?";
        if (includeExpired === null)
            throw new globalThis.Error("The parameter 'includeExpired' cannot be null.");
        else if (includeExpired !== undefined)
            url_ += "includeExpired=" + encodeURIComponent("" + includeExpired) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<ApiKeyDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiKeyDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiKeyDto[]>(null as any);
    }

    create(request: CreateApiKeyRequest): Promise<ApiKeyDto> {
        let url_ = this.baseUrl + "/api/v1/api-keys";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<ApiKeyDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiKeyDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiKeyDto>(null as any);
    }

    /**
     * Updates an API key. Key admins may change every field. Other users (assigned user or creator) may change
    name, validity, email and institution; changing role, Allow Internal API or project access returns 403,
    and so does extending a key they could not have created (CanExtend).
    User-based keys always get the user's role.
    Omitted projects keeps the current project access.
     */
    update(id: number, key: ApiKeyDto): Promise<ApiKeyDto> {
        let url_ = this.baseUrl + "/api/v1/api-keys/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(key);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<ApiKeyDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiKeyDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiKeyDto>(null as any);
    }

    delete(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/api-keys/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IAutoSubmitRecordApiRepository {

    retryEntry(ids: number[]): Promise<void>;

    /**
     * Lists auto-submit records for a research group with optional filters.
     * @param group Research group name
     * @param sampleId (optional) Optional sample ID filter
     * @param filterStatus (optional) Filter by status. Omit or null = no filter.
     * @param createdBy (optional) Optional creator user ID filter
     * @param growthDateFrom (optional) Optional growth date range start
     * @param growthDateTo (optional) Optional growth date range end
     * @param searchMessage (optional) Optional message search
     */
    list(group: string, sampleId: string | null | undefined, filterStatus: AutoSubmitFilterStatusDto | null | undefined, createdBy: string | null | undefined, growthDateFrom: string | null | undefined, growthDateTo: string | null | undefined, searchMessage: string | null | undefined): Promise<AutoSubmitRecordDto[]>;

    getJobStatus(group: string): Promise<string>;

    startUpload(group: string): Promise<void>;

    getStatistics(group: string): Promise<CharacterizationUploadStat[]>;

    deleteEntry(id: number): Promise<void>;

    getFolders(): Promise<string[]>;

    reload(): Promise<void>;
}

export class AutoSubmitRecordApiRepository extends AuthorizedApiBase implements IAutoSubmitRecordApiRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    retryEntry(ids: number[]): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/auto-submit-records";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRetryEntry(_response));
        });
    }

    protected processRetryEntry(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Lists auto-submit records for a research group with optional filters.
     * @param group Research group name
     * @param sampleId (optional) Optional sample ID filter
     * @param filterStatus (optional) Filter by status. Omit or null = no filter.
     * @param createdBy (optional) Optional creator user ID filter
     * @param growthDateFrom (optional) Optional growth date range start
     * @param growthDateTo (optional) Optional growth date range end
     * @param searchMessage (optional) Optional message search
     */
    list(group: string, sampleId: string | null | undefined, filterStatus: AutoSubmitFilterStatusDto | null | undefined, createdBy: string | null | undefined, growthDateFrom: string | null | undefined, growthDateTo: string | null | undefined, searchMessage: string | null | undefined): Promise<AutoSubmitRecordDto[]> {
        let url_ = this.baseUrl + "/api/v1/auto-submit-records/{group}?";
        if (group === undefined || group === null)
            throw new globalThis.Error("The parameter 'group' must be defined.");
        url_ = url_.replace("{group}", encodeURIComponent("" + group));
        if (sampleId !== undefined && sampleId !== null)
            url_ += "sampleId=" + encodeURIComponent("" + sampleId) + "&";
        if (filterStatus !== undefined && filterStatus !== null)
            url_ += "filterStatus=" + encodeURIComponent("" + filterStatus) + "&";
        if (createdBy !== undefined && createdBy !== null)
            url_ += "createdBy=" + encodeURIComponent("" + createdBy) + "&";
        if (growthDateFrom !== undefined && growthDateFrom !== null)
            url_ += "growthDateFrom=" + encodeURIComponent("" + growthDateFrom) + "&";
        if (growthDateTo !== undefined && growthDateTo !== null)
            url_ += "growthDateTo=" + encodeURIComponent("" + growthDateTo) + "&";
        if (searchMessage !== undefined && searchMessage !== null)
            url_ += "searchMessage=" + encodeURIComponent("" + searchMessage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<AutoSubmitRecordDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AutoSubmitRecordDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AutoSubmitRecordDto[]>(null as any);
    }

    getJobStatus(group: string): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/auto-submit-records/{group}/job-status";
        if (group === undefined || group === null)
            throw new globalThis.Error("The parameter 'group' must be defined.");
        url_ = url_.replace("{group}", encodeURIComponent("" + group));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetJobStatus(_response));
        });
    }

    protected processGetJobStatus(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    startUpload(group: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/auto-submit-records/{group}/start";
        if (group === undefined || group === null)
            throw new globalThis.Error("The parameter 'group' must be defined.");
        url_ = url_.replace("{group}", encodeURIComponent("" + group));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processStartUpload(_response));
        });
    }

    protected processStartUpload(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getStatistics(group: string): Promise<CharacterizationUploadStat[]> {
        let url_ = this.baseUrl + "/api/v1/auto-submit-records/{group}/statistics";
        if (group === undefined || group === null)
            throw new globalThis.Error("The parameter 'group' must be defined.");
        url_ = url_.replace("{group}", encodeURIComponent("" + group));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStatistics(_response));
        });
    }

    protected processGetStatistics(response: Response): Promise<CharacterizationUploadStat[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CharacterizationUploadStat[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CharacterizationUploadStat[]>(null as any);
    }

    deleteEntry(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/auto-submit-records/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteEntry(_response));
        });
    }

    protected processDeleteEntry(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getFolders(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/auto-submit-records/groups";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFolders(_response));
        });
    }

    protected processGetFolders(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    reload(): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/auto-submit-records/reload";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReload(_response));
        });
    }

    protected processReload(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IBulkElementApiRepository {

    /**
     * Returns all bulk elements.
     */
    list(): Promise<BulkElementDto[]>;

    /**
     * Creates a bulk element. Returns 400 if an element with the same name already exists.
     */
    create(element: BulkElementDto): Promise<BulkElementDto>;

    /**
     * Updates a bulk element. Body ID must match route id.
     */
    update(id: number, element: BulkElementDto): Promise<BulkElementDto>;

    /**
     * Deletes a bulk element by id.
     */
    delete(id: number): Promise<void>;
}

export class BulkElementApiRepository extends AuthorizedApiBase implements IBulkElementApiRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Returns all bulk elements.
     */
    list(): Promise<BulkElementDto[]> {
        let url_ = this.baseUrl + "/api/v1/bulk-elements";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<BulkElementDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkElementDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkElementDto[]>(null as any);
    }

    /**
     * Creates a bulk element. Returns 400 if an element with the same name already exists.
     */
    create(element: BulkElementDto): Promise<BulkElementDto> {
        let url_ = this.baseUrl + "/api/v1/bulk-elements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(element);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<BulkElementDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkElementDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkElementDto>(null as any);
    }

    /**
     * Updates a bulk element. Body ID must match route id.
     */
    update(id: number, element: BulkElementDto): Promise<BulkElementDto> {
        let url_ = this.baseUrl + "/api/v1/bulk-elements/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(element);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<BulkElementDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkElementDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkElementDto>(null as any);
    }

    /**
     * Deletes a bulk element by id.
     */
    delete(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/bulk-elements/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IBulkRawMaterialApiRepository {

    /**
     * Returns all bulk raw materials.
     */
    list(): Promise<BulkRawMaterialDto[]>;

    /**
     * Creates a bulk raw material.
     */
    create(rawMaterial: BulkRawMaterialDto): Promise<BulkRawMaterialDto>;

    /**
     * Updates a bulk raw material. Body ID must match route id.
     */
    update(id: number, rawMaterial: BulkRawMaterialDto): Promise<BulkRawMaterialDto>;

    /**
     * Deletes a bulk raw material by id.
     */
    delete(id: number): Promise<void>;

    /**
     * Returns vendor, lot, and granularity lists for dropdowns.
     */
    getDropdownChoices(): Promise<SubstrateDropdownChoicesDto>;
}

export class BulkRawMaterialApiRepository extends AuthorizedApiBase implements IBulkRawMaterialApiRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Returns all bulk raw materials.
     */
    list(): Promise<BulkRawMaterialDto[]> {
        let url_ = this.baseUrl + "/api/v1/bulk-materials";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<BulkRawMaterialDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkRawMaterialDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkRawMaterialDto[]>(null as any);
    }

    /**
     * Creates a bulk raw material.
     */
    create(rawMaterial: BulkRawMaterialDto): Promise<BulkRawMaterialDto> {
        let url_ = this.baseUrl + "/api/v1/bulk-materials";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rawMaterial);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<BulkRawMaterialDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkRawMaterialDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkRawMaterialDto>(null as any);
    }

    /**
     * Updates a bulk raw material. Body ID must match route id.
     */
    update(id: number, rawMaterial: BulkRawMaterialDto): Promise<BulkRawMaterialDto> {
        let url_ = this.baseUrl + "/api/v1/bulk-materials/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rawMaterial);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<BulkRawMaterialDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkRawMaterialDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkRawMaterialDto>(null as any);
    }

    /**
     * Deletes a bulk raw material by id.
     */
    delete(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/bulk-materials/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Returns vendor, lot, and granularity lists for dropdowns.
     */
    getDropdownChoices(): Promise<SubstrateDropdownChoicesDto> {
        let url_ = this.baseUrl + "/api/v1/bulk-materials/drop-down-choices";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDropdownChoices(_response));
        });
    }

    protected processGetDropdownChoices(response: Response): Promise<SubstrateDropdownChoicesDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubstrateDropdownChoicesDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubstrateDropdownChoicesDto>(null as any);
    }
}

export interface IBulkSampleApiRepository {

    createCompounding(growthId: number, instrumentRun: InstrumentRunDto): Promise<InstrumentRunDto>;

    getCompounding(id: number): Promise<InstrumentRunDto>;

    updateCompounding(id: number, instrumentRun: InstrumentRunDto): Promise<InstrumentRunDto>;

    createGrowthRun(request: CreateBulkGrowthRequest): Promise<BulkSamplesDto>;

    addSamplesToGrowth(growthId: number, subSamples: number[]): Promise<BulkSamplesDto>;

    /**
     * Load bulk samples matching search criteria. Returns 200 with an empty page when nothing matches.
    Malformed body or non-Bulk technique yields 400. Authorization failures yield 403. Never 404 for criteria misses.
     * @param sortColumn (optional) 
     * @param sortOrder (optional) 
     * @param start (optional) 
     * @param length (optional) 
     * @param draw (optional) 
     */
    loadSamples(sortColumn: string | null | undefined, sortOrder: string | null | undefined, start: number | undefined, length: number | undefined, draw: number | undefined, criteria: SampleSearchCriteria): Promise<BulkSamplesDto>;

    getPreparation(id: number): Promise<SampleActivityDto>;

    updatePreparation(id: number, request: UpdateBulkPreparationRequest): Promise<BulkSampleDto>;

    createSample(request: CreateBulkSampleRequest): Promise<BulkSamplesDto>;

    updateReportingCategory(sampleId: number, categoryId: number): Promise<void>;

    updateQualityCategory(sampleId: number, quality: string): Promise<void>;

    copySamples(request: CopyBulkSampleRequest): Promise<BulkSamplesDto>;

    /**
     * Resolve bulk-shipping rows to sample IDs: parse piece specs (ranges/lists), get or create pieces, or ship whole.
     */
    resolveShippingSamples(request: BulkShippingResolveRequestDto): Promise<SampleWithLabelDto[]>;

    getSynthesis(id: number): Promise<InstrumentRunDto>;

    updateSynthesis(id: number, instrumentRun: InstrumentRunDto): Promise<InstrumentRunDto>;
}

export class BulkSampleApiRepository extends AuthorizedApiBase implements IBulkSampleApiRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    createCompounding(growthId: number, instrumentRun: InstrumentRunDto): Promise<InstrumentRunDto> {
        let url_ = this.baseUrl + "/api/v1/bulk/compounding/{growthId}";
        if (growthId === undefined || growthId === null)
            throw new globalThis.Error("The parameter 'growthId' must be defined.");
        url_ = url_.replace("{growthId}", encodeURIComponent("" + growthId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(instrumentRun);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateCompounding(_response));
        });
    }

    protected processCreateCompounding(response: Response): Promise<InstrumentRunDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InstrumentRunDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentRunDto>(null as any);
    }

    getCompounding(id: number): Promise<InstrumentRunDto> {
        let url_ = this.baseUrl + "/api/v1/bulk/compounding/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCompounding(_response));
        });
    }

    protected processGetCompounding(response: Response): Promise<InstrumentRunDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InstrumentRunDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentRunDto>(null as any);
    }

    updateCompounding(id: number, instrumentRun: InstrumentRunDto): Promise<InstrumentRunDto> {
        let url_ = this.baseUrl + "/api/v1/bulk/compounding/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(instrumentRun);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateCompounding(_response));
        });
    }

    protected processUpdateCompounding(response: Response): Promise<InstrumentRunDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InstrumentRunDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentRunDto>(null as any);
    }

    createGrowthRun(request: CreateBulkGrowthRequest): Promise<BulkSamplesDto> {
        let url_ = this.baseUrl + "/api/v1/bulk/growth";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateGrowthRun(_response));
        });
    }

    protected processCreateGrowthRun(response: Response): Promise<BulkSamplesDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkSamplesDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkSamplesDto>(null as any);
    }

    addSamplesToGrowth(growthId: number, subSamples: number[]): Promise<BulkSamplesDto> {
        let url_ = this.baseUrl + "/api/v1/bulk/growth/{growthId}/addSamples";
        if (growthId === undefined || growthId === null)
            throw new globalThis.Error("The parameter 'growthId' must be defined.");
        url_ = url_.replace("{growthId}", encodeURIComponent("" + growthId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(subSamples);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddSamplesToGrowth(_response));
        });
    }

    protected processAddSamplesToGrowth(response: Response): Promise<BulkSamplesDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkSamplesDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkSamplesDto>(null as any);
    }

    /**
     * Load bulk samples matching search criteria. Returns 200 with an empty page when nothing matches.
    Malformed body or non-Bulk technique yields 400. Authorization failures yield 403. Never 404 for criteria misses.
     * @param sortColumn (optional) 
     * @param sortOrder (optional) 
     * @param start (optional) 
     * @param length (optional) 
     * @param draw (optional) 
     */
    loadSamples(sortColumn: string | null | undefined, sortOrder: string | null | undefined, start: number | undefined, length: number | undefined, draw: number | undefined, criteria: SampleSearchCriteria): Promise<BulkSamplesDto> {
        let url_ = this.baseUrl + "/api/v1/bulk/load?";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (length === null)
            throw new globalThis.Error("The parameter 'length' cannot be null.");
        else if (length !== undefined)
            url_ += "length=" + encodeURIComponent("" + length) + "&";
        if (draw === null)
            throw new globalThis.Error("The parameter 'draw' cannot be null.");
        else if (draw !== undefined)
            url_ += "draw=" + encodeURIComponent("" + draw) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(criteria);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoadSamples(_response));
        });
    }

    protected processLoadSamples(response: Response): Promise<BulkSamplesDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkSamplesDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkSamplesDto>(null as any);
    }

    getPreparation(id: number): Promise<SampleActivityDto> {
        let url_ = this.baseUrl + "/api/v1/bulk/preparation/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPreparation(_response));
        });
    }

    protected processGetPreparation(response: Response): Promise<SampleActivityDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleActivityDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleActivityDto>(null as any);
    }

    updatePreparation(id: number, request: UpdateBulkPreparationRequest): Promise<BulkSampleDto> {
        let url_ = this.baseUrl + "/api/v1/bulk/preparation/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdatePreparation(_response));
        });
    }

    protected processUpdatePreparation(response: Response): Promise<BulkSampleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkSampleDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkSampleDto>(null as any);
    }

    createSample(request: CreateBulkSampleRequest): Promise<BulkSamplesDto> {
        let url_ = this.baseUrl + "/api/v1/bulk/sample";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateSample(_response));
        });
    }

    protected processCreateSample(response: Response): Promise<BulkSamplesDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkSamplesDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkSamplesDto>(null as any);
    }

    updateReportingCategory(sampleId: number, categoryId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/bulk/sample/{sampleId}/category/{categoryId}";
        if (sampleId === undefined || sampleId === null)
            throw new globalThis.Error("The parameter 'sampleId' must be defined.");
        url_ = url_.replace("{sampleId}", encodeURIComponent("" + sampleId));
        if (categoryId === undefined || categoryId === null)
            throw new globalThis.Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateReportingCategory(_response));
        });
    }

    protected processUpdateReportingCategory(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    updateQualityCategory(sampleId: number, quality: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/bulk/sample/{sampleId}/quality";
        if (sampleId === undefined || sampleId === null)
            throw new globalThis.Error("The parameter 'sampleId' must be defined.");
        url_ = url_.replace("{sampleId}", encodeURIComponent("" + sampleId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(quality);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateQualityCategory(_response));
        });
    }

    protected processUpdateQualityCategory(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    copySamples(request: CopyBulkSampleRequest): Promise<BulkSamplesDto> {
        let url_ = this.baseUrl + "/api/v1/bulk/sample/copy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCopySamples(_response));
        });
    }

    protected processCopySamples(response: Response): Promise<BulkSamplesDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BulkSamplesDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BulkSamplesDto>(null as any);
    }

    /**
     * Resolve bulk-shipping rows to sample IDs: parse piece specs (ranges/lists), get or create pieces, or ship whole.
     */
    resolveShippingSamples(request: BulkShippingResolveRequestDto): Promise<SampleWithLabelDto[]> {
        let url_ = this.baseUrl + "/api/v1/bulk/shipping/resolve-samples";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processResolveShippingSamples(_response));
        });
    }

    protected processResolveShippingSamples(response: Response): Promise<SampleWithLabelDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleWithLabelDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleWithLabelDto[]>(null as any);
    }

    getSynthesis(id: number): Promise<InstrumentRunDto> {
        let url_ = this.baseUrl + "/api/v1/bulk/synthesis/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSynthesis(_response));
        });
    }

    protected processGetSynthesis(response: Response): Promise<InstrumentRunDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InstrumentRunDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentRunDto>(null as any);
    }

    updateSynthesis(id: number, instrumentRun: InstrumentRunDto): Promise<InstrumentRunDto> {
        let url_ = this.baseUrl + "/api/v1/bulk/synthesis/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(instrumentRun);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateSynthesis(_response));
        });
    }

    protected processUpdateSynthesis(response: Response): Promise<InstrumentRunDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InstrumentRunDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentRunDto>(null as any);
    }
}

export interface ICharInstrumentApiRepository {

    list(loadDefaultConfig: boolean | undefined): Promise<CharacterizationInstrumentDto[]>;

    create(instrument: CharacterizationInstrumentDto): Promise<CharacterizationInstrumentDto>;

    update(id: string, instrument: CharacterizationInstrumentDto): Promise<CharacterizationInstrumentDto>;

    delete(id: number): Promise<void>;

    getDropdownChoices(): Promise<CharInstrumentDropdownChoicesDto>;
}

export class CharInstrumentApiRepository extends AuthorizedApiBase implements ICharInstrumentApiRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    list(loadDefaultConfig: boolean | undefined): Promise<CharacterizationInstrumentDto[]> {
        let url_ = this.baseUrl + "/api/v1/characterization-instruments?";
        if (loadDefaultConfig === null)
            throw new globalThis.Error("The parameter 'loadDefaultConfig' cannot be null.");
        else if (loadDefaultConfig !== undefined)
            url_ += "loadDefaultConfig=" + encodeURIComponent("" + loadDefaultConfig) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<CharacterizationInstrumentDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CharacterizationInstrumentDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CharacterizationInstrumentDto[]>(null as any);
    }

    create(instrument: CharacterizationInstrumentDto): Promise<CharacterizationInstrumentDto> {
        let url_ = this.baseUrl + "/api/v1/characterization-instruments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(instrument);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<CharacterizationInstrumentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CharacterizationInstrumentDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CharacterizationInstrumentDto>(null as any);
    }

    update(id: string, instrument: CharacterizationInstrumentDto): Promise<CharacterizationInstrumentDto> {
        let url_ = this.baseUrl + "/api/v1/characterization-instruments/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(instrument);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<CharacterizationInstrumentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CharacterizationInstrumentDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CharacterizationInstrumentDto>(null as any);
    }

    delete(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/characterization-instruments/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 501) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getDropdownChoices(): Promise<CharInstrumentDropdownChoicesDto> {
        let url_ = this.baseUrl + "/api/v1/characterization-instruments/drop-down-choices";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDropdownChoices(_response));
        });
    }

    protected processGetDropdownChoices(response: Response): Promise<CharInstrumentDropdownChoicesDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CharInstrumentDropdownChoicesDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CharInstrumentDropdownChoicesDto>(null as any);
    }
}

export interface ICharacterizationTechniqueRepository {

    list(): Promise<CharacterizationTechniqueDto[]>;

    create(technique: CharacterizationTechniqueDto): Promise<CharacterizationTechniqueDto>;

    update(id: string, technique: CharacterizationTechniqueDto): Promise<CharacterizationTechniqueDto>;

    delete(id: number): Promise<void>;
}

export class CharacterizationTechniqueRepository extends AuthorizedApiBase implements ICharacterizationTechniqueRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    list(): Promise<CharacterizationTechniqueDto[]> {
        let url_ = this.baseUrl + "/api/v1/characterization-techniques";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<CharacterizationTechniqueDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CharacterizationTechniqueDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CharacterizationTechniqueDto[]>(null as any);
    }

    create(technique: CharacterizationTechniqueDto): Promise<CharacterizationTechniqueDto> {
        let url_ = this.baseUrl + "/api/v1/characterization-techniques";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(technique);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<CharacterizationTechniqueDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CharacterizationTechniqueDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CharacterizationTechniqueDto>(null as any);
    }

    update(id: string, technique: CharacterizationTechniqueDto): Promise<CharacterizationTechniqueDto> {
        let url_ = this.baseUrl + "/api/v1/characterization-techniques/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(technique);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<CharacterizationTechniqueDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CharacterizationTechniqueDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CharacterizationTechniqueDto>(null as any);
    }

    delete(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/characterization-techniques/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ICharacterizationUploadRecordApiRepository {

    retryEntry(ids: number[]): Promise<void>;

    list(sortColumn: string | null | undefined, sortOrder: string | null | undefined, start: number | undefined, length: number | undefined, draw: number | undefined, criteria: CharacterizationUploadFilterDto): Promise<PagingResultOfCharacterizationUploadRecordDto>;

    getJobStatus(folder: string): Promise<string>;

    getStatistics(folder: string): Promise<CharacterizationUploadStat[]>;

    deleteEntry(id: number): Promise<void>;

    download(id: number): Promise<FileResponse>;

    getFolders(): Promise<string[]>;

    reload(): Promise<void>;

    restartAll(criteria: CharacterizationUploadFilterDto): Promise<void>;

    getSources(): Promise<string[]>;
}

export class CharacterizationUploadRecordApiRepository extends AuthorizedApiBase implements ICharacterizationUploadRecordApiRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    retryEntry(ids: number[]): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/characterization-upload-records";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRetryEntry(_response));
        });
    }

    protected processRetryEntry(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    list(sortColumn: string | null | undefined, sortOrder: string | null | undefined, start: number | undefined, length: number | undefined, draw: number | undefined, criteria: CharacterizationUploadFilterDto): Promise<PagingResultOfCharacterizationUploadRecordDto> {
        let url_ = this.baseUrl + "/api/v1/characterization-upload-records?";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (length === null)
            throw new globalThis.Error("The parameter 'length' cannot be null.");
        else if (length !== undefined)
            url_ += "length=" + encodeURIComponent("" + length) + "&";
        if (draw === null)
            throw new globalThis.Error("The parameter 'draw' cannot be null.");
        else if (draw !== undefined)
            url_ += "draw=" + encodeURIComponent("" + draw) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(criteria);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<PagingResultOfCharacterizationUploadRecordDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingResultOfCharacterizationUploadRecordDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingResultOfCharacterizationUploadRecordDto>(null as any);
    }

    getJobStatus(folder: string): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/characterization-upload-records/{folder}/job-status";
        if (folder === undefined || folder === null)
            throw new globalThis.Error("The parameter 'folder' must be defined.");
        url_ = url_.replace("{folder}", encodeURIComponent("" + folder));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetJobStatus(_response));
        });
    }

    protected processGetJobStatus(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getStatistics(folder: string): Promise<CharacterizationUploadStat[]> {
        let url_ = this.baseUrl + "/api/v1/characterization-upload-records/{folder}/statistics";
        if (folder === undefined || folder === null)
            throw new globalThis.Error("The parameter 'folder' must be defined.");
        url_ = url_.replace("{folder}", encodeURIComponent("" + folder));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStatistics(_response));
        });
    }

    protected processGetStatistics(response: Response): Promise<CharacterizationUploadStat[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CharacterizationUploadStat[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CharacterizationUploadStat[]>(null as any);
    }

    deleteEntry(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/characterization-upload-records/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteEntry(_response));
        });
    }

    protected processDeleteEntry(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    download(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/characterization-upload-records/{id}/file";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownload(_response));
        });
    }

    protected processDownload(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getFolders(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/characterization-upload-records/folders";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFolders(_response));
        });
    }

    protected processGetFolders(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    reload(): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/characterization-upload-records/reload";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReload(_response));
        });
    }

    protected processReload(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    restartAll(criteria: CharacterizationUploadFilterDto): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/characterization-upload-records/restartAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(criteria);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRestartAll(_response));
        });
    }

    protected processRestartAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getSources(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/characterization-upload-records/sources";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSources(_response));
        });
    }

    protected processGetSources(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export interface ICommunicationApiRepository {

    create(request: CreateCommunicationRequest): Promise<CommunicationDto>;

    /**
     * @param fileIds (optional) 
     * @deprecated
     */
    checkFile(communicationId: number, fileIds: string | null | undefined): Promise<FileCheckDto[]>;

    /**
     * Updates file metadata for a logical file group. Same body as legacy PUT …/files.
     */
    updateFileGroup(communicationId: number, dto: FileMetaDataCreateOrUpdateRequest): Promise<FileMetaDataDto>;

    /**
     * Returns logical file groups for the communication.
     */
    getFileGroups(communicationId: number): Promise<FileMetaDataDto[]>;

    /**
     * Deletes every stored format in a logical file group.
     */
    deleteFileGroup(communicationId: number, fileGroupId: number): Promise<void>;

    /**
     * Updates file metadata for a file group on a communication. Send id or basename to identify the group.
     * @deprecated
     */
    updateFile(communicationId: number, dto: FileMetaDataCreateOrUpdateRequest): Promise<FileMetaDataDto>;

    /**
     * Legacy file upload using Fine Uploader request body. Prefer UploadCommunicationFileForm (multipart form).
     * @deprecated
     */
    uploadFile(communicationId: number, file: FineUploadFileDto): Promise<void>;

    /**
     * JSON array of file metadata groups (no file bytes). Prefer GET …/file-groups; use GET …/files/{{fileId}} for bytes.
     * @deprecated
     */
    getFiles(communicationId: number): Promise<FileMetaDataDto[]>;

    getFile(fileId: number, communicationId: number): Promise<FileResponse>;

    deleteFile(fileId: number, communicationId: number): Promise<void>;

    checkFilesUnderFilesRoute(communicationId: number, fileIds: string | null | undefined): Promise<FileCheckDto[]>;

    /**
     * Upload a file to a communication via multipart form. Returns the created file metadata on success.
    Preferred over the legacy POST .../files endpoint (Fine Uploader only).
     * @param uploadFile (optional) 
     * @param description (optional) 
     * @param visibility (optional) 
     * @param fields (optional) 
     */
    uploadCommunicationFileForm(communicationId: number, uploadFile: FileParameter | undefined, description: string | null | undefined, visibility: VisibilityDto | null | undefined, fields: FileMetaDataFieldWriteRequest[] | null | undefined): Promise<FileMetaDataDto>;

    getImage(communicationId: number, fileId: number): Promise<FileResponse>;

    get(id: number): Promise<CommunicationDto>;

    delete(id: number): Promise<void>;

    update(id: number, request: UpdateCommunicationRequest): Promise<CommunicationDto>;

    getDropdownChoices(): Promise<void>;
}

export class CommunicationApiRepository extends AuthorizedApiBase implements ICommunicationApiRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    create(request: CreateCommunicationRequest): Promise<CommunicationDto> {
        let url_ = this.baseUrl + "/api/v1/communications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<CommunicationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CommunicationDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommunicationDto>(null as any);
    }

    /**
     * @param fileIds (optional) 
     * @deprecated
     */
    checkFile(communicationId: number, fileIds: string | null | undefined): Promise<FileCheckDto[]> {
        let url_ = this.baseUrl + "/api/v1/communications/{communicationId}/check-file?";
        if (communicationId === undefined || communicationId === null)
            throw new globalThis.Error("The parameter 'communicationId' must be defined.");
        url_ = url_.replace("{communicationId}", encodeURIComponent("" + communicationId));
        if (fileIds !== undefined && fileIds !== null)
            url_ += "fileIds=" + encodeURIComponent("" + fileIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckFile(_response));
        });
    }

    protected processCheckFile(response: Response): Promise<FileCheckDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileCheckDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileCheckDto[]>(null as any);
    }

    /**
     * Updates file metadata for a logical file group. Same body as legacy PUT …/files.
     */
    updateFileGroup(communicationId: number, dto: FileMetaDataCreateOrUpdateRequest): Promise<FileMetaDataDto> {
        let url_ = this.baseUrl + "/api/v1/communications/{communicationId}/file-groups";
        if (communicationId === undefined || communicationId === null)
            throw new globalThis.Error("The parameter 'communicationId' must be defined.");
        url_ = url_.replace("{communicationId}", encodeURIComponent("" + communicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateFileGroup(_response));
        });
    }

    protected processUpdateFileGroup(response: Response): Promise<FileMetaDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto>(null as any);
    }

    /**
     * Returns logical file groups for the communication.
     */
    getFileGroups(communicationId: number): Promise<FileMetaDataDto[]> {
        let url_ = this.baseUrl + "/api/v1/communications/{communicationId}/file-groups";
        if (communicationId === undefined || communicationId === null)
            throw new globalThis.Error("The parameter 'communicationId' must be defined.");
        url_ = url_.replace("{communicationId}", encodeURIComponent("" + communicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFileGroups(_response));
        });
    }

    protected processGetFileGroups(response: Response): Promise<FileMetaDataDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto[]>(null as any);
    }

    /**
     * Deletes every stored format in a logical file group.
     */
    deleteFileGroup(communicationId: number, fileGroupId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/communications/{communicationId}/file-groups/{fileGroupId}";
        if (communicationId === undefined || communicationId === null)
            throw new globalThis.Error("The parameter 'communicationId' must be defined.");
        url_ = url_.replace("{communicationId}", encodeURIComponent("" + communicationId));
        if (fileGroupId === undefined || fileGroupId === null)
            throw new globalThis.Error("The parameter 'fileGroupId' must be defined.");
        url_ = url_.replace("{fileGroupId}", encodeURIComponent("" + fileGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteFileGroup(_response));
        });
    }

    protected processDeleteFileGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Updates file metadata for a file group on a communication. Send id or basename to identify the group.
     * @deprecated
     */
    updateFile(communicationId: number, dto: FileMetaDataCreateOrUpdateRequest): Promise<FileMetaDataDto> {
        let url_ = this.baseUrl + "/api/v1/communications/{communicationId}/files";
        if (communicationId === undefined || communicationId === null)
            throw new globalThis.Error("The parameter 'communicationId' must be defined.");
        url_ = url_.replace("{communicationId}", encodeURIComponent("" + communicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateFile(_response));
        });
    }

    protected processUpdateFile(response: Response): Promise<FileMetaDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto>(null as any);
    }

    /**
     * Legacy file upload using Fine Uploader request body. Prefer UploadCommunicationFileForm (multipart form).
     * @deprecated
     */
    uploadFile(communicationId: number, file: FineUploadFileDto): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/communications/{communicationId}/files";
        if (communicationId === undefined || communicationId === null)
            throw new globalThis.Error("The parameter 'communicationId' must be defined.");
        url_ = url_.replace("{communicationId}", encodeURIComponent("" + communicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(file);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadFile(_response));
        });
    }

    protected processUploadFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * JSON array of file metadata groups (no file bytes). Prefer GET …/file-groups; use GET …/files/{{fileId}} for bytes.
     * @deprecated
     */
    getFiles(communicationId: number): Promise<FileMetaDataDto[]> {
        let url_ = this.baseUrl + "/api/v1/communications/{communicationId}/files";
        if (communicationId === undefined || communicationId === null)
            throw new globalThis.Error("The parameter 'communicationId' must be defined.");
        url_ = url_.replace("{communicationId}", encodeURIComponent("" + communicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFiles(_response));
        });
    }

    protected processGetFiles(response: Response): Promise<FileMetaDataDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto[]>(null as any);
    }

    getFile(fileId: number, communicationId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/communications/{communicationId}/files/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        if (communicationId === undefined || communicationId === null)
            throw new globalThis.Error("The parameter 'communicationId' must be defined.");
        url_ = url_.replace("{communicationId}", encodeURIComponent("" + communicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFile(_response));
        });
    }

    protected processGetFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteFile(fileId: number, communicationId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/communications/{communicationId}/files/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        if (communicationId === undefined || communicationId === null)
            throw new globalThis.Error("The parameter 'communicationId' must be defined.");
        url_ = url_.replace("{communicationId}", encodeURIComponent("" + communicationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteFile(_response));
        });
    }

    protected processDeleteFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    checkFilesUnderFilesRoute(communicationId: number, fileIds: string | null | undefined): Promise<FileCheckDto[]> {
        let url_ = this.baseUrl + "/api/v1/communications/{communicationId}/files/check?";
        if (communicationId === undefined || communicationId === null)
            throw new globalThis.Error("The parameter 'communicationId' must be defined.");
        url_ = url_.replace("{communicationId}", encodeURIComponent("" + communicationId));
        if (fileIds !== undefined && fileIds !== null)
            url_ += "fileIds=" + encodeURIComponent("" + fileIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckFilesUnderFilesRoute(_response));
        });
    }

    protected processCheckFilesUnderFilesRoute(response: Response): Promise<FileCheckDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileCheckDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileCheckDto[]>(null as any);
    }

    /**
     * Upload a file to a communication via multipart form. Returns the created file metadata on success.
    Preferred over the legacy POST .../files endpoint (Fine Uploader only).
     * @param uploadFile (optional) 
     * @param description (optional) 
     * @param visibility (optional) 
     * @param fields (optional) 
     */
    uploadCommunicationFileForm(communicationId: number, uploadFile: FileParameter | undefined, description: string | null | undefined, visibility: VisibilityDto | null | undefined, fields: FileMetaDataFieldWriteRequest[] | null | undefined): Promise<FileMetaDataDto> {
        let url_ = this.baseUrl + "/api/v1/communications/{communicationId}/files/upload";
        if (communicationId === undefined || communicationId === null)
            throw new globalThis.Error("The parameter 'communicationId' must be defined.");
        url_ = url_.replace("{communicationId}", encodeURIComponent("" + communicationId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (uploadFile === null || uploadFile === undefined)
            throw new globalThis.Error("The parameter 'uploadFile' cannot be null.");
        else
            content_.append("UploadFile", uploadFile.data, uploadFile.fileName ? uploadFile.fileName : "UploadFile");
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (visibility !== null && visibility !== undefined)
            content_.append("Visibility", visibility.toString());
        if (fields !== null && fields !== undefined)
            fields.forEach(item_ => content_.append("Fields", item_.toString()));

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadCommunicationFileForm(_response));
        });
    }

    protected processUploadCommunicationFileForm(response: Response): Promise<FileMetaDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto>(null as any);
    }

    getImage(communicationId: number, fileId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/communications/{communicationId}/images/{fileId}";
        if (communicationId === undefined || communicationId === null)
            throw new globalThis.Error("The parameter 'communicationId' must be defined.");
        url_ = url_.replace("{communicationId}", encodeURIComponent("" + communicationId));
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetImage(_response));
        });
    }

    protected processGetImage(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    get(id: number): Promise<CommunicationDto> {
        let url_ = this.baseUrl + "/api/v1/communications/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<CommunicationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CommunicationDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommunicationDto>(null as any);
    }

    delete(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/communications/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    update(id: number, request: UpdateCommunicationRequest): Promise<CommunicationDto> {
        let url_ = this.baseUrl + "/api/v1/communications/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<CommunicationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CommunicationDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommunicationDto>(null as any);
    }

    getDropdownChoices(): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/communications/drop-down-choices";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDropdownChoices(_response));
        });
    }

    protected processGetDropdownChoices(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IAutoSubmitConfigAPIRepository {

    getConfigNames(): Promise<string[]>;

    createPOST(config: AutoSubmitConfig): Promise<FileResponse>;

    getConfigByName(name: string): Promise<IAutoSubmitConfig>;

    update(name: string, config: AutoSubmitConfig): Promise<FileResponse>;

    createDELETE(name: string): Promise<FileResponse>;

    getAllConfigs(): Promise<IAutoSubmitConfig[]>;

    createMany(configs: AutoSubmitConfig[]): Promise<FileResponse>;
}

export class AutoSubmitConfigAPIRepository extends AuthorizedApiBase implements IAutoSubmitConfigAPIRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getConfigNames(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/config/auto-submit";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetConfigNames(_response));
        });
    }

    protected processGetConfigNames(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    createPOST(config: AutoSubmitConfig): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/config/auto-submit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(config);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreatePOST(_response));
        });
    }

    protected processCreatePOST(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getConfigByName(name: string): Promise<IAutoSubmitConfig> {
        let url_ = this.baseUrl + "/api/v1/config/auto-submit/{name}";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetConfigByName(_response));
        });
    }

    protected processGetConfigByName(response: Response): Promise<IAutoSubmitConfig> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IAutoSubmitConfig;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IAutoSubmitConfig>(null as any);
    }

    update(name: string, config: AutoSubmitConfig): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/config/auto-submit/{name}";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(config);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createDELETE(name: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/config/auto-submit/{name}";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateDELETE(_response));
        });
    }

    protected processCreateDELETE(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getAllConfigs(): Promise<IAutoSubmitConfig[]> {
        let url_ = this.baseUrl + "/api/v1/config/auto-submit/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllConfigs(_response));
        });
    }

    protected processGetAllConfigs(response: Response): Promise<IAutoSubmitConfig[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IAutoSubmitConfig[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IAutoSubmitConfig[]>(null as any);
    }

    createMany(configs: AutoSubmitConfig[]): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/config/auto-submit/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(configs);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateMany(_response));
        });
    }

    protected processCreateMany(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface ICharacterizationConfigAPIRepository {

    getConfigNames(): Promise<string[]>;

    createPOST(config: CharacterizationUploadConfig): Promise<FileResponse>;

    getConfigByName(name: string): Promise<ICharacterizationUploadConfig>;

    update(name: string, config: CharacterizationUploadConfig): Promise<FileResponse>;

    createDELETE(name: string): Promise<FileResponse>;

    getAllConfigs(): Promise<ICharacterizationUploadConfig[]>;

    createMany(configs: CharacterizationUploadConfig[]): Promise<FileResponse>;
}

export class CharacterizationConfigAPIRepository extends AuthorizedApiBase implements ICharacterizationConfigAPIRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getConfigNames(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/config/characterization";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetConfigNames(_response));
        });
    }

    protected processGetConfigNames(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    createPOST(config: CharacterizationUploadConfig): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/config/characterization";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(config);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreatePOST(_response));
        });
    }

    protected processCreatePOST(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getConfigByName(name: string): Promise<ICharacterizationUploadConfig> {
        let url_ = this.baseUrl + "/api/v1/config/characterization/{name}";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetConfigByName(_response));
        });
    }

    protected processGetConfigByName(response: Response): Promise<ICharacterizationUploadConfig> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ICharacterizationUploadConfig;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ICharacterizationUploadConfig>(null as any);
    }

    update(name: string, config: CharacterizationUploadConfig): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/config/characterization/{name}";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(config);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createDELETE(name: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/config/characterization/{name}";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateDELETE(_response));
        });
    }

    protected processCreateDELETE(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getAllConfigs(): Promise<ICharacterizationUploadConfig[]> {
        let url_ = this.baseUrl + "/api/v1/config/characterization/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllConfigs(_response));
        });
    }

    protected processGetAllConfigs(response: Response): Promise<ICharacterizationUploadConfig[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ICharacterizationUploadConfig[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ICharacterizationUploadConfig[]>(null as any);
    }

    createMany(configs: CharacterizationUploadConfig[]): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/config/characterization/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(configs);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateMany(_response));
        });
    }

    protected processCreateMany(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IFileSharingConfigAPIRepository {

    getConfigNames(): Promise<string[]>;

    createPOST(config: FileSharingConfig): Promise<FileResponse>;

    getConfigByName(name: string): Promise<IFileSharingConfig>;

    update(name: string, config: FileSharingConfig): Promise<FileResponse>;

    createDELETE(name: string): Promise<FileResponse>;

    getAllConfigs(): Promise<IFileSharingConfig[]>;

    createMany(configs: FileSharingConfig[]): Promise<FileResponse>;
}

export class FileSharingConfigAPIRepository extends AuthorizedApiBase implements IFileSharingConfigAPIRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getConfigNames(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/config/file-sharing";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetConfigNames(_response));
        });
    }

    protected processGetConfigNames(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    createPOST(config: FileSharingConfig): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/config/file-sharing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(config);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreatePOST(_response));
        });
    }

    protected processCreatePOST(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getConfigByName(name: string): Promise<IFileSharingConfig> {
        let url_ = this.baseUrl + "/api/v1/config/file-sharing/{name}";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetConfigByName(_response));
        });
    }

    protected processGetConfigByName(response: Response): Promise<IFileSharingConfig> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IFileSharingConfig;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IFileSharingConfig>(null as any);
    }

    update(name: string, config: FileSharingConfig): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/config/file-sharing/{name}";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(config);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createDELETE(name: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/config/file-sharing/{name}";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateDELETE(_response));
        });
    }

    protected processCreateDELETE(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getAllConfigs(): Promise<IFileSharingConfig[]> {
        let url_ = this.baseUrl + "/api/v1/config/file-sharing/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllConfigs(_response));
        });
    }

    protected processGetAllConfigs(response: Response): Promise<IFileSharingConfig[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as IFileSharingConfig[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IFileSharingConfig[]>(null as any);
    }

    createMany(configs: FileSharingConfig[]): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/config/file-sharing/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(configs);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateMany(_response));
        });
    }

    protected processCreateMany(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IFileSourceAPIRepository {

    getAllFileSources(): Promise<string[]>;

    createPOST(config: FileSourceConfig): Promise<void>;

    get(name: string): Promise<FileSourceConfig>;

    update(name: string, reset: boolean | undefined, config: FileSourceConfig): Promise<void>;

    createDELETE(name: string): Promise<void>;

    getAllFileCharConfigs(): Promise<FileSourceConfig[]>;

    createMany(configs: FileSourceConfig[]): Promise<void>;
}

export class FileSourceAPIRepository extends AuthorizedApiBase implements IFileSourceAPIRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAllFileSources(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/config/filesource";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllFileSources(_response));
        });
    }

    protected processGetAllFileSources(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    createPOST(config: FileSourceConfig): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/config/filesource";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(config);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreatePOST(_response));
        });
    }

    protected processCreatePOST(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    get(name: string): Promise<FileSourceConfig> {
        let url_ = this.baseUrl + "/api/v1/config/filesource/{name}";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<FileSourceConfig> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileSourceConfig;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileSourceConfig>(null as any);
    }

    update(name: string, reset: boolean | undefined, config: FileSourceConfig): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/config/filesource/{name}?";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        if (reset === null)
            throw new globalThis.Error("The parameter 'reset' cannot be null.");
        else if (reset !== undefined)
            url_ += "reset=" + encodeURIComponent("" + reset) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(config);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    createDELETE(name: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/config/filesource/{name}";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateDELETE(_response));
        });
    }

    protected processCreateDELETE(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getAllFileCharConfigs(): Promise<FileSourceConfig[]> {
        let url_ = this.baseUrl + "/api/v1/config/filesource/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllFileCharConfigs(_response));
        });
    }

    protected processGetAllFileCharConfigs(response: Response): Promise<FileSourceConfig[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileSourceConfig[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileSourceConfig[]>(null as any);
    }

    createMany(configs: FileSourceConfig[]): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/config/filesource/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(configs);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateMany(_response));
        });
    }

    protected processCreateMany(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ISampleImportConfigAPIRepository {

    getConfigNames(): Promise<string[]>;

    createPOST(config: SampleImportConfig): Promise<FileResponse>;

    getConfigByName(name: string): Promise<ISampleImportConfig>;

    update(name: string, config: SampleImportConfig): Promise<FileResponse>;

    createDELETE(name: string): Promise<FileResponse>;

    getAllConfigs(): Promise<ISampleImportConfig[]>;

    createMany(configs: SampleImportConfig[]): Promise<FileResponse>;
}

export class SampleImportConfigAPIRepository extends AuthorizedApiBase implements ISampleImportConfigAPIRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getConfigNames(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/config/sample-import";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetConfigNames(_response));
        });
    }

    protected processGetConfigNames(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    createPOST(config: SampleImportConfig): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/config/sample-import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(config);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreatePOST(_response));
        });
    }

    protected processCreatePOST(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getConfigByName(name: string): Promise<ISampleImportConfig> {
        let url_ = this.baseUrl + "/api/v1/config/sample-import/{name}";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetConfigByName(_response));
        });
    }

    protected processGetConfigByName(response: Response): Promise<ISampleImportConfig> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ISampleImportConfig;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ISampleImportConfig>(null as any);
    }

    update(name: string, config: SampleImportConfig): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/config/sample-import/{name}";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(config);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createDELETE(name: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/config/sample-import/{name}";
        if (name === undefined || name === null)
            throw new globalThis.Error("The parameter 'name' must be defined.");
        url_ = url_.replace("{name}", encodeURIComponent("" + name));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateDELETE(_response));
        });
    }

    protected processCreateDELETE(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getAllConfigs(): Promise<ISampleImportConfig[]> {
        let url_ = this.baseUrl + "/api/v1/config/sample-import/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllConfigs(_response));
        });
    }

    protected processGetAllConfigs(response: Response): Promise<ISampleImportConfig[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ISampleImportConfig[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ISampleImportConfig[]>(null as any);
    }

    createMany(configs: SampleImportConfig[]): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/config/sample-import/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(configs);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateMany(_response));
        });
    }

    protected processCreateMany(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IDataPackageApiRepository {

    create(request: CreateDataPackageRequest): Promise<DataPackageDto>;

    generateShareId(id: number): Promise<string>;

    publish(id: number): Promise<DataPackageDto>;

    refreshActivityInSnapshot(id: number, activityId: number): Promise<void>;

    refreshSampleInSnapshot(id: number, sampleId: number): Promise<void>;

    resetPending(id: number): Promise<DataPackageDto>;

    restartSnapshot(id: number): Promise<void>;

    removeSampleActivities(id: number, activityId: number): Promise<void>;

    /**
     * Removes every stored format in a logical file group from a pending snapshot sample activity (same rules as per-file trim).
     */
    removeFileGroupFromSnapshot(id: number, activityId: number, fileGroupId: number): Promise<void>;

    removeFiles(id: number, activityId: number, fileId: number): Promise<void>;

    addSamples(id: number, sampleIdsOrLabels: string[]): Promise<string[]>;

    addSample(id: number, sampleIdOrLabel: string): Promise<void>;

    removeSample(id: number, sampleIdOrLabel: string): Promise<void>;

    addActivity(id: number, activityId: number): Promise<void>;

    removeTheoryActivities(id: number, activityId: number): Promise<void>;

    createSnapshot(id: number): Promise<void>;

    submit(id: number): Promise<DataPackageDto>;

    unpublish(id: number): Promise<DataPackageDto>;

    /**
     * Get a data package by numerical ID, DOI, or prepublish (secret) link. If the package is unpublished
    and was accessed by numerical ID (not DOI/prepublish) and the user is not a collaborator and has no
    AccessUnpublishedData, we return NotFound so the ID is not guessable; see DataPackageDirectAccessRequirement.
     */
    get(idOrDoi: string): Promise<DataPackageDto>;

    update(idOrDoi: string, request: UpdateDataPackageRequest): Promise<DataPackageDto>;

    deletePending(idOrDoi: string): Promise<void>;

    /**
     * Checks whether the given file ids exist and are accessible for the data package. Returns (fileId, exists) pairs.
     * @param idOrDoi Data package numeric ID, DOI, or prepublish id.
     * @param fileIds (optional) Comma-separated file ids to check.
     * @deprecated
     */
    checkFile(idOrDoi: string, fileIds: string | null | undefined): Promise<FileCheckDto[]>;

    setDoi(idOrDoi: string, updateRequest: DataPackageDoiUpdate): Promise<void>;

    /**
     * Updates file metadata for a logical file group. Same body as legacy PUT …/files.
     */
    updateFileGroup(idOrDoi: string, dto: FileMetaDataCreateOrUpdateRequest): Promise<FileMetaDataDto>;

    /**
     * Returns file metadata groups in a data package (filtered by access).
     */
    getFileGroups(idOrDoi: string): Promise<FileMetaDataDto[]>;

    /**
     * Deletes every stored format in a logical file group on a pending data package.
     */
    deleteFileGroup(idOrDoi: string, fileGroupId: number): Promise<void>;

    /**
     * Updates file metadata for a file group in a data package. Send id or basename to identify the group.
     * @param idOrDoi Data package numeric ID, DOI, or prepublish id.
     * @param dto Writable metadata; identify the file group by id or basename (see GET files response).
     * @deprecated
     */
    updateFile(idOrDoi: string, dto: FileMetaDataCreateOrUpdateRequest): Promise<FileMetaDataDto>;

    /**
     * Uploads a file to a data package (FineUploader format). Returns success/error result for the upload widget.
     * @param idOrDoi Data package numeric ID, DOI, or prepublish id.
     * @param file File payload via FineUploadBinder.
     * @deprecated
     */
    uploadFile(idOrDoi: string, file: FineUploadFileDto): Promise<FileResponse>;

    /**
     * Returns file metadata for all files in a data package (filtered by access).
     * @param idOrDoi Data package numeric ID, DOI, or prepublish id.
     * @deprecated
     */
    getFiles(idOrDoi: string): Promise<FileMetaDataDto[]>;

    /**
     * Raw file bytes (Content-Disposition: attachment), not a FileDto JSON body.
     * @param fileId File id.
     * @param idOrDoi Data package numeric ID, DOI, or prepublish id.
     */
    getFile(fileId: number, idOrDoi: string): Promise<FileResponse>;

    /**
     * Deletes a file from a data package.
     * @param fileId File id.
     * @param idOrDoi Data package numeric ID, DOI, or prepublish id.
     */
    deleteFile(fileId: number, idOrDoi: string): Promise<void>;

    /**
     * Checks physical file ids for the data package (same query as legacy check-file).
     * @param fileIds (optional) 
     */
    checkFilesUnderFilesRoute(idOrDoi: string, fileIds: string | null | undefined): Promise<FileCheckDto[]>;

    /**
     * Upload a file to a data package via multipart form. Returns the created file metadata on success.
    Only allowed while the data package is in Pending status — once submitted or published,
    the file set is locked to ensure the archived record is immutable.
    Preferred over the legacy POST .../files endpoint (Fine Uploader only).
     * @param uploadFile (optional) 
     * @param metadata (optional) 
     */
    uploadDataPackageFileForm(idOrDoi: string, uploadFile: FileParameter | undefined, metadata: string | null | undefined): Promise<FileMetaDataDto>;

    /**
     * Creates or returns a SharePoint folder share link for the data package.
    idOrDoi may be numeric ID, DOI, or prepublish id (lookup only).
    Authorization is package Read via LoadDataPackage
    (published, collaborator / AccessUnpublishedData, or secret used in this call).
     * @param idOrDoi Data package numeric ID, DOI, or prepublish id.
     */
    createFolderLink(idOrDoi: string): Promise<FolderShareLink>;

    /**
     * Returns an image file from a data package inline (e.g. for display in browser).
     * @param idOrDoi Data package numeric ID, DOI, or prepublish id.
     * @param fileId File id.
     */
    getImage(idOrDoi: string, fileId: number): Promise<FileResponse>;

    /**
     * Replaces/saves all notes for a data package. Returns the saved notes (filtered by auth).
     * @param idOrDoi Data package numeric ID, DOI, or prepublish id.
     * @param dtos Notes to save; existing by ID, new with ID 0 or omitted.
     */
    saveNotes(idOrDoi: string, dtos: NoteDto[]): Promise<NoteDto[]>;

    /**
     * Returns notes for a data package, filtered by the current user's access.
     * @param idOrDoi Data package numeric ID, DOI, or prepublish id.
     */
    getNotes(idOrDoi: string): Promise<NoteDto[]>;

    /**
     * Deletes a note from a data package. Caller must be allowed to delete the note (e.g. owner).
     * @param idOrDoi Data package numeric ID, DOI, or prepublish id.
     * @param noteId Note id.
     */
    deleteNote(idOrDoi: string, noteId: number): Promise<void>;

    getSamples(idOrDoi: string): Promise<SampleDto[]>;

    getSample(idOrDoi: string, sampleIdOrLabel: string): Promise<SampleDto>;

    getActivities(idOrDoi: string): Promise<TheoryActivityDto[]>;

    getAccessRights(idOrDoi: string): Promise<PrivilegeDto[]>;

    /**
     * Returns whether a data package exists and the current user can read it. Does not throw 403/404: resolves,
    then authorizes. Two checks: (1) Read – can they read this package at all (visibility, privilege).
    (2) DataPackageDirectAccessRequirement – same as Get: if they used numerical ID for an unpublished package
    and are not collaborator and have no AccessUnpublishedData, return exists: false. Use
    GET /publications/exists for publication DOIs/IDs.
     */
    exists(idOrDoi: string): Promise<ExistsResult>;

    search(sortColumn: string | null | undefined, sortOrder: string | null | undefined, start: number | undefined, length: number | undefined, draw: number | undefined, criteria: DataPackageSearchCriteria): Promise<PagingResultOfDataPackageDto>;
}

export class DataPackageApiRepository extends AuthorizedApiBase implements IDataPackageApiRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    create(request: CreateDataPackageRequest): Promise<DataPackageDto> {
        let url_ = this.baseUrl + "/api/v1/data-packages";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<DataPackageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataPackageDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataPackageDto>(null as any);
    }

    generateShareId(id: number): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{id}/generate-share-id";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGenerateShareId(_response));
        });
    }

    protected processGenerateShareId(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    publish(id: number): Promise<DataPackageDto> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{id}/publish";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPublish(_response));
        });
    }

    protected processPublish(response: Response): Promise<DataPackageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataPackageDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataPackageDto>(null as any);
    }

    refreshActivityInSnapshot(id: number, activityId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{id}/refresh-activity/{activityId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRefreshActivityInSnapshot(_response));
        });
    }

    protected processRefreshActivityInSnapshot(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    refreshSampleInSnapshot(id: number, sampleId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{id}/refresh-sample/{sampleId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (sampleId === undefined || sampleId === null)
            throw new globalThis.Error("The parameter 'sampleId' must be defined.");
        url_ = url_.replace("{sampleId}", encodeURIComponent("" + sampleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRefreshSampleInSnapshot(_response));
        });
    }

    protected processRefreshSampleInSnapshot(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    resetPending(id: number): Promise<DataPackageDto> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{id}/reset";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processResetPending(_response));
        });
    }

    protected processResetPending(response: Response): Promise<DataPackageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataPackageDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataPackageDto>(null as any);
    }

    restartSnapshot(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{id}/restart-snapshot";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRestartSnapshot(_response));
        });
    }

    protected processRestartSnapshot(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    removeSampleActivities(id: number, activityId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{id}/sample-activities/{activityId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveSampleActivities(_response));
        });
    }

    protected processRemoveSampleActivities(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Removes every stored format in a logical file group from a pending snapshot sample activity (same rules as per-file trim).
     */
    removeFileGroupFromSnapshot(id: number, activityId: number, fileGroupId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{id}/sample-activities/{activityId}/file-groups/{fileGroupId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (fileGroupId === undefined || fileGroupId === null)
            throw new globalThis.Error("The parameter 'fileGroupId' must be defined.");
        url_ = url_.replace("{fileGroupId}", encodeURIComponent("" + fileGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveFileGroupFromSnapshot(_response));
        });
    }

    protected processRemoveFileGroupFromSnapshot(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    removeFiles(id: number, activityId: number, fileId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{id}/sample-activities/{activityId}/files/{fileId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveFiles(_response));
        });
    }

    protected processRemoveFiles(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    addSamples(id: number, sampleIdsOrLabels: string[]): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{id}/samples";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(sampleIdsOrLabels);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddSamples(_response));
        });
    }

    protected processAddSamples(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    addSample(id: number, sampleIdOrLabel: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{id}/samples/{sampleIdOrLabel}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (sampleIdOrLabel === undefined || sampleIdOrLabel === null)
            throw new globalThis.Error("The parameter 'sampleIdOrLabel' must be defined.");
        url_ = url_.replace("{sampleIdOrLabel}", encodeURIComponent("" + sampleIdOrLabel));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddSample(_response));
        });
    }

    protected processAddSample(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    removeSample(id: number, sampleIdOrLabel: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{id}/samples/{sampleIdOrLabel}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (sampleIdOrLabel === undefined || sampleIdOrLabel === null)
            throw new globalThis.Error("The parameter 'sampleIdOrLabel' must be defined.");
        url_ = url_.replace("{sampleIdOrLabel}", encodeURIComponent("" + sampleIdOrLabel));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveSample(_response));
        });
    }

    protected processRemoveSample(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    addActivity(id: number, activityId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{id}/simulations/{activityId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddActivity(_response));
        });
    }

    protected processAddActivity(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    removeTheoryActivities(id: number, activityId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{id}/simulations/{activityId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveTheoryActivities(_response));
        });
    }

    protected processRemoveTheoryActivities(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    createSnapshot(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{id}/snapshot";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateSnapshot(_response));
        });
    }

    protected processCreateSnapshot(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    submit(id: number): Promise<DataPackageDto> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{id}/submit";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSubmit(_response));
        });
    }

    protected processSubmit(response: Response): Promise<DataPackageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataPackageDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataPackageDto>(null as any);
    }

    unpublish(id: number): Promise<DataPackageDto> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{id}/unpublish";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUnpublish(_response));
        });
    }

    protected processUnpublish(response: Response): Promise<DataPackageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataPackageDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataPackageDto>(null as any);
    }

    /**
     * Get a data package by numerical ID, DOI, or prepublish (secret) link. If the package is unpublished
    and was accessed by numerical ID (not DOI/prepublish) and the user is not a collaborator and has no
    AccessUnpublishedData, we return NotFound so the ID is not guessable; see DataPackageDirectAccessRequirement.
     */
    get(idOrDoi: string): Promise<DataPackageDto> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{idOrDoi}";
        if (idOrDoi === undefined || idOrDoi === null)
            throw new globalThis.Error("The parameter 'idOrDoi' must be defined.");
        url_ = url_.replace("{idOrDoi}", encodeURIComponent("" + idOrDoi));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<DataPackageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataPackageDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataPackageDto>(null as any);
    }

    update(idOrDoi: string, request: UpdateDataPackageRequest): Promise<DataPackageDto> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{idOrDoi}";
        if (idOrDoi === undefined || idOrDoi === null)
            throw new globalThis.Error("The parameter 'idOrDoi' must be defined.");
        url_ = url_.replace("{idOrDoi}", encodeURIComponent("" + idOrDoi));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<DataPackageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataPackageDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataPackageDto>(null as any);
    }

    deletePending(idOrDoi: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{idOrDoi}";
        if (idOrDoi === undefined || idOrDoi === null)
            throw new globalThis.Error("The parameter 'idOrDoi' must be defined.");
        url_ = url_.replace("{idOrDoi}", encodeURIComponent("" + idOrDoi));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeletePending(_response));
        });
    }

    protected processDeletePending(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Checks whether the given file ids exist and are accessible for the data package. Returns (fileId, exists) pairs.
     * @param idOrDoi Data package numeric ID, DOI, or prepublish id.
     * @param fileIds (optional) Comma-separated file ids to check.
     * @deprecated
     */
    checkFile(idOrDoi: string, fileIds: string | null | undefined): Promise<FileCheckDto[]> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{idOrDoi}/check-file?";
        if (idOrDoi === undefined || idOrDoi === null)
            throw new globalThis.Error("The parameter 'idOrDoi' must be defined.");
        url_ = url_.replace("{idOrDoi}", encodeURIComponent("" + idOrDoi));
        if (fileIds !== undefined && fileIds !== null)
            url_ += "fileIds=" + encodeURIComponent("" + fileIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckFile(_response));
        });
    }

    protected processCheckFile(response: Response): Promise<FileCheckDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileCheckDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileCheckDto[]>(null as any);
    }

    setDoi(idOrDoi: string, updateRequest: DataPackageDoiUpdate): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{idOrDoi}/doi";
        if (idOrDoi === undefined || idOrDoi === null)
            throw new globalThis.Error("The parameter 'idOrDoi' must be defined.");
        url_ = url_.replace("{idOrDoi}", encodeURIComponent("" + idOrDoi));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateRequest);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetDoi(_response));
        });
    }

    protected processSetDoi(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Updates file metadata for a logical file group. Same body as legacy PUT …/files.
     */
    updateFileGroup(idOrDoi: string, dto: FileMetaDataCreateOrUpdateRequest): Promise<FileMetaDataDto> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{idOrDoi}/file-groups";
        if (idOrDoi === undefined || idOrDoi === null)
            throw new globalThis.Error("The parameter 'idOrDoi' must be defined.");
        url_ = url_.replace("{idOrDoi}", encodeURIComponent("" + idOrDoi));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateFileGroup(_response));
        });
    }

    protected processUpdateFileGroup(response: Response): Promise<FileMetaDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto>(null as any);
    }

    /**
     * Returns file metadata groups in a data package (filtered by access).
     */
    getFileGroups(idOrDoi: string): Promise<FileMetaDataDto[]> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{idOrDoi}/file-groups";
        if (idOrDoi === undefined || idOrDoi === null)
            throw new globalThis.Error("The parameter 'idOrDoi' must be defined.");
        url_ = url_.replace("{idOrDoi}", encodeURIComponent("" + idOrDoi));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFileGroups(_response));
        });
    }

    protected processGetFileGroups(response: Response): Promise<FileMetaDataDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto[]>(null as any);
    }

    /**
     * Deletes every stored format in a logical file group on a pending data package.
     */
    deleteFileGroup(idOrDoi: string, fileGroupId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{idOrDoi}/file-groups/{fileGroupId}";
        if (idOrDoi === undefined || idOrDoi === null)
            throw new globalThis.Error("The parameter 'idOrDoi' must be defined.");
        url_ = url_.replace("{idOrDoi}", encodeURIComponent("" + idOrDoi));
        if (fileGroupId === undefined || fileGroupId === null)
            throw new globalThis.Error("The parameter 'fileGroupId' must be defined.");
        url_ = url_.replace("{fileGroupId}", encodeURIComponent("" + fileGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteFileGroup(_response));
        });
    }

    protected processDeleteFileGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Updates file metadata for a file group in a data package. Send id or basename to identify the group.
     * @param idOrDoi Data package numeric ID, DOI, or prepublish id.
     * @param dto Writable metadata; identify the file group by id or basename (see GET files response).
     * @deprecated
     */
    updateFile(idOrDoi: string, dto: FileMetaDataCreateOrUpdateRequest): Promise<FileMetaDataDto> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{idOrDoi}/files";
        if (idOrDoi === undefined || idOrDoi === null)
            throw new globalThis.Error("The parameter 'idOrDoi' must be defined.");
        url_ = url_.replace("{idOrDoi}", encodeURIComponent("" + idOrDoi));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateFile(_response));
        });
    }

    protected processUpdateFile(response: Response): Promise<FileMetaDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto>(null as any);
    }

    /**
     * Uploads a file to a data package (FineUploader format). Returns success/error result for the upload widget.
     * @param idOrDoi Data package numeric ID, DOI, or prepublish id.
     * @param file File payload via FineUploadBinder.
     * @deprecated
     */
    uploadFile(idOrDoi: string, file: FineUploadFileDto): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{idOrDoi}/files";
        if (idOrDoi === undefined || idOrDoi === null)
            throw new globalThis.Error("The parameter 'idOrDoi' must be defined.");
        url_ = url_.replace("{idOrDoi}", encodeURIComponent("" + idOrDoi));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(file);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadFile(_response));
        });
    }

    protected processUploadFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Returns file metadata for all files in a data package (filtered by access).
     * @param idOrDoi Data package numeric ID, DOI, or prepublish id.
     * @deprecated
     */
    getFiles(idOrDoi: string): Promise<FileMetaDataDto[]> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{idOrDoi}/files";
        if (idOrDoi === undefined || idOrDoi === null)
            throw new globalThis.Error("The parameter 'idOrDoi' must be defined.");
        url_ = url_.replace("{idOrDoi}", encodeURIComponent("" + idOrDoi));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFiles(_response));
        });
    }

    protected processGetFiles(response: Response): Promise<FileMetaDataDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto[]>(null as any);
    }

    /**
     * Raw file bytes (Content-Disposition: attachment), not a FileDto JSON body.
     * @param fileId File id.
     * @param idOrDoi Data package numeric ID, DOI, or prepublish id.
     */
    getFile(fileId: number, idOrDoi: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{idOrDoi}/files/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        if (idOrDoi === undefined || idOrDoi === null)
            throw new globalThis.Error("The parameter 'idOrDoi' must be defined.");
        url_ = url_.replace("{idOrDoi}", encodeURIComponent("" + idOrDoi));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFile(_response));
        });
    }

    protected processGetFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Deletes a file from a data package.
     * @param fileId File id.
     * @param idOrDoi Data package numeric ID, DOI, or prepublish id.
     */
    deleteFile(fileId: number, idOrDoi: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{idOrDoi}/files/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        if (idOrDoi === undefined || idOrDoi === null)
            throw new globalThis.Error("The parameter 'idOrDoi' must be defined.");
        url_ = url_.replace("{idOrDoi}", encodeURIComponent("" + idOrDoi));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteFile(_response));
        });
    }

    protected processDeleteFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Checks physical file ids for the data package (same query as legacy check-file).
     * @param fileIds (optional) 
     */
    checkFilesUnderFilesRoute(idOrDoi: string, fileIds: string | null | undefined): Promise<FileCheckDto[]> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{idOrDoi}/files/check?";
        if (idOrDoi === undefined || idOrDoi === null)
            throw new globalThis.Error("The parameter 'idOrDoi' must be defined.");
        url_ = url_.replace("{idOrDoi}", encodeURIComponent("" + idOrDoi));
        if (fileIds !== undefined && fileIds !== null)
            url_ += "fileIds=" + encodeURIComponent("" + fileIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckFilesUnderFilesRoute(_response));
        });
    }

    protected processCheckFilesUnderFilesRoute(response: Response): Promise<FileCheckDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileCheckDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileCheckDto[]>(null as any);
    }

    /**
     * Upload a file to a data package via multipart form. Returns the created file metadata on success.
    Only allowed while the data package is in Pending status — once submitted or published,
    the file set is locked to ensure the archived record is immutable.
    Preferred over the legacy POST .../files endpoint (Fine Uploader only).
     * @param uploadFile (optional) 
     * @param metadata (optional) 
     */
    uploadDataPackageFileForm(idOrDoi: string, uploadFile: FileParameter | undefined, metadata: string | null | undefined): Promise<FileMetaDataDto> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{idOrDoi}/files/upload";
        if (idOrDoi === undefined || idOrDoi === null)
            throw new globalThis.Error("The parameter 'idOrDoi' must be defined.");
        url_ = url_.replace("{idOrDoi}", encodeURIComponent("" + idOrDoi));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (uploadFile === null || uploadFile === undefined)
            throw new globalThis.Error("The parameter 'uploadFile' cannot be null.");
        else
            content_.append("UploadFile", uploadFile.data, uploadFile.fileName ? uploadFile.fileName : "UploadFile");
        if (metadata !== null && metadata !== undefined)
            content_.append("Metadata", metadata.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadDataPackageFileForm(_response));
        });
    }

    protected processUploadDataPackageFileForm(response: Response): Promise<FileMetaDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto>(null as any);
    }

    /**
     * Creates or returns a SharePoint folder share link for the data package.
    idOrDoi may be numeric ID, DOI, or prepublish id (lookup only).
    Authorization is package Read via LoadDataPackage
    (published, collaborator / AccessUnpublishedData, or secret used in this call).
     * @param idOrDoi Data package numeric ID, DOI, or prepublish id.
     */
    createFolderLink(idOrDoi: string): Promise<FolderShareLink> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{idOrDoi}/getLink";
        if (idOrDoi === undefined || idOrDoi === null)
            throw new globalThis.Error("The parameter 'idOrDoi' must be defined.");
        url_ = url_.replace("{idOrDoi}", encodeURIComponent("" + idOrDoi));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateFolderLink(_response));
        });
    }

    protected processCreateFolderLink(response: Response): Promise<FolderShareLink> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FolderShareLink;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FolderShareLink>(null as any);
    }

    /**
     * Returns an image file from a data package inline (e.g. for display in browser).
     * @param idOrDoi Data package numeric ID, DOI, or prepublish id.
     * @param fileId File id.
     */
    getImage(idOrDoi: string, fileId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{idOrDoi}/images/{fileId}";
        if (idOrDoi === undefined || idOrDoi === null)
            throw new globalThis.Error("The parameter 'idOrDoi' must be defined.");
        url_ = url_.replace("{idOrDoi}", encodeURIComponent("" + idOrDoi));
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetImage(_response));
        });
    }

    protected processGetImage(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Replaces/saves all notes for a data package. Returns the saved notes (filtered by auth).
     * @param idOrDoi Data package numeric ID, DOI, or prepublish id.
     * @param dtos Notes to save; existing by ID, new with ID 0 or omitted.
     */
    saveNotes(idOrDoi: string, dtos: NoteDto[]): Promise<NoteDto[]> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{idOrDoi}/notes";
        if (idOrDoi === undefined || idOrDoi === null)
            throw new globalThis.Error("The parameter 'idOrDoi' must be defined.");
        url_ = url_.replace("{idOrDoi}", encodeURIComponent("" + idOrDoi));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dtos);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveNotes(_response));
        });
    }

    protected processSaveNotes(response: Response): Promise<NoteDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NoteDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoteDto[]>(null as any);
    }

    /**
     * Returns notes for a data package, filtered by the current user's access.
     * @param idOrDoi Data package numeric ID, DOI, or prepublish id.
     */
    getNotes(idOrDoi: string): Promise<NoteDto[]> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{idOrDoi}/notes";
        if (idOrDoi === undefined || idOrDoi === null)
            throw new globalThis.Error("The parameter 'idOrDoi' must be defined.");
        url_ = url_.replace("{idOrDoi}", encodeURIComponent("" + idOrDoi));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetNotes(_response));
        });
    }

    protected processGetNotes(response: Response): Promise<NoteDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NoteDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoteDto[]>(null as any);
    }

    /**
     * Deletes a note from a data package. Caller must be allowed to delete the note (e.g. owner).
     * @param idOrDoi Data package numeric ID, DOI, or prepublish id.
     * @param noteId Note id.
     */
    deleteNote(idOrDoi: string, noteId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{idOrDoi}/notes/{noteId}";
        if (idOrDoi === undefined || idOrDoi === null)
            throw new globalThis.Error("The parameter 'idOrDoi' must be defined.");
        url_ = url_.replace("{idOrDoi}", encodeURIComponent("" + idOrDoi));
        if (noteId === undefined || noteId === null)
            throw new globalThis.Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteNote(_response));
        });
    }

    protected processDeleteNote(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getSamples(idOrDoi: string): Promise<SampleDto[]> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{idOrDoi}/samples";
        if (idOrDoi === undefined || idOrDoi === null)
            throw new globalThis.Error("The parameter 'idOrDoi' must be defined.");
        url_ = url_.replace("{idOrDoi}", encodeURIComponent("" + idOrDoi));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSamples(_response));
        });
    }

    protected processGetSamples(response: Response): Promise<SampleDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleDto[]>(null as any);
    }

    getSample(idOrDoi: string, sampleIdOrLabel: string): Promise<SampleDto> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{idOrDoi}/samples/{sampleIdOrLabel}";
        if (idOrDoi === undefined || idOrDoi === null)
            throw new globalThis.Error("The parameter 'idOrDoi' must be defined.");
        url_ = url_.replace("{idOrDoi}", encodeURIComponent("" + idOrDoi));
        if (sampleIdOrLabel === undefined || sampleIdOrLabel === null)
            throw new globalThis.Error("The parameter 'sampleIdOrLabel' must be defined.");
        url_ = url_.replace("{sampleIdOrLabel}", encodeURIComponent("" + sampleIdOrLabel));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSample(_response));
        });
    }

    protected processGetSample(response: Response): Promise<SampleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleDto>(null as any);
    }

    getActivities(idOrDoi: string): Promise<TheoryActivityDto[]> {
        let url_ = this.baseUrl + "/api/v1/data-packages/{idOrDoi}/simulations";
        if (idOrDoi === undefined || idOrDoi === null)
            throw new globalThis.Error("The parameter 'idOrDoi' must be defined.");
        url_ = url_.replace("{idOrDoi}", encodeURIComponent("" + idOrDoi));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetActivities(_response));
        });
    }

    protected processGetActivities(response: Response): Promise<TheoryActivityDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TheoryActivityDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TheoryActivityDto[]>(null as any);
    }

    getAccessRights(idOrDoi: string): Promise<PrivilegeDto[]> {
        let url_ = this.baseUrl + "/api/v1/data-packages/access-rights/{idOrDoi}";
        if (idOrDoi === undefined || idOrDoi === null)
            throw new globalThis.Error("The parameter 'idOrDoi' must be defined.");
        url_ = url_.replace("{idOrDoi}", encodeURIComponent("" + idOrDoi));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAccessRights(_response));
        });
    }

    protected processGetAccessRights(response: Response): Promise<PrivilegeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PrivilegeDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrivilegeDto[]>(null as any);
    }

    /**
     * Returns whether a data package exists and the current user can read it. Does not throw 403/404: resolves,
    then authorizes. Two checks: (1) Read – can they read this package at all (visibility, privilege).
    (2) DataPackageDirectAccessRequirement – same as Get: if they used numerical ID for an unpublished package
    and are not collaborator and have no AccessUnpublishedData, return exists: false. Use
    GET /publications/exists for publication DOIs/IDs.
     */
    exists(idOrDoi: string): Promise<ExistsResult> {
        let url_ = this.baseUrl + "/api/v1/data-packages/exists/{idOrDoi}";
        if (idOrDoi === undefined || idOrDoi === null)
            throw new globalThis.Error("The parameter 'idOrDoi' must be defined.");
        url_ = url_.replace("{idOrDoi}", encodeURIComponent("" + idOrDoi));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExists(_response));
        });
    }

    protected processExists(response: Response): Promise<ExistsResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExistsResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExistsResult>(null as any);
    }

    search(sortColumn: string | null | undefined, sortOrder: string | null | undefined, start: number | undefined, length: number | undefined, draw: number | undefined, criteria: DataPackageSearchCriteria): Promise<PagingResultOfDataPackageDto> {
        let url_ = this.baseUrl + "/api/v1/data-packages/search?";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (length === null)
            throw new globalThis.Error("The parameter 'length' cannot be null.");
        else if (length !== undefined)
            url_ += "length=" + encodeURIComponent("" + length) + "&";
        if (draw === null)
            throw new globalThis.Error("The parameter 'draw' cannot be null.");
        else if (draw !== undefined)
            url_ += "draw=" + encodeURIComponent("" + draw) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(criteria);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearch(_response));
        });
    }

    protected processSearch(response: Response): Promise<PagingResultOfDataPackageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingResultOfDataPackageDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingResultOfDataPackageDto>(null as any);
    }
}

export interface ISelectListApiRepository {

    /**
     * Returns key-value lists for dropdowns. Query 'lists': comma-separated list names (e.g. ProjectType, Status); omit or empty for all.
     * @param lists (optional) 
     */
    get(lists: string | null | undefined): Promise<{ [key: string]: { [key: string]: string; }[]; }>;
}

export class SelectListApiRepository extends AuthorizedApiBase implements ISelectListApiRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Returns key-value lists for dropdowns. Query 'lists': comma-separated list names (e.g. ProjectType, Status); omit or empty for all.
     * @param lists (optional) 
     */
    get(lists: string | null | undefined): Promise<{ [key: string]: { [key: string]: string; }[]; }> {
        let url_ = this.baseUrl + "/api/v1/dropdowns?";
        if (lists !== undefined && lists !== null)
            url_ += "lists=" + encodeURIComponent("" + lists) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<{ [key: string]: { [key: string]: string; }[]; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as { [key: string]: { [key: string]: string; }[]; };
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: { [key: string]: string; }[]; }>(null as any);
    }
}

export interface IImportRecordApiRepository {

    retryEntry(ids: number[]): Promise<void>;

    list(sortColumn: string | null | undefined, sortOrder: string | null | undefined, start: number | undefined, length: number | undefined, draw: number | undefined, criteria: ImportFilterDto): Promise<PagingResultOfImportTaskDto>;

    deleteEntry(id: number): Promise<void>;

    download(id: number): Promise<FileResponse>;

    getJobStatus(source: string): Promise<string>;

    getStatistics(source: string): Promise<ImportStat[]>;

    restartAll(criteria: ImportFilterDto): Promise<void>;

    getSources(): Promise<string[]>;
}

export class ImportRecordApiRepository extends AuthorizedApiBase implements IImportRecordApiRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    retryEntry(ids: number[]): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/import-records";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRetryEntry(_response));
        });
    }

    protected processRetryEntry(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    list(sortColumn: string | null | undefined, sortOrder: string | null | undefined, start: number | undefined, length: number | undefined, draw: number | undefined, criteria: ImportFilterDto): Promise<PagingResultOfImportTaskDto> {
        let url_ = this.baseUrl + "/api/v1/import-records?";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (length === null)
            throw new globalThis.Error("The parameter 'length' cannot be null.");
        else if (length !== undefined)
            url_ += "length=" + encodeURIComponent("" + length) + "&";
        if (draw === null)
            throw new globalThis.Error("The parameter 'draw' cannot be null.");
        else if (draw !== undefined)
            url_ += "draw=" + encodeURIComponent("" + draw) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(criteria);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<PagingResultOfImportTaskDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingResultOfImportTaskDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingResultOfImportTaskDto>(null as any);
    }

    deleteEntry(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/import-records/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteEntry(_response));
        });
    }

    protected processDeleteEntry(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    download(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/import-records/{id}/file";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownload(_response));
        });
    }

    protected processDownload(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getJobStatus(source: string): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/import-records/{source}/job-status";
        if (source === undefined || source === null)
            throw new globalThis.Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetJobStatus(_response));
        });
    }

    protected processGetJobStatus(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getStatistics(source: string): Promise<ImportStat[]> {
        let url_ = this.baseUrl + "/api/v1/import-records/{source}/statistics";
        if (source === undefined || source === null)
            throw new globalThis.Error("The parameter 'source' must be defined.");
        url_ = url_.replace("{source}", encodeURIComponent("" + source));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStatistics(_response));
        });
    }

    protected processGetStatistics(response: Response): Promise<ImportStat[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportStat[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportStat[]>(null as any);
    }

    restartAll(criteria: ImportFilterDto): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/import-records/restartAll";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(criteria);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRestartAll(_response));
        });
    }

    protected processRestartAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getSources(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/import-records/sources";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSources(_response));
        });
    }

    protected processGetSources(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export interface IMaterialApiRepository {

    /**
     * Get all materials.
     * @param referencedBy (optional) Only include materials used by a specific object types. Accepted values are All (Default), Publication, Project, or Sample
     * @param includeUsage (optional) If true, include usage of materials. Requires Privilege Material.Read
     * @return List of materials
     */
    list(referencedBy: string | null | undefined, includeUsage: boolean | undefined): Promise<MaterialDto[]>;

    /**
     * Create a new Material, and generate a HTML label with subscripts from the name if label has not been set yet.
     * @param material The new material.
     * @return The material, with generated label and ID
     */
    create(material: MaterialDto): Promise<MaterialDto>;

    /**
     * Update an existing Material, and regenerate a HTML label with subscripts from the name if label has not been set yet.
     * @param id The id of the material to change. Must be the same as set in the material object.
     * @param material The new material.
     * @return The material, with generated label and ID
     */
    update(id: number, material: MaterialDto): Promise<MaterialDto>;

    /**
     * Delete a Material.
     * @param id The id of the material to change. Must be the same as set in the material object.
     */
    delete(id: number): Promise<void>;

    /**
     * Get a material by numeric Id or name (aka chemical formula).
     * @param idOrName Numerical ID or chemical formula (e.g. MoSe2)
     * @return The material
     */
    get(idOrName: string): Promise<MaterialDto>;

    /**
     * Get a material by name (aka chemical formula).
     * @param name (optional) Name, mostly the chemical formula (e.g. MoSe2)
     * @return The material
     */
    getByName(name: string | null | undefined): Promise<MaterialDto>;
}

export class MaterialApiRepository extends AuthorizedApiBase implements IMaterialApiRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get all materials.
     * @param referencedBy (optional) Only include materials used by a specific object types. Accepted values are All (Default), Publication, Project, or Sample
     * @param includeUsage (optional) If true, include usage of materials. Requires Privilege Material.Read
     * @return List of materials
     */
    list(referencedBy: string | null | undefined, includeUsage: boolean | undefined): Promise<MaterialDto[]> {
        let url_ = this.baseUrl + "/api/v1/materials?";
        if (referencedBy !== undefined && referencedBy !== null)
            url_ += "referencedBy=" + encodeURIComponent("" + referencedBy) + "&";
        if (includeUsage === null)
            throw new globalThis.Error("The parameter 'includeUsage' cannot be null.");
        else if (includeUsage !== undefined)
            url_ += "includeUsage=" + encodeURIComponent("" + includeUsage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<MaterialDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaterialDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("If both parameters are used at the same time, or if referencedBy is not one of the excepted values", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If includeUsage is requested, but the required privilege has not been granted", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MaterialDto[]>(null as any);
    }

    /**
     * Create a new Material, and generate a HTML label with subscripts from the name if label has not been set yet.
     * @param material The new material.
     * @return The material, with generated label and ID
     */
    create(material: MaterialDto): Promise<MaterialDto> {
        let url_ = this.baseUrl + "/api/v1/materials";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(material);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<MaterialDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaterialDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If privilege to create materials has not been granted", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("If there is already a material with the same name", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MaterialDto>(null as any);
    }

    /**
     * Update an existing Material, and regenerate a HTML label with subscripts from the name if label has not been set yet.
     * @param id The id of the material to change. Must be the same as set in the material object.
     * @param material The new material.
     * @return The material, with generated label and ID
     */
    update(id: number, material: MaterialDto): Promise<MaterialDto> {
        let url_ = this.baseUrl + "/api/v1/materials/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(material);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<MaterialDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaterialDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If privilege to create materials has not been granted", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("If no such material exists", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MaterialDto>(null as any);
    }

    /**
     * Delete a Material.
     * @param id The id of the material to change. Must be the same as set in the material object.
     */
    delete(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/materials/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("If privilege to create materials has not been granted", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("If no such material exists", status, _responseText, _headers, result404);
            });
        } else if (status === 412) {
            return response.text().then((_responseText) => {
            let result412: any = null;
            result412 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("If that material is used by samples/projects/publications", status, _responseText, _headers, result412);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Get a material by numeric Id or name (aka chemical formula).
     * @param idOrName Numerical ID or chemical formula (e.g. MoSe2)
     * @return The material
     */
    get(idOrName: string): Promise<MaterialDto> {
        let url_ = this.baseUrl + "/api/v1/materials/{idOrName}";
        if (idOrName === undefined || idOrName === null)
            throw new globalThis.Error("The parameter 'idOrName' must be defined.");
        url_ = url_.replace("{idOrName}", encodeURIComponent("" + idOrName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<MaterialDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaterialDto;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("If no such material exists", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MaterialDto>(null as any);
    }

    /**
     * Get a material by name (aka chemical formula).
     * @param name (optional) Name, mostly the chemical formula (e.g. MoSe2)
     * @return The material
     */
    getByName(name: string | null | undefined): Promise<MaterialDto> {
        let url_ = this.baseUrl + "/api/v1/materials/by-name?";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetByName(_response));
        });
    }

    protected processGetByName(response: Response): Promise<MaterialDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MaterialDto;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("If no such material exists", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MaterialDto>(null as any);
    }
}

export interface IMetaDataConfigApiRepository {

    get(charInstrument: string | null | undefined, synInstrument: string | null | undefined): Promise<FileMetaDataConfigDto>;

    update(data: FileMetaDataConfigDto): Promise<void>;

    create(data: FileMetaDataConfigDto): Promise<void>;

    delete(instrument: string): Promise<void>;

    test(filename: string | null | undefined, data: FileMetaDataConfigDto): Promise<FileResponse>;
}

export class MetaDataConfigApiRepository extends AuthorizedApiBase implements IMetaDataConfigApiRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    get(charInstrument: string | null | undefined, synInstrument: string | null | undefined): Promise<FileMetaDataConfigDto> {
        let url_ = this.baseUrl + "/api/v1/meta-data-config?";
        if (charInstrument !== undefined && charInstrument !== null)
            url_ += "charInstrument=" + encodeURIComponent("" + charInstrument) + "&";
        if (synInstrument !== undefined && synInstrument !== null)
            url_ += "synInstrument=" + encodeURIComponent("" + synInstrument) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<FileMetaDataConfigDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataConfigDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataConfigDto>(null as any);
    }

    update(data: FileMetaDataConfigDto): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/meta-data-config";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    create(data: FileMetaDataConfigDto): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/meta-data-config";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    delete(instrument: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/meta-data-config/{instrument}";
        if (instrument === undefined || instrument === null)
            throw new globalThis.Error("The parameter 'instrument' must be defined.");
        url_ = url_.replace("{instrument}", encodeURIComponent("" + instrument));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 501) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    test(filename: string | null | undefined, data: FileMetaDataConfigDto): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/meta-data-config/test?";
        if (filename !== undefined && filename !== null)
            url_ += "filename=" + encodeURIComponent("" + filename) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTest(_response));
        });
    }

    protected processTest(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IProjectActivityApiRepository {

    create(activity: CreateProjectActivityRequest): Promise<ProjectActivityDto>;

    /**
     * Checks whether the given file ids exist and are accessible for the activity. Returns a list of (fileId, exists) pairs.
     * @param activityId Activity id.
     * @param fileIds (optional) Comma-separated file ids to check.
     * @deprecated
     */
    checkFile(activityId: number, fileIds: string | null | undefined): Promise<FileCheckDto[]>;

    /**
     * Updates file metadata for a logical file group. Same body as legacy PUT …/files.
     */
    updateFileGroup(activityId: number, dto: FileMetaDataCreateOrUpdateRequest): Promise<FileMetaDataDto>;

    /**
     * Returns file metadata groups (logical attachments) for the activity.
     */
    getFileGroups(activityId: number): Promise<FileMetaDataDto[]>;

    /**
     * Deletes every stored format in a logical file group (same semantics as removing each physical file in turn).
     */
    deleteFileGroup(activityId: number, fileGroupId: number): Promise<void>;

    /**
     * Uploads a file to an activity (FineUploader format). Returns success/error result for the upload widget.
     * @param activityId Activity id.
     * @param file File payload (base64 or blob) and name, via FineUploadBinder.
     * @deprecated
     */
    uploadFile(activityId: number, file: FineUploadFileDto): Promise<FileResponse>;

    /**
     * Updates file metadata for a file group on an activity. Send id or basename to identify the group.
     * @param activityId Activity id.
     * @param dto Writable metadata; identify the file group by id or basename (see GET files response).
     * @deprecated
     */
    updateFile(activityId: number, dto: FileMetaDataCreateOrUpdateRequest): Promise<FileMetaDataDto>;

    /**
     * Returns file metadata for all files attached to an activity (filtered by access).
     * @param activityId Activity id.
     * @deprecated
     */
    getFiles(activityId: number): Promise<FileMetaDataDto[]>;

    /**
     * Raw file bytes (Content-Disposition: attachment), not a FileDto JSON body.
     * @param fileId File id.
     * @param activityId Activity id.
     */
    getFile(fileId: number, activityId: number): Promise<FileResponse>;

    /**
     * Deletes a file attached to an activity.
     * @param fileId File id.
     * @param activityId Activity id.
     */
    deleteFile(fileId: number, activityId: number): Promise<void>;

    /**
     * Checks whether the given physical file ids exist and are accessible for the activity.
     * @param fileIds (optional) 
     */
    checkFilesUnderFilesRoute(activityId: number, fileIds: string | null | undefined): Promise<FileCheckDto[]>;

    /**
     * Upload a file to an activity via multipart form. Returns the created file metadata on success.
    Default intent is attachment-only (no recipe parsing for sample processing activities).
    Preferred over the legacy POST .../files endpoint (Fine Uploader only).
     * @param activityId Activity id.
     * @param uploadFile (optional) 
     * @param description (optional) 
     * @param visibility (optional) 
     * @param fields (optional) 
     */
    uploadActivityFileForm(activityId: number, uploadFile: FileParameter | undefined, description: string | null | undefined, visibility: VisibilityDto | null | undefined, fields: FileMetaDataFieldWriteRequest[] | null | undefined): Promise<FileMetaDataDto>;

    /**
     * Returns an image file inline (e.g. for display in browser).
     * @param fileId File id.
     * @param activityId Activity id.
     */
    getImage(fileId: number, activityId: number): Promise<FileResponse>;

    /**
     * Replaces/saves all notes for an activity. Returns the saved notes (filtered by auth).
     * @param activityId Activity id.
     * @param dtos Notes to save; existing notes are updated by ID, new notes have ID 0 or omitted.
     */
    saveNotes(activityId: number, dtos: NoteDto[]): Promise<NoteDto[]>;

    /**
     * Returns notes for an activity, filtered by the current user's access.
     * @param activityId Activity id.
     */
    getNotes(activityId: number): Promise<NoteDto[]>;

    /**
     * Deletes a note from an activity. Caller must be allowed to delete the note (e.g. owner).
     * @param activityId Activity id.
     * @param noteId Note id.
     */
    deleteNote(activityId: number, noteId: number): Promise<void>;

    update(id: number, activity: UpdateProjectActivityRequest): Promise<ProjectActivityDto>;

    get(id: number): Promise<ProjectActivityDto>;

    deletePending(id: number, userHasConfirmed: boolean | undefined): Promise<void>;

    resetPending(id: number): Promise<ProjectActivityDto>;

    submit(id: number, userHasConfirmed: boolean | undefined): Promise<ProjectActivityDto>;
}

export class ProjectActivityApiRepository extends AuthorizedApiBase implements IProjectActivityApiRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    create(activity: CreateProjectActivityRequest): Promise<ProjectActivityDto> {
        let url_ = this.baseUrl + "/api/v1/project-activities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(activity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<ProjectActivityDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectActivityDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectActivityDto>(null as any);
    }

    /**
     * Checks whether the given file ids exist and are accessible for the activity. Returns a list of (fileId, exists) pairs.
     * @param activityId Activity id.
     * @param fileIds (optional) Comma-separated file ids to check.
     * @deprecated
     */
    checkFile(activityId: number, fileIds: string | null | undefined): Promise<FileCheckDto[]> {
        let url_ = this.baseUrl + "/api/v1/project-activities/{activityId}/check-file?";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (fileIds !== undefined && fileIds !== null)
            url_ += "fileIds=" + encodeURIComponent("" + fileIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckFile(_response));
        });
    }

    protected processCheckFile(response: Response): Promise<FileCheckDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileCheckDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileCheckDto[]>(null as any);
    }

    /**
     * Updates file metadata for a logical file group. Same body as legacy PUT …/files.
     */
    updateFileGroup(activityId: number, dto: FileMetaDataCreateOrUpdateRequest): Promise<FileMetaDataDto> {
        let url_ = this.baseUrl + "/api/v1/project-activities/{activityId}/file-groups";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateFileGroup(_response));
        });
    }

    protected processUpdateFileGroup(response: Response): Promise<FileMetaDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto>(null as any);
    }

    /**
     * Returns file metadata groups (logical attachments) for the activity.
     */
    getFileGroups(activityId: number): Promise<FileMetaDataDto[]> {
        let url_ = this.baseUrl + "/api/v1/project-activities/{activityId}/file-groups";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFileGroups(_response));
        });
    }

    protected processGetFileGroups(response: Response): Promise<FileMetaDataDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto[]>(null as any);
    }

    /**
     * Deletes every stored format in a logical file group (same semantics as removing each physical file in turn).
     */
    deleteFileGroup(activityId: number, fileGroupId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/project-activities/{activityId}/file-groups/{fileGroupId}";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (fileGroupId === undefined || fileGroupId === null)
            throw new globalThis.Error("The parameter 'fileGroupId' must be defined.");
        url_ = url_.replace("{fileGroupId}", encodeURIComponent("" + fileGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteFileGroup(_response));
        });
    }

    protected processDeleteFileGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Uploads a file to an activity (FineUploader format). Returns success/error result for the upload widget.
     * @param activityId Activity id.
     * @param file File payload (base64 or blob) and name, via FineUploadBinder.
     * @deprecated
     */
    uploadFile(activityId: number, file: FineUploadFileDto): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/project-activities/{activityId}/files";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(file);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadFile(_response));
        });
    }

    protected processUploadFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Updates file metadata for a file group on an activity. Send id or basename to identify the group.
     * @param activityId Activity id.
     * @param dto Writable metadata; identify the file group by id or basename (see GET files response).
     * @deprecated
     */
    updateFile(activityId: number, dto: FileMetaDataCreateOrUpdateRequest): Promise<FileMetaDataDto> {
        let url_ = this.baseUrl + "/api/v1/project-activities/{activityId}/files";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateFile(_response));
        });
    }

    protected processUpdateFile(response: Response): Promise<FileMetaDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto>(null as any);
    }

    /**
     * Returns file metadata for all files attached to an activity (filtered by access).
     * @param activityId Activity id.
     * @deprecated
     */
    getFiles(activityId: number): Promise<FileMetaDataDto[]> {
        let url_ = this.baseUrl + "/api/v1/project-activities/{activityId}/files";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFiles(_response));
        });
    }

    protected processGetFiles(response: Response): Promise<FileMetaDataDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto[]>(null as any);
    }

    /**
     * Raw file bytes (Content-Disposition: attachment), not a FileDto JSON body.
     * @param fileId File id.
     * @param activityId Activity id.
     */
    getFile(fileId: number, activityId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/project-activities/{activityId}/files/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFile(_response));
        });
    }

    protected processGetFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Deletes a file attached to an activity.
     * @param fileId File id.
     * @param activityId Activity id.
     */
    deleteFile(fileId: number, activityId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/project-activities/{activityId}/files/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteFile(_response));
        });
    }

    protected processDeleteFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Checks whether the given physical file ids exist and are accessible for the activity.
     * @param fileIds (optional) 
     */
    checkFilesUnderFilesRoute(activityId: number, fileIds: string | null | undefined): Promise<FileCheckDto[]> {
        let url_ = this.baseUrl + "/api/v1/project-activities/{activityId}/files/check?";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (fileIds !== undefined && fileIds !== null)
            url_ += "fileIds=" + encodeURIComponent("" + fileIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckFilesUnderFilesRoute(_response));
        });
    }

    protected processCheckFilesUnderFilesRoute(response: Response): Promise<FileCheckDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileCheckDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileCheckDto[]>(null as any);
    }

    /**
     * Upload a file to an activity via multipart form. Returns the created file metadata on success.
    Default intent is attachment-only (no recipe parsing for sample processing activities).
    Preferred over the legacy POST .../files endpoint (Fine Uploader only).
     * @param activityId Activity id.
     * @param uploadFile (optional) 
     * @param description (optional) 
     * @param visibility (optional) 
     * @param fields (optional) 
     */
    uploadActivityFileForm(activityId: number, uploadFile: FileParameter | undefined, description: string | null | undefined, visibility: VisibilityDto | null | undefined, fields: FileMetaDataFieldWriteRequest[] | null | undefined): Promise<FileMetaDataDto> {
        let url_ = this.baseUrl + "/api/v1/project-activities/{activityId}/files/upload";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (uploadFile === null || uploadFile === undefined)
            throw new globalThis.Error("The parameter 'uploadFile' cannot be null.");
        else
            content_.append("UploadFile", uploadFile.data, uploadFile.fileName ? uploadFile.fileName : "UploadFile");
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (visibility !== null && visibility !== undefined)
            content_.append("Visibility", visibility.toString());
        if (fields !== null && fields !== undefined)
            fields.forEach(item_ => content_.append("Fields", item_.toString()));

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadActivityFileForm(_response));
        });
    }

    protected processUploadActivityFileForm(response: Response): Promise<FileMetaDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto>(null as any);
    }

    /**
     * Returns an image file inline (e.g. for display in browser).
     * @param fileId File id.
     * @param activityId Activity id.
     */
    getImage(fileId: number, activityId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/project-activities/{activityId}/images/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetImage(_response));
        });
    }

    protected processGetImage(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Replaces/saves all notes for an activity. Returns the saved notes (filtered by auth).
     * @param activityId Activity id.
     * @param dtos Notes to save; existing notes are updated by ID, new notes have ID 0 or omitted.
     */
    saveNotes(activityId: number, dtos: NoteDto[]): Promise<NoteDto[]> {
        let url_ = this.baseUrl + "/api/v1/project-activities/{activityId}/notes";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dtos);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveNotes(_response));
        });
    }

    protected processSaveNotes(response: Response): Promise<NoteDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NoteDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoteDto[]>(null as any);
    }

    /**
     * Returns notes for an activity, filtered by the current user's access.
     * @param activityId Activity id.
     */
    getNotes(activityId: number): Promise<NoteDto[]> {
        let url_ = this.baseUrl + "/api/v1/project-activities/{activityId}/notes";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetNotes(_response));
        });
    }

    protected processGetNotes(response: Response): Promise<NoteDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NoteDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoteDto[]>(null as any);
    }

    /**
     * Deletes a note from an activity. Caller must be allowed to delete the note (e.g. owner).
     * @param activityId Activity id.
     * @param noteId Note id.
     */
    deleteNote(activityId: number, noteId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/project-activities/{activityId}/notes/{noteId}";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (noteId === undefined || noteId === null)
            throw new globalThis.Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteNote(_response));
        });
    }

    protected processDeleteNote(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    update(id: number, activity: UpdateProjectActivityRequest): Promise<ProjectActivityDto> {
        let url_ = this.baseUrl + "/api/v1/project-activities/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(activity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<ProjectActivityDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectActivityDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectActivityDto>(null as any);
    }

    get(id: number): Promise<ProjectActivityDto> {
        let url_ = this.baseUrl + "/api/v1/project-activities/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<ProjectActivityDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectActivityDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectActivityDto>(null as any);
    }

    deletePending(id: number, userHasConfirmed: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/project-activities/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userHasConfirmed === null)
            throw new globalThis.Error("The parameter 'userHasConfirmed' cannot be null.");
        else if (userHasConfirmed !== undefined)
            url_ += "userHasConfirmed=" + encodeURIComponent("" + userHasConfirmed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeletePending(_response));
        });
    }

    protected processDeletePending(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result424);
            });
        } else if (status === 428) {
            return response.text().then((_responseText) => {
            let result428: any = null;
            result428 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result428);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    resetPending(id: number): Promise<ProjectActivityDto> {
        let url_ = this.baseUrl + "/api/v1/project-activities/{id}/reset";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processResetPending(_response));
        });
    }

    protected processResetPending(response: Response): Promise<ProjectActivityDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectActivityDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectActivityDto>(null as any);
    }

    submit(id: number, userHasConfirmed: boolean | undefined): Promise<ProjectActivityDto> {
        let url_ = this.baseUrl + "/api/v1/project-activities/{id}/submit?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userHasConfirmed === null)
            throw new globalThis.Error("The parameter 'userHasConfirmed' cannot be null.");
        else if (userHasConfirmed !== undefined)
            url_ += "userHasConfirmed=" + encodeURIComponent("" + userHasConfirmed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSubmit(_response));
        });
    }

    protected processSubmit(response: Response): Promise<ProjectActivityDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectActivityDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectActivityDto>(null as any);
    }
}

export interface IProjectApiRepository {

    /**
     * Get all projects the user has access to.
     * @return 200 with list of projects (possibly empty).
     */
    getAll(): Promise<ProjectDto[]>;

    create(project: CreateOrUpdateProjectRequestDto): Promise<ProjectDto>;

    delete(id: number): Promise<ProjectDto>;

    update(id: number, project: CreateOrUpdateProjectRequestDto): Promise<ProjectDto>;

    getContactDetails(id: number, contactName: string | null | undefined): Promise<ShippingContact>;

    getContacts(id: number): Promise<string>;

    /**
     * @deprecated
     */
    submit(id: number): Promise<ProjectDto>;

    /**
     * Get a project.
     * @param idOrLabel Project label or numeric project ID
     */
    get(idOrLabel: string): Promise<ProjectDto>;

    getCollaborators(idOrLabel: string): Promise<ProjectCollaboratorDto[]>;

    removeCollaborator(idOrLabel: string, collaboratorId: string, roleId: number): Promise<void>;

    addCollaborator(idOrLabel: string, collaboratorId: string, roleId: number): Promise<void>;

    getCommunications(idOrLabel: string): Promise<CommunicationDto[]>;

    getCommunication(idOrLabel: string, commId: number): Promise<CommunicationDto>;

    getDataPackages(idOrLabel: string, simulationsOnly: boolean | undefined): Promise<DataPackageDto[]>;

    createDataPackage(idOrLabel: string, request: CreateDataPackageRequest): Promise<number>;

    getDataPackage(idOrLabel: string, dataPackageId: string): Promise<DataPackageDto>;

    createFolderLink(idOrLabel: string): Promise<FolderShareLink>;

    /**
     * Load project notes. Returns notes filtered by the current user's access.
     * @param idOrLabel Numeric project ID or project label
     */
    getNotes(idOrLabel: string): Promise<NoteDto[]>;

    /**
     * Save project notes. Replaces/saves all notes; returns saved notes filtered by access.
     * @param idOrLabel Numeric project ID or project label
     * @param dtos Notes to save; existing by ID, new with ID 0 or omitted.
     */
    saveNotes(idOrLabel: string, dtos: NoteDto[]): Promise<NoteDto[]>;

    /**
     * Deletes a note from a project. Caller must be allowed to delete the note (e.g. owner).
     * @param idOrLabel Numeric project ID or project label
     * @param noteId Note id.
     */
    deleteNote(idOrLabel: string, noteId: number): Promise<void>;

    getProjectActivities(idOrLabel: string): Promise<ProjectActivityDto[]>;

    getProjectActivity(idOrLabel: string, activityId: number): Promise<ProjectActivityDto>;

    getSampleRequests(idOrLabel: string): Promise<SampleRequestDto[]>;

    getSampleRequest(idOrLabel: string, id: number): Promise<SampleRequestDto>;

    getSamples(idOrLabel: string, recent: boolean | null | undefined, nbOfDays: number | null | undefined, includeShipped: boolean | null | undefined): Promise<SampleDto[]>;

    getSample(idOrLabel: string, sampleId: string): Promise<SampleDto>;

    getShippings(idOrLabel: string): Promise<ShippingDto[]>;

    getShipping(idOrLabel: string, shipId: number): Promise<ShippingDto>;

    getTheoryActivities(idOrLabel: string): Promise<TheoryActivityDto[]>;

    getTheoryActivity(idOrLabel: string, activityId: number): Promise<TheoryActivityDto>;

    updateSampleRequests(projectId: number, dtos: SampleRequestDto[]): Promise<SampleRequestDto>;

    getBudgets(projectId: number): Promise<string>;

    getAccessRights(idOrLabel: string): Promise<PrivilegeDto[]>;

    /**
     * Checks whether a project exists (or more precisely, if the user has access to it) for the provided id or label.
     */
    exists(idOrLabel: string): Promise<ExistsResult>;

    /**
     * Get a free project label by adding a unique number.
     * @param label A label prefix
     * @param alwaysAddNumber (optional) if true, alway add a number, if false, only if there is already a project with that label
     */
    getFreeLabel(label: string, alwaysAddNumber: boolean | null | undefined): Promise<string>;

    /**
     * Check if a user has a certain privilege for at least one project.
    The UI uses this to decide which button/menu entries to display.
            
    If users are not authorized to perform a task on any project,
    there is no need to let them open a dialog which then has an empty lists of projects to chose from.
     * @param privileges (optional) Comma-separated privilege names (e.g. "Sample", "UserProject,InternalProject").
     * @param op (optional) The operation to check (e.g. Read, Write, Delete).
     * @return True if the user has the privilege for at least one project (or globally).
     */
    hasAnyProjectWithPrivilege(privileges: string | null | undefined, op: OperationEnum | null | undefined): Promise<boolean>;

    isValidLabel(label: string): Promise<CheckResultDto>;

    listProjectTypes(includeUsage: boolean | undefined): Promise<ProjectTypeDto[]>;

    createProjectType(projectType: ProjectTypeDto): Promise<ProjectTypeDto>;

    updateProjectType(id: number, projectType: ProjectTypeDto): Promise<ProjectTypeDto>;

    deleteProjectType(id: number): Promise<void>;

    search(sortColumn: string | null | undefined, sortOrder: string | null | undefined, start: number | undefined, length: number | undefined, draw: number | undefined, criteria: ProjectSearchCriteriaDto): Promise<PagingResultOfProjectDto>;
}

export class ProjectApiRepository extends AuthorizedApiBase implements IProjectApiRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get all projects the user has access to.
     * @return 200 with list of projects (possibly empty).
     */
    getAll(): Promise<ProjectDto[]> {
        let url_ = this.baseUrl + "/api/v1/projects";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<ProjectDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectDto[]>(null as any);
    }

    create(project: CreateOrUpdateProjectRequestDto): Promise<ProjectDto> {
        let url_ = this.baseUrl + "/api/v1/projects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(project);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<ProjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectDto>(null as any);
    }

    delete(id: number): Promise<ProjectDto> {
        let url_ = this.baseUrl + "/api/v1/projects/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<ProjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectDto>(null as any);
    }

    update(id: number, project: CreateOrUpdateProjectRequestDto): Promise<ProjectDto> {
        let url_ = this.baseUrl + "/api/v1/projects/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(project);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<ProjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectDto>(null as any);
    }

    getContactDetails(id: number, contactName: string | null | undefined): Promise<ShippingContact> {
        let url_ = this.baseUrl + "/api/v1/projects/{id}/contact-details?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (contactName !== undefined && contactName !== null)
            url_ += "contactName=" + encodeURIComponent("" + contactName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetContactDetails(_response));
        });
    }

    protected processGetContactDetails(response: Response): Promise<ShippingContact> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ShippingContact;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShippingContact>(null as any);
    }

    getContacts(id: number): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/projects/{id}/shipping-contacts";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetContacts(_response));
        });
    }

    protected processGetContacts(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @deprecated
     */
    submit(id: number): Promise<ProjectDto> {
        let url_ = this.baseUrl + "/api/v1/projects/{id}/submit";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSubmit(_response));
        });
    }

    protected processSubmit(response: Response): Promise<ProjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectDto>(null as any);
    }

    /**
     * Get a project.
     * @param idOrLabel Project label or numeric project ID
     */
    get(idOrLabel: string): Promise<ProjectDto> {
        let url_ = this.baseUrl + "/api/v1/projects/{idOrLabel}";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<ProjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectDto>(null as any);
    }

    getCollaborators(idOrLabel: string): Promise<ProjectCollaboratorDto[]> {
        let url_ = this.baseUrl + "/api/v1/projects/{idOrLabel}/collaborators";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCollaborators(_response));
        });
    }

    protected processGetCollaborators(response: Response): Promise<ProjectCollaboratorDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectCollaboratorDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectCollaboratorDto[]>(null as any);
    }

    removeCollaborator(idOrLabel: string, collaboratorId: string, roleId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/projects/{idOrLabel}/collaborators/{collaboratorId}/{roleId}";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        if (collaboratorId === undefined || collaboratorId === null)
            throw new globalThis.Error("The parameter 'collaboratorId' must be defined.");
        url_ = url_.replace("{collaboratorId}", encodeURIComponent("" + collaboratorId));
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveCollaborator(_response));
        });
    }

    protected processRemoveCollaborator(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    addCollaborator(idOrLabel: string, collaboratorId: string, roleId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/projects/{idOrLabel}/collaborators/{collaboratorId}/{roleId}";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        if (collaboratorId === undefined || collaboratorId === null)
            throw new globalThis.Error("The parameter 'collaboratorId' must be defined.");
        url_ = url_.replace("{collaboratorId}", encodeURIComponent("" + collaboratorId));
        if (roleId === undefined || roleId === null)
            throw new globalThis.Error("The parameter 'roleId' must be defined.");
        url_ = url_.replace("{roleId}", encodeURIComponent("" + roleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddCollaborator(_response));
        });
    }

    protected processAddCollaborator(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getCommunications(idOrLabel: string): Promise<CommunicationDto[]> {
        let url_ = this.baseUrl + "/api/v1/projects/{idOrLabel}/communications";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCommunications(_response));
        });
    }

    protected processGetCommunications(response: Response): Promise<CommunicationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CommunicationDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommunicationDto[]>(null as any);
    }

    getCommunication(idOrLabel: string, commId: number): Promise<CommunicationDto> {
        let url_ = this.baseUrl + "/api/v1/projects/{idOrLabel}/communications/{commId}";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        if (commId === undefined || commId === null)
            throw new globalThis.Error("The parameter 'commId' must be defined.");
        url_ = url_.replace("{commId}", encodeURIComponent("" + commId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCommunication(_response));
        });
    }

    protected processGetCommunication(response: Response): Promise<CommunicationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CommunicationDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CommunicationDto>(null as any);
    }

    getDataPackages(idOrLabel: string, simulationsOnly: boolean | undefined): Promise<DataPackageDto[]> {
        let url_ = this.baseUrl + "/api/v1/projects/{idOrLabel}/data-packages?";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        if (simulationsOnly === null)
            throw new globalThis.Error("The parameter 'simulationsOnly' cannot be null.");
        else if (simulationsOnly !== undefined)
            url_ += "simulationsOnly=" + encodeURIComponent("" + simulationsOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDataPackages(_response));
        });
    }

    protected processGetDataPackages(response: Response): Promise<DataPackageDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataPackageDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataPackageDto[]>(null as any);
    }

    createDataPackage(idOrLabel: string, request: CreateDataPackageRequest): Promise<number> {
        let url_ = this.baseUrl + "/api/v1/projects/{idOrLabel}/data-packages";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateDataPackage(_response));
        });
    }

    protected processCreateDataPackage(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getDataPackage(idOrLabel: string, dataPackageId: string): Promise<DataPackageDto> {
        let url_ = this.baseUrl + "/api/v1/projects/{idOrLabel}/data-packages/{dataPackageId}";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        if (dataPackageId === undefined || dataPackageId === null)
            throw new globalThis.Error("The parameter 'dataPackageId' must be defined.");
        url_ = url_.replace("{dataPackageId}", encodeURIComponent("" + dataPackageId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDataPackage(_response));
        });
    }

    protected processGetDataPackage(response: Response): Promise<DataPackageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataPackageDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataPackageDto>(null as any);
    }

    createFolderLink(idOrLabel: string): Promise<FolderShareLink> {
        let url_ = this.baseUrl + "/api/v1/projects/{idOrLabel}/getLink";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateFolderLink(_response));
        });
    }

    protected processCreateFolderLink(response: Response): Promise<FolderShareLink> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FolderShareLink;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FolderShareLink>(null as any);
    }

    /**
     * Load project notes. Returns notes filtered by the current user's access.
     * @param idOrLabel Numeric project ID or project label
     */
    getNotes(idOrLabel: string): Promise<NoteDto[]> {
        let url_ = this.baseUrl + "/api/v1/projects/{idOrLabel}/notes";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetNotes(_response));
        });
    }

    protected processGetNotes(response: Response): Promise<NoteDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NoteDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoteDto[]>(null as any);
    }

    /**
     * Save project notes. Replaces/saves all notes; returns saved notes filtered by access.
     * @param idOrLabel Numeric project ID or project label
     * @param dtos Notes to save; existing by ID, new with ID 0 or omitted.
     */
    saveNotes(idOrLabel: string, dtos: NoteDto[]): Promise<NoteDto[]> {
        let url_ = this.baseUrl + "/api/v1/projects/{idOrLabel}/notes";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dtos);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveNotes(_response));
        });
    }

    protected processSaveNotes(response: Response): Promise<NoteDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NoteDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoteDto[]>(null as any);
    }

    /**
     * Deletes a note from a project. Caller must be allowed to delete the note (e.g. owner).
     * @param idOrLabel Numeric project ID or project label
     * @param noteId Note id.
     */
    deleteNote(idOrLabel: string, noteId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/projects/{idOrLabel}/notes/{noteId}";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        if (noteId === undefined || noteId === null)
            throw new globalThis.Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteNote(_response));
        });
    }

    protected processDeleteNote(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getProjectActivities(idOrLabel: string): Promise<ProjectActivityDto[]> {
        let url_ = this.baseUrl + "/api/v1/projects/{idOrLabel}/project-activities";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetProjectActivities(_response));
        });
    }

    protected processGetProjectActivities(response: Response): Promise<ProjectActivityDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectActivityDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectActivityDto[]>(null as any);
    }

    getProjectActivity(idOrLabel: string, activityId: number): Promise<ProjectActivityDto> {
        let url_ = this.baseUrl + "/api/v1/projects/{idOrLabel}/project-activities/{activityId}";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetProjectActivity(_response));
        });
    }

    protected processGetProjectActivity(response: Response): Promise<ProjectActivityDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectActivityDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectActivityDto>(null as any);
    }

    getSampleRequests(idOrLabel: string): Promise<SampleRequestDto[]> {
        let url_ = this.baseUrl + "/api/v1/projects/{idOrLabel}/sample-requests";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSampleRequests(_response));
        });
    }

    protected processGetSampleRequests(response: Response): Promise<SampleRequestDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleRequestDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleRequestDto[]>(null as any);
    }

    getSampleRequest(idOrLabel: string, id: number): Promise<SampleRequestDto> {
        let url_ = this.baseUrl + "/api/v1/projects/{idOrLabel}/sample-requests/{id}";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSampleRequest(_response));
        });
    }

    protected processGetSampleRequest(response: Response): Promise<SampleRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleRequestDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleRequestDto>(null as any);
    }

    getSamples(idOrLabel: string, recent: boolean | null | undefined, nbOfDays: number | null | undefined, includeShipped: boolean | null | undefined): Promise<SampleDto[]> {
        let url_ = this.baseUrl + "/api/v1/projects/{idOrLabel}/samples?";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        if (recent !== undefined && recent !== null)
            url_ += "recent=" + encodeURIComponent("" + recent) + "&";
        if (nbOfDays !== undefined && nbOfDays !== null)
            url_ += "nbOfDays=" + encodeURIComponent("" + nbOfDays) + "&";
        if (includeShipped !== undefined && includeShipped !== null)
            url_ += "includeShipped=" + encodeURIComponent("" + includeShipped) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSamples(_response));
        });
    }

    protected processGetSamples(response: Response): Promise<SampleDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleDto[]>(null as any);
    }

    getSample(idOrLabel: string, sampleId: string): Promise<SampleDto> {
        let url_ = this.baseUrl + "/api/v1/projects/{idOrLabel}/samples/{sampleId}";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        if (sampleId === undefined || sampleId === null)
            throw new globalThis.Error("The parameter 'sampleId' must be defined.");
        url_ = url_.replace("{sampleId}", encodeURIComponent("" + sampleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSample(_response));
        });
    }

    protected processGetSample(response: Response): Promise<SampleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleDto>(null as any);
    }

    getShippings(idOrLabel: string): Promise<ShippingDto[]> {
        let url_ = this.baseUrl + "/api/v1/projects/{idOrLabel}/shippings";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetShippings(_response));
        });
    }

    protected processGetShippings(response: Response): Promise<ShippingDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ShippingDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShippingDto[]>(null as any);
    }

    getShipping(idOrLabel: string, shipId: number): Promise<ShippingDto> {
        let url_ = this.baseUrl + "/api/v1/projects/{idOrLabel}/shippings/{shipId}";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        if (shipId === undefined || shipId === null)
            throw new globalThis.Error("The parameter 'shipId' must be defined.");
        url_ = url_.replace("{shipId}", encodeURIComponent("" + shipId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetShipping(_response));
        });
    }

    protected processGetShipping(response: Response): Promise<ShippingDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ShippingDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShippingDto>(null as any);
    }

    getTheoryActivities(idOrLabel: string): Promise<TheoryActivityDto[]> {
        let url_ = this.baseUrl + "/api/v1/projects/{idOrLabel}/theory-activities";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTheoryActivities(_response));
        });
    }

    protected processGetTheoryActivities(response: Response): Promise<TheoryActivityDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TheoryActivityDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TheoryActivityDto[]>(null as any);
    }

    getTheoryActivity(idOrLabel: string, activityId: number): Promise<TheoryActivityDto> {
        let url_ = this.baseUrl + "/api/v1/projects/{idOrLabel}/theory-activities/{activityId}";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTheoryActivity(_response));
        });
    }

    protected processGetTheoryActivity(response: Response): Promise<TheoryActivityDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TheoryActivityDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TheoryActivityDto>(null as any);
    }

    updateSampleRequests(projectId: number, dtos: SampleRequestDto[]): Promise<SampleRequestDto> {
        let url_ = this.baseUrl + "/api/v1/projects/{projectId}/sample-requests";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dtos);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateSampleRequests(_response));
        });
    }

    protected processUpdateSampleRequests(response: Response): Promise<SampleRequestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleRequestDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleRequestDto>(null as any);
    }

    getBudgets(projectId: number): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/projects/{projectId}/shipping-budgets";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBudgets(_response));
        });
    }

    protected processGetBudgets(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getAccessRights(idOrLabel: string): Promise<PrivilegeDto[]> {
        let url_ = this.baseUrl + "/api/v1/projects/access-rights/{idOrLabel}";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAccessRights(_response));
        });
    }

    protected processGetAccessRights(response: Response): Promise<PrivilegeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PrivilegeDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrivilegeDto[]>(null as any);
    }

    /**
     * Checks whether a project exists (or more precisely, if the user has access to it) for the provided id or label.
     */
    exists(idOrLabel: string): Promise<ExistsResult> {
        let url_ = this.baseUrl + "/api/v1/projects/exists/{idOrLabel}";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExists(_response));
        });
    }

    protected processExists(response: Response): Promise<ExistsResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExistsResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExistsResult>(null as any);
    }

    /**
     * Get a free project label by adding a unique number.
     * @param label A label prefix
     * @param alwaysAddNumber (optional) if true, alway add a number, if false, only if there is already a project with that label
     */
    getFreeLabel(label: string, alwaysAddNumber: boolean | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/projects/get-free-label/{label}?";
        if (label === undefined || label === null)
            throw new globalThis.Error("The parameter 'label' must be defined.");
        url_ = url_.replace("{label}", encodeURIComponent("" + label));
        if (alwaysAddNumber !== undefined && alwaysAddNumber !== null)
            url_ += "alwaysAddNumber=" + encodeURIComponent("" + alwaysAddNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFreeLabel(_response));
        });
    }

    protected processGetFreeLabel(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Check if a user has a certain privilege for at least one project.
    The UI uses this to decide which button/menu entries to display.
            
    If users are not authorized to perform a task on any project,
    there is no need to let them open a dialog which then has an empty lists of projects to chose from.
     * @param privileges (optional) Comma-separated privilege names (e.g. "Sample", "UserProject,InternalProject").
     * @param op (optional) The operation to check (e.g. Read, Write, Delete).
     * @return True if the user has the privilege for at least one project (or globally).
     */
    hasAnyProjectWithPrivilege(privileges: string | null | undefined, op: OperationEnum | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/projects/hasAnyProjectWithPrivilege?";
        if (privileges !== undefined && privileges !== null)
            url_ += "privileges=" + encodeURIComponent("" + privileges) + "&";
        if (op !== undefined && op !== null)
            url_ += "op=" + encodeURIComponent("" + op) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processHasAnyProjectWithPrivilege(_response));
        });
    }

    protected processHasAnyProjectWithPrivilege(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    isValidLabel(label: string): Promise<CheckResultDto> {
        let url_ = this.baseUrl + "/api/v1/projects/is-valid-label/{label}";
        if (label === undefined || label === null)
            throw new globalThis.Error("The parameter 'label' must be defined.");
        url_ = url_.replace("{label}", encodeURIComponent("" + label));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsValidLabel(_response));
        });
    }

    protected processIsValidLabel(response: Response): Promise<CheckResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CheckResultDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CheckResultDto>(null as any);
    }

    listProjectTypes(includeUsage: boolean | undefined): Promise<ProjectTypeDto[]> {
        let url_ = this.baseUrl + "/api/v1/projects/project-types?";
        if (includeUsage === null)
            throw new globalThis.Error("The parameter 'includeUsage' cannot be null.");
        else if (includeUsage !== undefined)
            url_ += "includeUsage=" + encodeURIComponent("" + includeUsage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processListProjectTypes(_response));
        });
    }

    protected processListProjectTypes(response: Response): Promise<ProjectTypeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectTypeDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectTypeDto[]>(null as any);
    }

    createProjectType(projectType: ProjectTypeDto): Promise<ProjectTypeDto> {
        let url_ = this.baseUrl + "/api/v1/projects/project-types";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(projectType);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateProjectType(_response));
        });
    }

    protected processCreateProjectType(response: Response): Promise<ProjectTypeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectTypeDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectTypeDto>(null as any);
    }

    updateProjectType(id: number, projectType: ProjectTypeDto): Promise<ProjectTypeDto> {
        let url_ = this.baseUrl + "/api/v1/projects/project-types/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(projectType);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateProjectType(_response));
        });
    }

    protected processUpdateProjectType(response: Response): Promise<ProjectTypeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectTypeDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectTypeDto>(null as any);
    }

    deleteProjectType(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/projects/project-types/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteProjectType(_response));
        });
    }

    protected processDeleteProjectType(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    search(sortColumn: string | null | undefined, sortOrder: string | null | undefined, start: number | undefined, length: number | undefined, draw: number | undefined, criteria: ProjectSearchCriteriaDto): Promise<PagingResultOfProjectDto> {
        let url_ = this.baseUrl + "/api/v1/projects/search?";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (length === null)
            throw new globalThis.Error("The parameter 'length' cannot be null.");
        else if (length !== undefined)
            url_ += "length=" + encodeURIComponent("" + length) + "&";
        if (draw === null)
            throw new globalThis.Error("The parameter 'draw' cannot be null.");
        else if (draw !== undefined)
            url_ += "draw=" + encodeURIComponent("" + draw) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(criteria);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearch(_response));
        });
    }

    protected processSearch(response: Response): Promise<PagingResultOfProjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingResultOfProjectDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingResultOfProjectDto>(null as any);
    }
}

export interface IPublicationApiRepository {

    list(): Promise<PublicationDto[]>;

    create(request: CreatePublicationRequest): Promise<PublicationDto>;

    update(idOrDoi: string, request: UpdatePublicationRequest): Promise<PublicationDto>;

    delete(idOrDoi: string): Promise<void>;

    /**
     * @param idOrDoi Publication numeric ID or DOI.
     */
    getDataPackagesByPath(idOrDoi: string): Promise<DataPackageDto[]>;

    createDataPackage(idOrDoi: string, request: CreateDataPackageRequest): Promise<number>;

    getByIdOrDoi(idOrDoi: string | null | undefined): Promise<PublicationDto>;

    getDataPackagesByIdOrDoi(idOrDoi: string | null | undefined): Promise<DataPackageDto[]>;

    /**
     * Returns whether a publication exists and the current user can read it. Always 200 with
    Exists true or false; does not throw 403/404.
     */
    exists(idOrDoi: string): Promise<ExistsResult>;

    getById(id: number): Promise<PublicationDto>;

    getJournals(): Promise<string[]>;

    getScienceDrivers(): Promise<ScienceDriverDto[]>;

    search(sortColumn: string | null | undefined, sortOrder: string | null | undefined, start: number | undefined, length: number | undefined, draw: number | undefined, criteria: PublicationSearchCriteriaDto): Promise<PagingResultOfDataPackageDto>;
}

export class PublicationApiRepository extends AuthorizedApiBase implements IPublicationApiRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    list(): Promise<PublicationDto[]> {
        let url_ = this.baseUrl + "/api/v1/publications";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<PublicationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PublicationDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PublicationDto[]>(null as any);
    }

    create(request: CreatePublicationRequest): Promise<PublicationDto> {
        let url_ = this.baseUrl + "/api/v1/publications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<PublicationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PublicationDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PublicationDto>(null as any);
    }

    update(idOrDoi: string, request: UpdatePublicationRequest): Promise<PublicationDto> {
        let url_ = this.baseUrl + "/api/v1/publications/{idOrDoi}";
        if (idOrDoi === undefined || idOrDoi === null)
            throw new globalThis.Error("The parameter 'idOrDoi' must be defined.");
        url_ = url_.replace("{idOrDoi}", encodeURIComponent("" + idOrDoi));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<PublicationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PublicationDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PublicationDto>(null as any);
    }

    delete(idOrDoi: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/publications/{idOrDoi}";
        if (idOrDoi === undefined || idOrDoi === null)
            throw new globalThis.Error("The parameter 'idOrDoi' must be defined.");
        url_ = url_.replace("{idOrDoi}", encodeURIComponent("" + idOrDoi));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param idOrDoi Publication numeric ID or DOI.
     */
    getDataPackagesByPath(idOrDoi: string): Promise<DataPackageDto[]> {
        let url_ = this.baseUrl + "/api/v1/publications/{idOrDoi}/data-packages";
        if (idOrDoi === undefined || idOrDoi === null)
            throw new globalThis.Error("The parameter 'idOrDoi' must be defined.");
        url_ = url_.replace("{idOrDoi}", encodeURIComponent("" + idOrDoi));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDataPackagesByPath(_response));
        });
    }

    protected processGetDataPackagesByPath(response: Response): Promise<DataPackageDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataPackageDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataPackageDto[]>(null as any);
    }

    createDataPackage(idOrDoi: string, request: CreateDataPackageRequest): Promise<number> {
        let url_ = this.baseUrl + "/api/v1/publications/{idOrDoi}/data-packages";
        if (idOrDoi === undefined || idOrDoi === null)
            throw new globalThis.Error("The parameter 'idOrDoi' must be defined.");
        url_ = url_.replace("{idOrDoi}", encodeURIComponent("" + idOrDoi));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateDataPackage(_response));
        });
    }

    protected processCreateDataPackage(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getByIdOrDoi(idOrDoi: string | null | undefined): Promise<PublicationDto> {
        let url_ = this.baseUrl + "/api/v1/publications/by-id-or-doi?";
        if (idOrDoi !== undefined && idOrDoi !== null)
            url_ += "idOrDoi=" + encodeURIComponent("" + idOrDoi) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetByIdOrDoi(_response));
        });
    }

    protected processGetByIdOrDoi(response: Response): Promise<PublicationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PublicationDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PublicationDto>(null as any);
    }

    getDataPackagesByIdOrDoi(idOrDoi: string | null | undefined): Promise<DataPackageDto[]> {
        let url_ = this.baseUrl + "/api/v1/publications/data-packages?";
        if (idOrDoi !== undefined && idOrDoi !== null)
            url_ += "idOrDoi=" + encodeURIComponent("" + idOrDoi) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDataPackagesByIdOrDoi(_response));
        });
    }

    protected processGetDataPackagesByIdOrDoi(response: Response): Promise<DataPackageDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataPackageDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataPackageDto[]>(null as any);
    }

    /**
     * Returns whether a publication exists and the current user can read it. Always 200 with
    Exists true or false; does not throw 403/404.
     */
    exists(idOrDoi: string): Promise<ExistsResult> {
        let url_ = this.baseUrl + "/api/v1/publications/exists/{idOrDoi}";
        if (idOrDoi === undefined || idOrDoi === null)
            throw new globalThis.Error("The parameter 'idOrDoi' must be defined.");
        url_ = url_.replace("{idOrDoi}", encodeURIComponent("" + idOrDoi));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExists(_response));
        });
    }

    protected processExists(response: Response): Promise<ExistsResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExistsResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExistsResult>(null as any);
    }

    getById(id: number): Promise<PublicationDto> {
        let url_ = this.baseUrl + "/api/v1/publications/id/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<PublicationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PublicationDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PublicationDto>(null as any);
    }

    getJournals(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/publications/journals";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetJournals(_response));
        });
    }

    protected processGetJournals(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getScienceDrivers(): Promise<ScienceDriverDto[]> {
        let url_ = this.baseUrl + "/api/v1/publications/science-drivers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetScienceDrivers(_response));
        });
    }

    protected processGetScienceDrivers(response: Response): Promise<ScienceDriverDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScienceDriverDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScienceDriverDto[]>(null as any);
    }

    search(sortColumn: string | null | undefined, sortOrder: string | null | undefined, start: number | undefined, length: number | undefined, draw: number | undefined, criteria: PublicationSearchCriteriaDto): Promise<PagingResultOfDataPackageDto> {
        let url_ = this.baseUrl + "/api/v1/publications/search?";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (length === null)
            throw new globalThis.Error("The parameter 'length' cannot be null.");
        else if (length !== undefined)
            url_ += "length=" + encodeURIComponent("" + length) + "&";
        if (draw === null)
            throw new globalThis.Error("The parameter 'draw' cannot be null.");
        else if (draw !== undefined)
            url_ += "draw=" + encodeURIComponent("" + draw) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(criteria);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearch(_response));
        });
    }

    protected processSearch(response: Response): Promise<PagingResultOfDataPackageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingResultOfDataPackageDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingResultOfDataPackageDto>(null as any);
    }
}

export interface IRecipeFavoriteApiRepository {

    /**
     * Lists recipe favorites for the current user, optionally filtered by technique, instrument, template, step.
     * @param techniqueId (optional) Optional filter by technique ID.
     * @param instrumentId (optional) Optional filter by instrument ID.
     * @param template (optional) Optional filter by template name.
     * @param step (optional) Optional filter by step (e.g. PREP, SYN).
     * @return 200 with list of favorites (no recipe content). Returns empty list if not authorized.
     */
    list(techniqueId: string | null | undefined, instrumentId: string | null | undefined, template: string | null | undefined, step: string | null | undefined): Promise<RecipeFavoriteDto[]>;

    /**
     * Creates a new recipe favorite for the current user.
     * @param favorite Favorite data (template, step, technique, instrument, optional content).
     * @return 200 with saved favorite.
     */
    create(favorite: RecipeFavoriteDto): Promise<RecipeFavoriteDto>;

    /**
     * Gets a single recipe favorite by ID for the current user.
     * @param id Favorite ID.
     * @return 200 with favorite (including recipe content), or 404 if not found.
     */
    get(id: number): Promise<RecipeFavoriteDto>;

    /**
     * Updates an existing recipe favorite. Validates that route ID matches body ID.
     * @param id Favorite ID (route).
     * @param favorite Favorite data; ID in body must match route.
     * @return 204 on success, or 400 if ID mismatch, 404 if not found.
     */
    update(id: number, favorite: RecipeFavoriteDto): Promise<void>;

    /**
     * Deletes a recipe favorite for the current user.
     * @param id Favorite ID.
     * @return 204 on success.
     */
    delete(id: number): Promise<void>;
}

export class RecipeFavoriteApiRepository extends AuthorizedApiBase implements IRecipeFavoriteApiRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Lists recipe favorites for the current user, optionally filtered by technique, instrument, template, step.
     * @param techniqueId (optional) Optional filter by technique ID.
     * @param instrumentId (optional) Optional filter by instrument ID.
     * @param template (optional) Optional filter by template name.
     * @param step (optional) Optional filter by step (e.g. PREP, SYN).
     * @return 200 with list of favorites (no recipe content). Returns empty list if not authorized.
     */
    list(techniqueId: string | null | undefined, instrumentId: string | null | undefined, template: string | null | undefined, step: string | null | undefined): Promise<RecipeFavoriteDto[]> {
        let url_ = this.baseUrl + "/api/v1/recipe-favorites?";
        if (techniqueId !== undefined && techniqueId !== null)
            url_ += "techniqueId=" + encodeURIComponent("" + techniqueId) + "&";
        if (instrumentId !== undefined && instrumentId !== null)
            url_ += "instrumentId=" + encodeURIComponent("" + instrumentId) + "&";
        if (template !== undefined && template !== null)
            url_ += "template=" + encodeURIComponent("" + template) + "&";
        if (step !== undefined && step !== null)
            url_ += "step=" + encodeURIComponent("" + step) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<RecipeFavoriteDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RecipeFavoriteDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecipeFavoriteDto[]>(null as any);
    }

    /**
     * Creates a new recipe favorite for the current user.
     * @param favorite Favorite data (template, step, technique, instrument, optional content).
     * @return 200 with saved favorite.
     */
    create(favorite: RecipeFavoriteDto): Promise<RecipeFavoriteDto> {
        let url_ = this.baseUrl + "/api/v1/recipe-favorites";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(favorite);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<RecipeFavoriteDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RecipeFavoriteDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecipeFavoriteDto>(null as any);
    }

    /**
     * Gets a single recipe favorite by ID for the current user.
     * @param id Favorite ID.
     * @return 200 with favorite (including recipe content), or 404 if not found.
     */
    get(id: number): Promise<RecipeFavoriteDto> {
        let url_ = this.baseUrl + "/api/v1/recipe-favorites/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<RecipeFavoriteDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RecipeFavoriteDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecipeFavoriteDto>(null as any);
    }

    /**
     * Updates an existing recipe favorite. Validates that route ID matches body ID.
     * @param id Favorite ID (route).
     * @param favorite Favorite data; ID in body must match route.
     * @return 204 on success, or 400 if ID mismatch, 404 if not found.
     */
    update(id: number, favorite: RecipeFavoriteDto): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/recipe-favorites/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(favorite);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Deletes a recipe favorite for the current user.
     * @param id Favorite ID.
     * @return 204 on success.
     */
    delete(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/recipe-favorites/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IRecipeTemplateApiRepository {

    /**
     * Gets a single recipe template by step, technique or instrument, and optional name.
     * @param step (optional) Activity step (required): PREP, SYN, or POST.
     * @param technique (optional) Technique ID. Required if instrument is not provided; at least one of technique or instrument must be set.
     * @param instrument (optional) Instrument ID. Required if technique is not provided; at least one of technique or instrument must be set.
     * @param name (optional) Optional template name to resolve a single template.
     * @return 200 with template (including formula constants if used), or 404 when no matching template exists, or 400 when required parameters are missing or step is invalid.
     */
    get(step: RecipeTemplateStep | null | undefined, technique: string | null | undefined, instrument: string | null | undefined, name: string | null | undefined): Promise<RecipeTemplateDto>;

    /**
     * Lists available recipe template names for the given step and technique and/or instrument.
     * @param step (optional) Activity step (required): PREP, SYN, or POST.
     * @param technique (optional) Technique ID. Required if instrument is not provided; at least one of technique or instrument must be set.
     * @param instrument (optional) Instrument ID. Required if technique is not provided; at least one of technique or instrument must be set.
     * @return 200 with list of template names and UsesInstrument flag, or 400 when required parameters are missing or step is invalid.
     */
    availableTemplates(step: RecipeTemplateStep | null | undefined, technique: string | null | undefined, instrument: string | null | undefined): Promise<AvailableTemplate[]>;
}

export class RecipeTemplateApiRepository extends AuthorizedApiBase implements IRecipeTemplateApiRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets a single recipe template by step, technique or instrument, and optional name.
     * @param step (optional) Activity step (required): PREP, SYN, or POST.
     * @param technique (optional) Technique ID. Required if instrument is not provided; at least one of technique or instrument must be set.
     * @param instrument (optional) Instrument ID. Required if technique is not provided; at least one of technique or instrument must be set.
     * @param name (optional) Optional template name to resolve a single template.
     * @return 200 with template (including formula constants if used), or 404 when no matching template exists, or 400 when required parameters are missing or step is invalid.
     */
    get(step: RecipeTemplateStep | null | undefined, technique: string | null | undefined, instrument: string | null | undefined, name: string | null | undefined): Promise<RecipeTemplateDto> {
        let url_ = this.baseUrl + "/api/v1/recipe-templates?";
        if (step !== undefined && step !== null)
            url_ += "step=" + encodeURIComponent("" + step) + "&";
        if (technique !== undefined && technique !== null)
            url_ += "technique=" + encodeURIComponent("" + technique) + "&";
        if (instrument !== undefined && instrument !== null)
            url_ += "instrument=" + encodeURIComponent("" + instrument) + "&";
        if (name !== undefined && name !== null)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<RecipeTemplateDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RecipeTemplateDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecipeTemplateDto>(null as any);
    }

    /**
     * Lists available recipe template names for the given step and technique and/or instrument.
     * @param step (optional) Activity step (required): PREP, SYN, or POST.
     * @param technique (optional) Technique ID. Required if instrument is not provided; at least one of technique or instrument must be set.
     * @param instrument (optional) Instrument ID. Required if technique is not provided; at least one of technique or instrument must be set.
     * @return 200 with list of template names and UsesInstrument flag, or 400 when required parameters are missing or step is invalid.
     */
    availableTemplates(step: RecipeTemplateStep | null | undefined, technique: string | null | undefined, instrument: string | null | undefined): Promise<AvailableTemplate[]> {
        let url_ = this.baseUrl + "/api/v1/recipe-templates/available-templates?";
        if (step !== undefined && step !== null)
            url_ += "step=" + encodeURIComponent("" + step) + "&";
        if (technique !== undefined && technique !== null)
            url_ += "technique=" + encodeURIComponent("" + technique) + "&";
        if (instrument !== undefined && instrument !== null)
            url_ += "instrument=" + encodeURIComponent("" + instrument) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAvailableTemplates(_response));
        });
    }

    protected processAvailableTemplates(response: Response): Promise<AvailableTemplate[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AvailableTemplate[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AvailableTemplate[]>(null as any);
    }
}

export interface IRoleApiRepository {

    getRoles(): Promise<RoleDto[]>;

    create(role: CreateRoleRequest): Promise<RoleDto>;

    update(id: number, role: UpdateRoleRequest): Promise<RoleDto>;

    delete(id: number): Promise<void>;

    getRole(idOrName: string): Promise<RoleWithPrivilegesDto>;

    getRolesWithPrivileges(): Promise<RoleWithPrivilegesDto[]>;
}

export class RoleApiRepository extends AuthorizedApiBase implements IRoleApiRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getRoles(): Promise<RoleDto[]> {
        let url_ = this.baseUrl + "/api/v1/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRoles(_response));
        });
    }

    protected processGetRoles(response: Response): Promise<RoleDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RoleDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleDto[]>(null as any);
    }

    create(role: CreateRoleRequest): Promise<RoleDto> {
        let url_ = this.baseUrl + "/api/v1/roles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(role);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<RoleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RoleDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleDto>(null as any);
    }

    update(id: number, role: UpdateRoleRequest): Promise<RoleDto> {
        let url_ = this.baseUrl + "/api/v1/roles/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(role);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<RoleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RoleDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleDto>(null as any);
    }

    delete(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/roles/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getRole(idOrName: string): Promise<RoleWithPrivilegesDto> {
        let url_ = this.baseUrl + "/api/v1/roles/{idOrName}";
        if (idOrName === undefined || idOrName === null)
            throw new globalThis.Error("The parameter 'idOrName' must be defined.");
        url_ = url_.replace("{idOrName}", encodeURIComponent("" + idOrName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRole(_response));
        });
    }

    protected processGetRole(response: Response): Promise<RoleWithPrivilegesDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RoleWithPrivilegesDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleWithPrivilegesDto>(null as any);
    }

    getRolesWithPrivileges(): Promise<RoleWithPrivilegesDto[]> {
        let url_ = this.baseUrl + "/api/v1/roles/withPrivileges";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRolesWithPrivileges(_response));
        });
    }

    protected processGetRolesWithPrivileges(response: Response): Promise<RoleWithPrivilegesDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RoleWithPrivilegesDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleWithPrivilegesDto[]>(null as any);
    }
}

export interface ISampleActivityApiRepository {

    create(activity: CreateSampleActivityRequest): Promise<SampleActivityDto>;

    /**
     * Checks whether the given file ids exist and are accessible for the activity. Returns a list of (fileId, exists) pairs.
     * @param activityId Activity id.
     * @param fileIds (optional) Comma-separated file ids to check.
     * @deprecated
     */
    checkFile(activityId: number, fileIds: string | null | undefined): Promise<FileCheckDto[]>;

    /**
     * Updates file metadata for a logical file group. Same body as legacy PUT …/files.
     */
    updateFileGroup(activityId: number, dto: FileMetaDataCreateOrUpdateRequest): Promise<FileMetaDataDto>;

    /**
     * Returns file metadata groups (logical attachments) for the activity.
     */
    getFileGroups(activityId: number): Promise<FileMetaDataDto[]>;

    /**
     * Deletes every stored format in a logical file group (same semantics as removing each physical file in turn).
     */
    deleteFileGroup(activityId: number, fileGroupId: number): Promise<void>;

    /**
     * Uploads a file to an activity (FineUploader format). Returns success/error result for the upload widget.
     * @param activityId Activity id.
     * @param file File payload (base64 or blob) and name, via FineUploadBinder.
     * @deprecated
     */
    uploadFile(activityId: number, file: FineUploadFileDto): Promise<FileResponse>;

    /**
     * Updates file metadata for a file group on an activity. Send id or basename to identify the group.
     * @param activityId Activity id.
     * @param dto Writable metadata; identify the file group by id or basename (see GET files response).
     * @deprecated
     */
    updateFile(activityId: number, dto: FileMetaDataCreateOrUpdateRequest): Promise<FileMetaDataDto>;

    /**
     * Returns file metadata for all files attached to an activity (filtered by access).
     * @param activityId Activity id.
     * @deprecated
     */
    getFiles(activityId: number): Promise<FileMetaDataDto[]>;

    /**
     * Raw file bytes (Content-Disposition: attachment), not a FileDto JSON body.
     * @param fileId File id.
     * @param activityId Activity id.
     */
    getFile(fileId: number, activityId: number): Promise<FileResponse>;

    /**
     * Deletes a file attached to an activity.
     * @param fileId File id.
     * @param activityId Activity id.
     */
    deleteFile(fileId: number, activityId: number): Promise<void>;

    /**
     * Checks whether the given physical file ids exist and are accessible for the activity.
     * @param fileIds (optional) 
     */
    checkFilesUnderFilesRoute(activityId: number, fileIds: string | null | undefined): Promise<FileCheckDto[]>;

    /**
     * Upload a file to an activity via multipart form. Returns the created file metadata on success.
    Default intent is attachment-only (no recipe parsing for sample processing activities).
    Preferred over the legacy POST .../files endpoint (Fine Uploader only).
     * @param activityId Activity id.
     * @param uploadFile (optional) 
     * @param description (optional) 
     * @param visibility (optional) 
     * @param fields (optional) 
     */
    uploadActivityFileForm(activityId: number, uploadFile: FileParameter | undefined, description: string | null | undefined, visibility: VisibilityDto | null | undefined, fields: FileMetaDataFieldWriteRequest[] | null | undefined): Promise<FileMetaDataDto>;

    /**
     * Multipart upload that parses the file as recipe data (strict). Only for processing sample activities with
    Upload-type recipe templates; returns 400 when the file cannot be parsed, the activity is submitted,
    or the activity is not eligible. Requires parent ProcessingActivity.Update (same gate as
    files/upload) plus OwnFile.Create.
     * @param activityId Activity id.
     * @param uploadFile (optional) 
     * @param description (optional) 
     * @param visibility (optional) 
     * @param fields (optional) 
     */
    uploadActivityRecipeFileForm(activityId: number, uploadFile: FileParameter | undefined, description: string | null | undefined, visibility: VisibilityDto | null | undefined, fields: FileMetaDataFieldWriteRequest[] | null | undefined): Promise<FileMetaDataDto>;

    getFolderLink(activityId: number): Promise<FolderShareLink>;

    /**
     * Returns an image file inline (e.g. for display in browser).
     * @param fileId File id.
     * @param activityId Activity id.
     */
    getImage(fileId: number, activityId: number): Promise<FileResponse>;

    /**
     * Replaces/saves all notes for an activity. Returns the saved notes (filtered by auth).
     * @param activityId Activity id.
     * @param dtos Notes to save; existing notes are updated by ID, new notes have ID 0 or omitted.
     */
    saveNotes(activityId: number, dtos: NoteDto[]): Promise<NoteDto[]>;

    /**
     * Returns notes for an activity, filtered by the current user's access.
     * @param activityId Activity id.
     */
    getNotes(activityId: number): Promise<NoteDto[]>;

    /**
     * Deletes a note from an activity. Caller must be allowed to delete the note (e.g. owner).
     * @param activityId Activity id.
     * @param noteId Note id.
     */
    deleteNote(activityId: number, noteId: number): Promise<void>;

    downloadRecipe(activityId: number, format: string | null | undefined): Promise<FileResponse>;

    get(id: number): Promise<SampleActivityDto>;

    update(id: number, userHasConfirmed: boolean | undefined, activity: UpdateSampleActivityRequest): Promise<SampleActivityDto>;

    /**
     * Override DeletePending to prevent direct deletion of Inventory activities.
    Inventory activities cannot be deleted independently - the parent sample must be deleted instead.
    This enforces the business rule that samples must always have an inventory activity.
     * @param id The ID of the sample activity to delete
     * @param userHasConfirmed (optional) Whether the user has confirmed the deletion (not used for inventory activities)
     * @return Returns 424 (Failed Dependency) with a message explaining that the sample must be deleted instead
     */
    deletePending(id: number, userHasConfirmed: boolean | undefined): Promise<void>;

    getPieces(id: number, projectId: number | null | undefined, dataPackageId: number | null | undefined): Promise<SampleDto[]>;

    resetPending(id: number): Promise<SampleActivityDto>;

    submit(id: number, userHasConfirmed: boolean | undefined): Promise<SampleActivityDto>;
}

export class SampleActivityApiRepository extends AuthorizedApiBase implements ISampleActivityApiRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    create(activity: CreateSampleActivityRequest): Promise<SampleActivityDto> {
        let url_ = this.baseUrl + "/api/v1/sample-activities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(activity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<SampleActivityDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleActivityDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleActivityDto>(null as any);
    }

    /**
     * Checks whether the given file ids exist and are accessible for the activity. Returns a list of (fileId, exists) pairs.
     * @param activityId Activity id.
     * @param fileIds (optional) Comma-separated file ids to check.
     * @deprecated
     */
    checkFile(activityId: number, fileIds: string | null | undefined): Promise<FileCheckDto[]> {
        let url_ = this.baseUrl + "/api/v1/sample-activities/{activityId}/check-file?";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (fileIds !== undefined && fileIds !== null)
            url_ += "fileIds=" + encodeURIComponent("" + fileIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckFile(_response));
        });
    }

    protected processCheckFile(response: Response): Promise<FileCheckDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileCheckDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileCheckDto[]>(null as any);
    }

    /**
     * Updates file metadata for a logical file group. Same body as legacy PUT …/files.
     */
    updateFileGroup(activityId: number, dto: FileMetaDataCreateOrUpdateRequest): Promise<FileMetaDataDto> {
        let url_ = this.baseUrl + "/api/v1/sample-activities/{activityId}/file-groups";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateFileGroup(_response));
        });
    }

    protected processUpdateFileGroup(response: Response): Promise<FileMetaDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto>(null as any);
    }

    /**
     * Returns file metadata groups (logical attachments) for the activity.
     */
    getFileGroups(activityId: number): Promise<FileMetaDataDto[]> {
        let url_ = this.baseUrl + "/api/v1/sample-activities/{activityId}/file-groups";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFileGroups(_response));
        });
    }

    protected processGetFileGroups(response: Response): Promise<FileMetaDataDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto[]>(null as any);
    }

    /**
     * Deletes every stored format in a logical file group (same semantics as removing each physical file in turn).
     */
    deleteFileGroup(activityId: number, fileGroupId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/sample-activities/{activityId}/file-groups/{fileGroupId}";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (fileGroupId === undefined || fileGroupId === null)
            throw new globalThis.Error("The parameter 'fileGroupId' must be defined.");
        url_ = url_.replace("{fileGroupId}", encodeURIComponent("" + fileGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteFileGroup(_response));
        });
    }

    protected processDeleteFileGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Uploads a file to an activity (FineUploader format). Returns success/error result for the upload widget.
     * @param activityId Activity id.
     * @param file File payload (base64 or blob) and name, via FineUploadBinder.
     * @deprecated
     */
    uploadFile(activityId: number, file: FineUploadFileDto): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/sample-activities/{activityId}/files";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(file);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadFile(_response));
        });
    }

    protected processUploadFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Updates file metadata for a file group on an activity. Send id or basename to identify the group.
     * @param activityId Activity id.
     * @param dto Writable metadata; identify the file group by id or basename (see GET files response).
     * @deprecated
     */
    updateFile(activityId: number, dto: FileMetaDataCreateOrUpdateRequest): Promise<FileMetaDataDto> {
        let url_ = this.baseUrl + "/api/v1/sample-activities/{activityId}/files";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateFile(_response));
        });
    }

    protected processUpdateFile(response: Response): Promise<FileMetaDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto>(null as any);
    }

    /**
     * Returns file metadata for all files attached to an activity (filtered by access).
     * @param activityId Activity id.
     * @deprecated
     */
    getFiles(activityId: number): Promise<FileMetaDataDto[]> {
        let url_ = this.baseUrl + "/api/v1/sample-activities/{activityId}/files";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFiles(_response));
        });
    }

    protected processGetFiles(response: Response): Promise<FileMetaDataDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto[]>(null as any);
    }

    /**
     * Raw file bytes (Content-Disposition: attachment), not a FileDto JSON body.
     * @param fileId File id.
     * @param activityId Activity id.
     */
    getFile(fileId: number, activityId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/sample-activities/{activityId}/files/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFile(_response));
        });
    }

    protected processGetFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Deletes a file attached to an activity.
     * @param fileId File id.
     * @param activityId Activity id.
     */
    deleteFile(fileId: number, activityId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/sample-activities/{activityId}/files/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteFile(_response));
        });
    }

    protected processDeleteFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Checks whether the given physical file ids exist and are accessible for the activity.
     * @param fileIds (optional) 
     */
    checkFilesUnderFilesRoute(activityId: number, fileIds: string | null | undefined): Promise<FileCheckDto[]> {
        let url_ = this.baseUrl + "/api/v1/sample-activities/{activityId}/files/check?";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (fileIds !== undefined && fileIds !== null)
            url_ += "fileIds=" + encodeURIComponent("" + fileIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckFilesUnderFilesRoute(_response));
        });
    }

    protected processCheckFilesUnderFilesRoute(response: Response): Promise<FileCheckDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileCheckDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileCheckDto[]>(null as any);
    }

    /**
     * Upload a file to an activity via multipart form. Returns the created file metadata on success.
    Default intent is attachment-only (no recipe parsing for sample processing activities).
    Preferred over the legacy POST .../files endpoint (Fine Uploader only).
     * @param activityId Activity id.
     * @param uploadFile (optional) 
     * @param description (optional) 
     * @param visibility (optional) 
     * @param fields (optional) 
     */
    uploadActivityFileForm(activityId: number, uploadFile: FileParameter | undefined, description: string | null | undefined, visibility: VisibilityDto | null | undefined, fields: FileMetaDataFieldWriteRequest[] | null | undefined): Promise<FileMetaDataDto> {
        let url_ = this.baseUrl + "/api/v1/sample-activities/{activityId}/files/upload";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (uploadFile === null || uploadFile === undefined)
            throw new globalThis.Error("The parameter 'uploadFile' cannot be null.");
        else
            content_.append("UploadFile", uploadFile.data, uploadFile.fileName ? uploadFile.fileName : "UploadFile");
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (visibility !== null && visibility !== undefined)
            content_.append("Visibility", visibility.toString());
        if (fields !== null && fields !== undefined)
            fields.forEach(item_ => content_.append("Fields", item_.toString()));

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadActivityFileForm(_response));
        });
    }

    protected processUploadActivityFileForm(response: Response): Promise<FileMetaDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto>(null as any);
    }

    /**
     * Multipart upload that parses the file as recipe data (strict). Only for processing sample activities with
    Upload-type recipe templates; returns 400 when the file cannot be parsed, the activity is submitted,
    or the activity is not eligible. Requires parent ProcessingActivity.Update (same gate as
    files/upload) plus OwnFile.Create.
     * @param activityId Activity id.
     * @param uploadFile (optional) 
     * @param description (optional) 
     * @param visibility (optional) 
     * @param fields (optional) 
     */
    uploadActivityRecipeFileForm(activityId: number, uploadFile: FileParameter | undefined, description: string | null | undefined, visibility: VisibilityDto | null | undefined, fields: FileMetaDataFieldWriteRequest[] | null | undefined): Promise<FileMetaDataDto> {
        let url_ = this.baseUrl + "/api/v1/sample-activities/{activityId}/files/upload-recipe";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (uploadFile === null || uploadFile === undefined)
            throw new globalThis.Error("The parameter 'uploadFile' cannot be null.");
        else
            content_.append("UploadFile", uploadFile.data, uploadFile.fileName ? uploadFile.fileName : "UploadFile");
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (visibility !== null && visibility !== undefined)
            content_.append("Visibility", visibility.toString());
        if (fields !== null && fields !== undefined)
            fields.forEach(item_ => content_.append("Fields", item_.toString()));

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadActivityRecipeFileForm(_response));
        });
    }

    protected processUploadActivityRecipeFileForm(response: Response): Promise<FileMetaDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto>(null as any);
    }

    getFolderLink(activityId: number): Promise<FolderShareLink> {
        let url_ = this.baseUrl + "/api/v1/sample-activities/{activityId}/getLink";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFolderLink(_response));
        });
    }

    protected processGetFolderLink(response: Response): Promise<FolderShareLink> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FolderShareLink;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FolderShareLink>(null as any);
    }

    /**
     * Returns an image file inline (e.g. for display in browser).
     * @param fileId File id.
     * @param activityId Activity id.
     */
    getImage(fileId: number, activityId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/sample-activities/{activityId}/images/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetImage(_response));
        });
    }

    protected processGetImage(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Replaces/saves all notes for an activity. Returns the saved notes (filtered by auth).
     * @param activityId Activity id.
     * @param dtos Notes to save; existing notes are updated by ID, new notes have ID 0 or omitted.
     */
    saveNotes(activityId: number, dtos: NoteDto[]): Promise<NoteDto[]> {
        let url_ = this.baseUrl + "/api/v1/sample-activities/{activityId}/notes";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dtos);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveNotes(_response));
        });
    }

    protected processSaveNotes(response: Response): Promise<NoteDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NoteDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoteDto[]>(null as any);
    }

    /**
     * Returns notes for an activity, filtered by the current user's access.
     * @param activityId Activity id.
     */
    getNotes(activityId: number): Promise<NoteDto[]> {
        let url_ = this.baseUrl + "/api/v1/sample-activities/{activityId}/notes";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetNotes(_response));
        });
    }

    protected processGetNotes(response: Response): Promise<NoteDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NoteDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoteDto[]>(null as any);
    }

    /**
     * Deletes a note from an activity. Caller must be allowed to delete the note (e.g. owner).
     * @param activityId Activity id.
     * @param noteId Note id.
     */
    deleteNote(activityId: number, noteId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/sample-activities/{activityId}/notes/{noteId}";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (noteId === undefined || noteId === null)
            throw new globalThis.Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteNote(_response));
        });
    }

    protected processDeleteNote(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    downloadRecipe(activityId: number, format: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/sample-activities/{activityId}/recipe?";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (format !== undefined && format !== null)
            url_ += "format=" + encodeURIComponent("" + format) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadRecipe(_response));
        });
    }

    protected processDownloadRecipe(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    get(id: number): Promise<SampleActivityDto> {
        let url_ = this.baseUrl + "/api/v1/sample-activities/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<SampleActivityDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleActivityDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleActivityDto>(null as any);
    }

    update(id: number, userHasConfirmed: boolean | undefined, activity: UpdateSampleActivityRequest): Promise<SampleActivityDto> {
        let url_ = this.baseUrl + "/api/v1/sample-activities/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userHasConfirmed === null)
            throw new globalThis.Error("The parameter 'userHasConfirmed' cannot be null.");
        else if (userHasConfirmed !== undefined)
            url_ += "userHasConfirmed=" + encodeURIComponent("" + userHasConfirmed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(activity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<SampleActivityDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleActivityDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status === 428) {
            return response.text().then((_responseText) => {
            let result428: any = null;
            result428 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result428);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleActivityDto>(null as any);
    }

    /**
     * Override DeletePending to prevent direct deletion of Inventory activities.
    Inventory activities cannot be deleted independently - the parent sample must be deleted instead.
    This enforces the business rule that samples must always have an inventory activity.
     * @param id The ID of the sample activity to delete
     * @param userHasConfirmed (optional) Whether the user has confirmed the deletion (not used for inventory activities)
     * @return Returns 424 (Failed Dependency) with a message explaining that the sample must be deleted instead
     */
    deletePending(id: number, userHasConfirmed: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/sample-activities/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userHasConfirmed === null)
            throw new globalThis.Error("The parameter 'userHasConfirmed' cannot be null.");
        else if (userHasConfirmed !== undefined)
            url_ += "userHasConfirmed=" + encodeURIComponent("" + userHasConfirmed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeletePending(_response));
        });
    }

    protected processDeletePending(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result424);
            });
        } else if (status === 428) {
            return response.text().then((_responseText) => {
            let result428: any = null;
            result428 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result428);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getPieces(id: number, projectId: number | null | undefined, dataPackageId: number | null | undefined): Promise<SampleDto[]> {
        let url_ = this.baseUrl + "/api/v1/sample-activities/{id}/pieces?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (dataPackageId !== undefined && dataPackageId !== null)
            url_ += "dataPackageId=" + encodeURIComponent("" + dataPackageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPieces(_response));
        });
    }

    protected processGetPieces(response: Response): Promise<SampleDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleDto[]>(null as any);
    }

    resetPending(id: number): Promise<SampleActivityDto> {
        let url_ = this.baseUrl + "/api/v1/sample-activities/{id}/reset";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processResetPending(_response));
        });
    }

    protected processResetPending(response: Response): Promise<SampleActivityDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleActivityDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleActivityDto>(null as any);
    }

    submit(id: number, userHasConfirmed: boolean | undefined): Promise<SampleActivityDto> {
        let url_ = this.baseUrl + "/api/v1/sample-activities/{id}/submit?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userHasConfirmed === null)
            throw new globalThis.Error("The parameter 'userHasConfirmed' cannot be null.");
        else if (userHasConfirmed !== undefined)
            url_ += "userHasConfirmed=" + encodeURIComponent("" + userHasConfirmed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSubmit(_response));
        });
    }

    protected processSubmit(response: Response): Promise<SampleActivityDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleActivityDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result424);
            });
        } else if (status === 428) {
            return response.text().then((_responseText) => {
            let result428: any = null;
            result428 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result428);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleActivityDto>(null as any);
    }
}

export interface ISampleImportApiRepository {

    /**
     * Submit an inline sample definition (XML, JSON, or YAML) for background import.
     * @param forceUpdate (optional) 
     */
    submitInlineDefinition(forceUpdate: boolean | undefined): Promise<SampleImportSubmitResponseDto>;

    retryEntries(forceUpdate: boolean | undefined, ids: number[]): Promise<number[]>;

    deleteEntry(id: number): Promise<void>;

    retryEntry(id: number, forceUpdate: boolean | undefined): Promise<void>;

    download(id: number): Promise<FileResponse>;

    /**
     * Update import monitor status and message (e.g. recipe_pipeline outcome). API-key friendly.
     */
    updateOutcome(id: number, body: SampleImportOutcomeUpdateDto): Promise<void>;

    list(instrumentId: string, sampleId: string | null | undefined, filterStatus: SampleImportFilterStatusDto | null | undefined, createdBy: string | null | undefined, processDateFrom: string | null | undefined, processDateTo: string | null | undefined, searchMessage: string | null | undefined): Promise<SampleImportRecordDto[]>;

    importSample(instrumentId: string, sampleId: string): Promise<void>;

    getImportIds(instrumentId: string, sampleId: string | null | undefined, filterStatus: SampleImportFilterStatusDto | null | undefined, createdBy: string | null | undefined, processDateFrom: string | null | undefined, processDateTo: string | null | undefined, searchMessage: string | null | undefined): Promise<number[]>;

    importAll(instrumentId: string): Promise<void>;

    getJobStatus(instrumentId: string): Promise<string>;

    getStatistics(instrumentId: string): Promise<SampleImportStat>;

    reimport(instrumentId: string): Promise<void>;

    /**
     * Instruments with sample-import configured that the caller may manage
    (IsInstrumentManager).
     */
    getConfiguredInstruments(): Promise<string[]>;

    reload(): Promise<void>;
}

export class SampleImportApiRepository extends AuthorizedApiBase implements ISampleImportApiRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Submit an inline sample definition (XML, JSON, or YAML) for background import.
     * @param forceUpdate (optional) 
     */
    submitInlineDefinition(forceUpdate: boolean | undefined): Promise<SampleImportSubmitResponseDto> {
        let url_ = this.baseUrl + "/api/v1/sample-import?";
        if (forceUpdate === null)
            throw new globalThis.Error("The parameter 'forceUpdate' cannot be null.");
        else if (forceUpdate !== undefined)
            url_ += "forceUpdate=" + encodeURIComponent("" + forceUpdate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSubmitInlineDefinition(_response));
        });
    }

    protected processSubmitInlineDefinition(response: Response): Promise<SampleImportSubmitResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleImportSubmitResponseDto;
            return result200;
            });
        } else if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            result202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleImportSubmitResponseDto;
            return result202;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 415) {
            return response.text().then((_responseText) => {
            let result415: any = null;
            result415 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result415);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            let result429: any = null;
            result429 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result429);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleImportSubmitResponseDto>(null as any);
    }

    retryEntries(forceUpdate: boolean | undefined, ids: number[]): Promise<number[]> {
        let url_ = this.baseUrl + "/api/v1/sample-import?";
        if (forceUpdate === null)
            throw new globalThis.Error("The parameter 'forceUpdate' cannot be null.");
        else if (forceUpdate !== undefined)
            url_ += "forceUpdate=" + encodeURIComponent("" + forceUpdate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(ids);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRetryEntries(_response));
        });
    }

    protected processRetryEntries(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    deleteEntry(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/sample-import/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteEntry(_response));
        });
    }

    protected processDeleteEntry(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    retryEntry(id: number, forceUpdate: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/sample-import/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (forceUpdate === null)
            throw new globalThis.Error("The parameter 'forceUpdate' cannot be null.");
        else if (forceUpdate !== undefined)
            url_ += "forceUpdate=" + encodeURIComponent("" + forceUpdate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRetryEntry(_response));
        });
    }

    protected processRetryEntry(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    download(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/sample-import/{id}/file";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownload(_response));
        });
    }

    protected processDownload(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Update import monitor status and message (e.g. recipe_pipeline outcome). API-key friendly.
     */
    updateOutcome(id: number, body: SampleImportOutcomeUpdateDto): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/sample-import/{id}/outcome";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateOutcome(_response));
        });
    }

    protected processUpdateOutcome(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    list(instrumentId: string, sampleId: string | null | undefined, filterStatus: SampleImportFilterStatusDto | null | undefined, createdBy: string | null | undefined, processDateFrom: string | null | undefined, processDateTo: string | null | undefined, searchMessage: string | null | undefined): Promise<SampleImportRecordDto[]> {
        let url_ = this.baseUrl + "/api/v1/sample-import/{instrumentId}?";
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        if (sampleId !== undefined && sampleId !== null)
            url_ += "sampleId=" + encodeURIComponent("" + sampleId) + "&";
        if (filterStatus !== undefined && filterStatus !== null)
            url_ += "filterStatus=" + encodeURIComponent("" + filterStatus) + "&";
        if (createdBy !== undefined && createdBy !== null)
            url_ += "createdBy=" + encodeURIComponent("" + createdBy) + "&";
        if (processDateFrom !== undefined && processDateFrom !== null)
            url_ += "processDateFrom=" + encodeURIComponent("" + processDateFrom) + "&";
        if (processDateTo !== undefined && processDateTo !== null)
            url_ += "processDateTo=" + encodeURIComponent("" + processDateTo) + "&";
        if (searchMessage !== undefined && searchMessage !== null)
            url_ += "searchMessage=" + encodeURIComponent("" + searchMessage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<SampleImportRecordDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleImportRecordDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleImportRecordDto[]>(null as any);
    }

    importSample(instrumentId: string, sampleId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/sample-import/{instrumentId}/{sampleId}/import";
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        if (sampleId === undefined || sampleId === null)
            throw new globalThis.Error("The parameter 'sampleId' must be defined.");
        url_ = url_.replace("{sampleId}", encodeURIComponent("" + sampleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportSample(_response));
        });
    }

    protected processImportSample(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getImportIds(instrumentId: string, sampleId: string | null | undefined, filterStatus: SampleImportFilterStatusDto | null | undefined, createdBy: string | null | undefined, processDateFrom: string | null | undefined, processDateTo: string | null | undefined, searchMessage: string | null | undefined): Promise<number[]> {
        let url_ = this.baseUrl + "/api/v1/sample-import/{instrumentId}/ids?";
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        if (sampleId !== undefined && sampleId !== null)
            url_ += "sampleId=" + encodeURIComponent("" + sampleId) + "&";
        if (filterStatus !== undefined && filterStatus !== null)
            url_ += "filterStatus=" + encodeURIComponent("" + filterStatus) + "&";
        if (createdBy !== undefined && createdBy !== null)
            url_ += "createdBy=" + encodeURIComponent("" + createdBy) + "&";
        if (processDateFrom !== undefined && processDateFrom !== null)
            url_ += "processDateFrom=" + encodeURIComponent("" + processDateFrom) + "&";
        if (processDateTo !== undefined && processDateTo !== null)
            url_ += "processDateTo=" + encodeURIComponent("" + processDateTo) + "&";
        if (searchMessage !== undefined && searchMessage !== null)
            url_ += "searchMessage=" + encodeURIComponent("" + searchMessage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetImportIds(_response));
        });
    }

    protected processGetImportIds(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    importAll(instrumentId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/sample-import/{instrumentId}/import";
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportAll(_response));
        });
    }

    protected processImportAll(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getJobStatus(instrumentId: string): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/sample-import/{instrumentId}/job-status";
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetJobStatus(_response));
        });
    }

    protected processGetJobStatus(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getStatistics(instrumentId: string): Promise<SampleImportStat> {
        let url_ = this.baseUrl + "/api/v1/sample-import/{instrumentId}/statistics";
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStatistics(_response));
        });
    }

    protected processGetStatistics(response: Response): Promise<SampleImportStat> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleImportStat;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleImportStat>(null as any);
    }

    reimport(instrumentId: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/sample-import/{instrumentId}/updateAll";
        if (instrumentId === undefined || instrumentId === null)
            throw new globalThis.Error("The parameter 'instrumentId' must be defined.");
        url_ = url_.replace("{instrumentId}", encodeURIComponent("" + instrumentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReimport(_response));
        });
    }

    protected processReimport(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Instruments with sample-import configured that the caller may manage
    (IsInstrumentManager).
     */
    getConfiguredInstruments(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/sample-import/instruments";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetConfiguredInstruments(_response));
        });
    }

    protected processGetConfiguredInstruments(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    reload(): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/sample-import/reload";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReload(_response));
        });
    }

    protected processReload(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ISampleReportConfigApiRepository {

    /**
     * Creates a sample report definition. Body must omit database IDs; the saved DTO (including groups) is returned.
     */
    create(config: SampleReportConfigDto): Promise<SampleReportConfigDto>;

    /**
     * Lists available report definitions for the caller, without group/column details.
    Optional technique and instrument query values restrict the catalog the same way the execute UI does.
     * @param techniqueId (optional) 
     * @param instrumentId (optional) 
     */
    list(techniqueId: string | null | undefined, instrumentId: string | null | undefined): Promise<SampleReportConfigDto[]>;

    /**
     * Replaces an existing sample report definition. Returns 204 when the update succeeds.
     */
    update(id: number, config: SampleReportConfigDto): Promise<void>;

    delete(id: number): Promise<void>;

    /**
     * Returns one sample report definition including column groups.
     */
    get(id: number): Promise<SampleReportConfigDto>;
}

export class SampleReportConfigApiRepository extends AuthorizedApiBase implements ISampleReportConfigApiRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Creates a sample report definition. Body must omit database IDs; the saved DTO (including groups) is returned.
     */
    create(config: SampleReportConfigDto): Promise<SampleReportConfigDto> {
        let url_ = this.baseUrl + "/api/v1/sample-report-configs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(config);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<SampleReportConfigDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleReportConfigDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleReportConfigDto>(null as any);
    }

    /**
     * Lists available report definitions for the caller, without group/column details.
    Optional technique and instrument query values restrict the catalog the same way the execute UI does.
     * @param techniqueId (optional) 
     * @param instrumentId (optional) 
     */
    list(techniqueId: string | null | undefined, instrumentId: string | null | undefined): Promise<SampleReportConfigDto[]> {
        let url_ = this.baseUrl + "/api/v1/sample-report-configs?";
        if (techniqueId !== undefined && techniqueId !== null)
            url_ += "techniqueId=" + encodeURIComponent("" + techniqueId) + "&";
        if (instrumentId !== undefined && instrumentId !== null)
            url_ += "instrumentId=" + encodeURIComponent("" + instrumentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<SampleReportConfigDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleReportConfigDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleReportConfigDto[]>(null as any);
    }

    /**
     * Replaces an existing sample report definition. Returns 204 when the update succeeds.
     */
    update(id: number, config: SampleReportConfigDto): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/sample-report-configs/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(config);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    delete(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/sample-report-configs/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Returns one sample report definition including column groups.
     */
    get(id: number): Promise<SampleReportConfigDto> {
        let url_ = this.baseUrl + "/api/v1/sample-report-configs/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<SampleReportConfigDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleReportConfigDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleReportConfigDto>(null as any);
    }
}

export interface ISampleReportApiRepository {

    /**
     * Runs a sample report for configId using the given sample-search criteria.
    Returns grouped columns and string rows (including parent/child ref links).
     * @param configId (optional) 
     */
    createReport(configId: number | undefined, criteria: SampleSearchCriteria): Promise<SampleReportDto>;

    /**
     * Same run as CreateReport, returned as an Excel (.xlsx) file download.
     * @param configId (optional) 
     */
    download(configId: number | undefined, criteria: SampleSearchCriteria): Promise<FileResponse>;

    exists(id: number): Promise<ExistsResult>;
}

export class SampleReportApiRepository extends AuthorizedApiBase implements ISampleReportApiRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Runs a sample report for configId using the given sample-search criteria.
    Returns grouped columns and string rows (including parent/child ref links).
     * @param configId (optional) 
     */
    createReport(configId: number | undefined, criteria: SampleSearchCriteria): Promise<SampleReportDto> {
        let url_ = this.baseUrl + "/api/v1/sample-reports?";
        if (configId === null)
            throw new globalThis.Error("The parameter 'configId' cannot be null.");
        else if (configId !== undefined)
            url_ += "configId=" + encodeURIComponent("" + configId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(criteria);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateReport(_response));
        });
    }

    protected processCreateReport(response: Response): Promise<SampleReportDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleReportDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleReportDto>(null as any);
    }

    /**
     * Same run as CreateReport, returned as an Excel (.xlsx) file download.
     * @param configId (optional) 
     */
    download(configId: number | undefined, criteria: SampleSearchCriteria): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/sample-reports/download?";
        if (configId === null)
            throw new globalThis.Error("The parameter 'configId' cannot be null.");
        else if (configId !== undefined)
            url_ += "configId=" + encodeURIComponent("" + configId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(criteria);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownload(_response));
        });
    }

    protected processDownload(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    exists(id: number): Promise<ExistsResult> {
        let url_ = this.baseUrl + "/api/v1/sample-reports/exists/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExists(_response));
        });
    }

    protected processExists(response: Response): Promise<ExistsResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExistsResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExistsResult>(null as any);
    }
}

export interface ISampleRequestApiRepository {

    /**
     * @param excludeShipped (optional) 
     * @deprecated
     */
    getRequests(excludeShipped: boolean | undefined): Promise<SampleRequestDto[]>;

    getShippings(id: number): Promise<ShippingWithDeliveryDto[]>;

    /**
     * Paged sample-request search (criteria in body; sort and paging in query). No draw parameter; Draw is null.
     * @param sortColumn (optional) 
     * @param sortOrder (optional) 
     * @param start (optional) 
     * @param length (optional) 
     */
    search(sortColumn: string | null | undefined, sortOrder: string | null | undefined, start: number | undefined, length: number | undefined, criteria: SampleRequestSearchCriteriaDto): Promise<PagingResultOfSampleRequestSearchResultDto>;
}

export class SampleRequestApiRepository extends AuthorizedApiBase implements ISampleRequestApiRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param excludeShipped (optional) 
     * @deprecated
     */
    getRequests(excludeShipped: boolean | undefined): Promise<SampleRequestDto[]> {
        let url_ = this.baseUrl + "/api/v1/sample-requests?";
        if (excludeShipped === null)
            throw new globalThis.Error("The parameter 'excludeShipped' cannot be null.");
        else if (excludeShipped !== undefined)
            url_ += "excludeShipped=" + encodeURIComponent("" + excludeShipped) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRequests(_response));
        });
    }

    protected processGetRequests(response: Response): Promise<SampleRequestDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleRequestDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleRequestDto[]>(null as any);
    }

    getShippings(id: number): Promise<ShippingWithDeliveryDto[]> {
        let url_ = this.baseUrl + "/api/v1/sample-requests/{id}/shippings";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetShippings(_response));
        });
    }

    protected processGetShippings(response: Response): Promise<ShippingWithDeliveryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ShippingWithDeliveryDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShippingWithDeliveryDto[]>(null as any);
    }

    /**
     * Paged sample-request search (criteria in body; sort and paging in query). No draw parameter; Draw is null.
     * @param sortColumn (optional) 
     * @param sortOrder (optional) 
     * @param start (optional) 
     * @param length (optional) 
     */
    search(sortColumn: string | null | undefined, sortOrder: string | null | undefined, start: number | undefined, length: number | undefined, criteria: SampleRequestSearchCriteriaDto): Promise<PagingResultOfSampleRequestSearchResultDto> {
        let url_ = this.baseUrl + "/api/v1/sample-requests/search?";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (length === null)
            throw new globalThis.Error("The parameter 'length' cannot be null.");
        else if (length !== undefined)
            url_ += "length=" + encodeURIComponent("" + length) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(criteria);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearch(_response));
        });
    }

    protected processSearch(response: Response): Promise<PagingResultOfSampleRequestSearchResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingResultOfSampleRequestSearchResultDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingResultOfSampleRequestSearchResultDto>(null as any);
    }
}

export interface ISampleSnapshotApiRepository {

    /**
     * Load samples for a given growth run
     * @param growthId ID of the growth run, can be numeric (internal) ID or sample ID
     */
    getSamplesOnGrowthRun(growthId: number): Promise<SampleDto[]>;

    /**
     * Get a sample by numeric or sampleID
     */
    get(id: number): Promise<SampleDto>;

    getActivities(id: number, charTechnique: string | null | undefined, syn: string | null | undefined): Promise<SampleActivityDto[]>;

    getActivity(id: number, activityId: number): Promise<SampleActivityDto>;

    /**
     * @param fileIds (optional) 
     * @deprecated
     */
    checkFile(id: number, fileIds: string | null | undefined): Promise<FileCheckDto[]>;

    /**
     * JSON array of file metadata groups (no file bytes). Use GET …/files/{fileId} or each nested file’s
    DownloadUrl for the stored content.
     */
    getFileGroups(id: number): Promise<FileMetaDataDto[]>;

    /**
     * JSON array of file metadata groups (no file bytes). Use GET …/files/{fileId} or each nested file’s
    DownloadUrl for the stored content.
     * @deprecated
     */
    getFiles(id: number): Promise<FileMetaDataDto[]>;

    /**
     * Raw file bytes (Content-Disposition: attachment), not a FileDto JSON body.
     */
    getFile(fileId: number, id: number): Promise<FileResponse>;

    /**
     * Checks physical file ids for the snapshot sample (same query as legacy check-file).
     * @param fileIds (optional) 
     */
    checkFilesUnderFilesRoute(id: number, fileIds: string | null | undefined): Promise<FileCheckDto[]>;

    createFolderLink(id: number, anonymousLink: boolean | null | undefined): Promise<FolderShareLink>;

    getImage(id: number, fileId: number): Promise<FileResponse>;

    getNotes(id: number): Promise<NoteDto[]>;

    getDropdownChoices(technique: string | null | undefined, projectId: number | null | undefined): Promise<SampleDropdownChoicesDto>;

    getUsedInstruments(projectId: number | undefined): Promise<string[]>;

    getUsedMaterials(projectId: number | undefined): Promise<string[]>;

    getUsedSubstrates(projectId: number | undefined): Promise<string[]>;
}

export class SampleSnapshotApiRepository extends AuthorizedApiBase implements ISampleSnapshotApiRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Load samples for a given growth run
     * @param growthId ID of the growth run, can be numeric (internal) ID or sample ID
     */
    getSamplesOnGrowthRun(growthId: number): Promise<SampleDto[]> {
        let url_ = this.baseUrl + "/api/v1/sample-snapshots/{growthId}/sub-samples";
        if (growthId === undefined || growthId === null)
            throw new globalThis.Error("The parameter 'growthId' must be defined.");
        url_ = url_.replace("{growthId}", encodeURIComponent("" + growthId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSamplesOnGrowthRun(_response));
        });
    }

    protected processGetSamplesOnGrowthRun(response: Response): Promise<SampleDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleDto[]>(null as any);
    }

    /**
     * Get a sample by numeric or sampleID
     */
    get(id: number): Promise<SampleDto> {
        let url_ = this.baseUrl + "/api/v1/sample-snapshots/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<SampleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleDto>(null as any);
    }

    getActivities(id: number, charTechnique: string | null | undefined, syn: string | null | undefined): Promise<SampleActivityDto[]> {
        let url_ = this.baseUrl + "/api/v1/sample-snapshots/{id}/activities?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (charTechnique !== undefined && charTechnique !== null)
            url_ += "charTechnique=" + encodeURIComponent("" + charTechnique) + "&";
        if (syn !== undefined && syn !== null)
            url_ += "syn=" + encodeURIComponent("" + syn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetActivities(_response));
        });
    }

    protected processGetActivities(response: Response): Promise<SampleActivityDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleActivityDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleActivityDto[]>(null as any);
    }

    getActivity(id: number, activityId: number): Promise<SampleActivityDto> {
        let url_ = this.baseUrl + "/api/v1/sample-snapshots/{id}/activities/{activityId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetActivity(_response));
        });
    }

    protected processGetActivity(response: Response): Promise<SampleActivityDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleActivityDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleActivityDto>(null as any);
    }

    /**
     * @param fileIds (optional) 
     * @deprecated
     */
    checkFile(id: number, fileIds: string | null | undefined): Promise<FileCheckDto[]> {
        let url_ = this.baseUrl + "/api/v1/sample-snapshots/{id}/check-file?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileIds !== undefined && fileIds !== null)
            url_ += "fileIds=" + encodeURIComponent("" + fileIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckFile(_response));
        });
    }

    protected processCheckFile(response: Response): Promise<FileCheckDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileCheckDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileCheckDto[]>(null as any);
    }

    /**
     * JSON array of file metadata groups (no file bytes). Use GET …/files/{fileId} or each nested file’s
    DownloadUrl for the stored content.
     */
    getFileGroups(id: number): Promise<FileMetaDataDto[]> {
        let url_ = this.baseUrl + "/api/v1/sample-snapshots/{id}/file-groups";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFileGroups(_response));
        });
    }

    protected processGetFileGroups(response: Response): Promise<FileMetaDataDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto[]>(null as any);
    }

    /**
     * JSON array of file metadata groups (no file bytes). Use GET …/files/{fileId} or each nested file’s
    DownloadUrl for the stored content.
     * @deprecated
     */
    getFiles(id: number): Promise<FileMetaDataDto[]> {
        let url_ = this.baseUrl + "/api/v1/sample-snapshots/{id}/files";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFiles(_response));
        });
    }

    protected processGetFiles(response: Response): Promise<FileMetaDataDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto[]>(null as any);
    }

    /**
     * Raw file bytes (Content-Disposition: attachment), not a FileDto JSON body.
     */
    getFile(fileId: number, id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/sample-snapshots/{id}/files/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFile(_response));
        });
    }

    protected processGetFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Checks physical file ids for the snapshot sample (same query as legacy check-file).
     * @param fileIds (optional) 
     */
    checkFilesUnderFilesRoute(id: number, fileIds: string | null | undefined): Promise<FileCheckDto[]> {
        let url_ = this.baseUrl + "/api/v1/sample-snapshots/{id}/files/check?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileIds !== undefined && fileIds !== null)
            url_ += "fileIds=" + encodeURIComponent("" + fileIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckFilesUnderFilesRoute(_response));
        });
    }

    protected processCheckFilesUnderFilesRoute(response: Response): Promise<FileCheckDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileCheckDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileCheckDto[]>(null as any);
    }

    createFolderLink(id: number, anonymousLink: boolean | null | undefined): Promise<FolderShareLink> {
        let url_ = this.baseUrl + "/api/v1/sample-snapshots/{id}/getLink?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (anonymousLink !== undefined && anonymousLink !== null)
            url_ += "anonymousLink=" + encodeURIComponent("" + anonymousLink) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateFolderLink(_response));
        });
    }

    protected processCreateFolderLink(response: Response): Promise<FolderShareLink> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FolderShareLink;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FolderShareLink>(null as any);
    }

    getImage(id: number, fileId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/sample-snapshots/{id}/images/{fileId}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetImage(_response));
        });
    }

    protected processGetImage(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getNotes(id: number): Promise<NoteDto[]> {
        let url_ = this.baseUrl + "/api/v1/sample-snapshots/{id}/notes";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetNotes(_response));
        });
    }

    protected processGetNotes(response: Response): Promise<NoteDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NoteDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoteDto[]>(null as any);
    }

    getDropdownChoices(technique: string | null | undefined, projectId: number | null | undefined): Promise<SampleDropdownChoicesDto> {
        let url_ = this.baseUrl + "/api/v1/sample-snapshots/drop-down-choices?";
        if (technique !== undefined && technique !== null)
            url_ += "technique=" + encodeURIComponent("" + technique) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDropdownChoices(_response));
        });
    }

    protected processGetDropdownChoices(response: Response): Promise<SampleDropdownChoicesDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleDropdownChoicesDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleDropdownChoicesDto>(null as any);
    }

    getUsedInstruments(projectId: number | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/sample-snapshots/used-instruments?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUsedInstruments(_response));
        });
    }

    protected processGetUsedInstruments(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getUsedMaterials(projectId: number | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/sample-snapshots/used-materials?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUsedMaterials(_response));
        });
    }

    protected processGetUsedMaterials(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getUsedSubstrates(projectId: number | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/sample-snapshots/used-substrates?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUsedSubstrates(_response));
        });
    }

    protected processGetUsedSubstrates(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export interface ISampleStatisticsApiRepository {

    getStatsInternal(criteria: SampleSearchCriteria): Promise<SampleStatisticsDto[]>;
}

export class SampleStatisticsApiRepository extends AuthorizedApiBase implements ISampleStatisticsApiRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getStatsInternal(criteria: SampleSearchCriteria): Promise<SampleStatisticsDto[]> {
        let url_ = this.baseUrl + "/api/v1/sample-stat";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(criteria);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStatsInternal(_response));
        });
    }

    protected processGetStatsInternal(response: Response): Promise<SampleStatisticsDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleStatisticsDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleStatisticsDto[]>(null as any);
    }
}

export interface ISampleApiRepository {

    /**
     * Load samples for a given growth run
     * @param growthId ID of the growth run, can be numeric (internal) ID or sample ID
     * @param projectIdOrLabel (optional) Optional, restrict to samples on that project
     * @param dataPackageId (optional) Optional, restrict to samples in that data package
     */
    getSamplesOnGrowthRun(growthId: string, projectIdOrLabel: string | null | undefined, dataPackageId: number | null | undefined): Promise<SampleDto[]>;

    /**
     * Get a sample by numeric or sampleID
     */
    get(idOrLabel: string): Promise<SampleDto>;

    /**
     * Update a sample
     */
    update(idOrLabel: string, model: SampleDto): Promise<SampleDto>;

    deletePending(idOrLabel: string, userHasConfirmed: boolean | undefined): Promise<void>;

    getActivities(idOrLabel: string, charTechnique: string | null | undefined, syn: string | null | undefined): Promise<SampleActivityDto[]>;

    getActivity(idOrLabel: string, activityId: number): Promise<SampleDto>;

    /**
     * Checks whether the given file ids exist and are accessible for the sample. Returns (fileId, exists) pairs.
     * @param idOrLabel Sample ID or label.
     * @param fileIds (optional) Comma-separated file ids to check.
     * @deprecated
     */
    checkFile(idOrLabel: string, fileIds: string | null | undefined): Promise<FileCheckDto[]>;

    /**
     * Updates file metadata for a logical file group. Same body as legacy PUT …/files.
     */
    updateFileGroup(idOrLabel: string, dto: FileMetaDataCreateOrUpdateRequest): Promise<FileMetaDataDto>;

    /**
     * Returns file metadata groups attached to the sample.
     */
    getFileGroups(idOrLabel: string): Promise<FileMetaDataDto[]>;

    /**
     * Deletes every stored format in a logical file group on the sample.
     */
    deleteFileGroup(idOrLabel: string, fileGroupId: number): Promise<void>;

    /**
     * Updates file metadata for a file group on a sample. Send id or basename to identify the group.
     * @param idOrLabel Sample ID or label.
     * @param dto Writable metadata; identify the file group by id or basename (see GET files response).
     * @deprecated
     */
    updateFile(idOrLabel: string, dto: FileMetaDataCreateOrUpdateRequest): Promise<FileMetaDataDto>;

    /**
     * Returns file metadata for all files attached to a sample (filtered by access).
     * @param idOrLabel Sample ID or label.
     * @deprecated
     */
    getFiles(idOrLabel: string): Promise<FileMetaDataDto[]>;

    /**
     * Uploads a file to a sample (FineUploader format). Returns success/error result for the upload widget.
     * @param idOrLabel Sample ID or label.
     * @param file File payload via FineUploadBinder.
     * @deprecated
     */
    uploadFile(idOrLabel: string, file: FineUploadFileDto): Promise<FileResponse>;

    /**
     * Raw file bytes (Content-Disposition: attachment), not a FileDto JSON body.
     * @param fileId File id.
     * @param idOrLabel Sample ID or label.
     */
    getFile(fileId: number, idOrLabel: string): Promise<FileResponse>;

    /**
     * @param fileId File id.
     * @param idOrLabel Sample ID or label.
     */
    deleteFile(fileId: number, idOrLabel: string): Promise<void>;

    /**
     * Checks physical file ids for the sample (same query as legacy check-file).
     * @param fileIds (optional) 
     */
    checkFilesUnderFilesRoute(idOrLabel: string, fileIds: string | null | undefined): Promise<FileCheckDto[]>;

    /**
     * Upload a file to a sample via multipart form. Returns the created file metadata on success.
    Preferred over the legacy POST .../files endpoint (Fine Uploader only).
     * @param idOrLabel Sample ID or label.
     * @param uploadFile (optional) 
     * @param description (optional) 
     * @param visibility (optional) 
     * @param fields (optional) 
     */
    uploadSampleFileForm(idOrLabel: string, uploadFile: FileParameter | undefined, description: string | null | undefined, visibility: VisibilityDto | null | undefined, fields: FileMetaDataFieldWriteRequest[] | null | undefined): Promise<FileMetaDataDto>;

    createFolderLink(idOrLabel: string, anonymousLink: boolean | null | undefined): Promise<FolderShareLink>;

    /**
     * Returns an image file for a sample inline (e.g. for display in browser).
     * @param idOrLabel Sample ID or label.
     * @param fileId File id.
     */
    getImage(idOrLabel: string, fileId: number): Promise<FileResponse>;

    /**
     * Replaces/saves all notes for a sample. Returns the saved notes (filtered by auth).
     * @param idOrLabel Sample ID or label.
     * @param dtos Notes to save; existing by ID, new with ID 0 or omitted.
     */
    saveNotes(idOrLabel: string, dtos: NoteDto[]): Promise<NoteDto[]>;

    /**
     * Returns notes for a sample, filtered by the current user's access.
     * @param idOrLabel Sample ID or label.
     */
    getNotes(idOrLabel: string): Promise<NoteDto[]>;

    /**
     * Deletes a note from a sample. Caller must be allowed to delete the note (e.g. owner).
     * @param idOrLabel Sample ID or label.
     * @param noteId Note id.
     */
    deleteNote(idOrLabel: string, noteId: number): Promise<void>;

    /**
     * Sets the reporting category on a sample. Uses the standard sample update authorization path
    (same semantics as updating the sample via PUT, but only changes the reporting category foreign key).
     */
    assignReportingCategoryToSample(idOrLabel: string, categoryId: number): Promise<void>;

    resetPending(idOrLabel: string): Promise<SampleDto>;

    addSampleToGrowthRun(idOrLabel: string, sampleAsSubstrate: string | null | undefined): Promise<SampleDto>;

    addSubSample(idOrLabel: string, subSample: string | null | undefined): Promise<SampleDto>;

    submit(idOrLabel: string, userHasConfirmed: boolean | undefined): Promise<SampleDto>;

    transfer(idOrLabel: string, withoutActivity: boolean | undefined, targetLabels: string[]): Promise<number[]>;

    /**
     * Splits a sample into a given number of pieces, or create new pieces if there are already pieces.
     * @param sampleId The ID of the sample to split.
     * @param nbOfPiece (optional) The number of pieces to split the sample into. Must be greater than 0
     */
    split(sampleId: number, nbOfPiece: number | undefined): Promise<SampleDto[]>;

    getAccessRights(idOrLabel: string): Promise<PrivilegeDto[]>;

    addToInventory(request: AddToInventoryRequest): Promise<AddToInventoryResponseDto>;

    addToInventoryVaried(request: AddToInventoryVariedRequest): Promise<AddToInventoryResponseDto>;

    addToInventoryVariedWithImages(sampleDataJson: string | null | undefined, uploadFiles: FileParameter[] | null | undefined, imageSpecimenIndexes: number[] | null | undefined): Promise<AddToInventoryResponseDto>;

    addToInventoryWithImage(uploadFile: FileParameter | undefined, sampleDataJson: string | null | undefined): Promise<AddToInventoryResponseDto>;

    /**
     * Create a new sample by combining one or more starting-material samples.
    This creates both the sample and an initial processing activity (synthesis or preparation).
    Starting materials can be specified as numeric IDs ("123") or labels ("S12345") in any combination.
    Labels are recommended for scripting as they're stable across environments.
     */
    combineStartingMaterials(request: CombineStartingMaterialsRequest): Promise<SampleDto>;

    copy(request: SampleCopyRequest): Promise<SampleDto>;

    /**
     * @deprecated
     */
    createGrowth(request: SampleCreationRequest): Promise<SampleDto>;

    /**
     * Create a multi-sample growth run: one parent sample (run), one SYN processing activity,
    and for each substrate either an existing sample attached to the run or a new sample with add-to-inventory.
     */
    createMultiSampleGrowth(request: CreateMultiSampleGrowthRequest): Promise<SampleDto>;

    getDropdownChoices(technique: string | null | undefined, projectId: number | null | undefined): Promise<SampleDropdownChoicesDto>;

    /**
     * Returns whether a sample exists and the current user can read it. Always 200 with
    Exists true or false; does not throw 403/404.
     */
    exists(idOrLabel: string): Promise<ExistsResult>;

    /**
     * @deprecated
     */
    create(request: ExternalSampleCreationRequest): Promise<SampleDto>;

    getFreeLabel(prefix: string | null | undefined): Promise<string>;

    isLabelUsed(label: string | null | undefined): Promise<boolean>;

    listReportingCategories(includeUsage: boolean | undefined): Promise<ReportingCategoryDto[]>;

    createReportingCategory(category: ReportingCategoryDto): Promise<ReportingCategoryDto>;

    updateReportingCategory(id: number, category: ReportingCategoryDto): Promise<ReportingCategoryDto>;

    deleteReportingCategory(id: number): Promise<void>;

    /**
     * Search for samples matching the given criteria.
     * @param sortColumn (optional) 
     * @param sortOrder (optional) 
     * @param start (optional) 
     * @param length (optional) 
     * @param draw (optional) 
     * @param criteria Search filters. Growth-run parent rows are never returned; the run label appears on child rows via
    ParentLabel. MultiSampleGrowthOnly
    toggles between all searchable samples (default) and growth-run child samples only.
     * @return Paged sample search results.
     */
    search(sortColumn: string | null | undefined, sortOrder: string | null | undefined, start: number | undefined, length: number | undefined, draw: number | undefined, criteria: SampleSearchCriteria): Promise<PagingResultOfSampleSearchResultDto>;

    addPieces(activityId: number | undefined, nbOfPiece: number | null | undefined): Promise<SampleDto[]>;

    getUsedInstruments(projectId: number | undefined): Promise<string[]>;

    getUsedMaterials(projectId: number | undefined): Promise<string[]>;
}

export class SampleApiRepository extends AuthorizedApiBase implements ISampleApiRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Load samples for a given growth run
     * @param growthId ID of the growth run, can be numeric (internal) ID or sample ID
     * @param projectIdOrLabel (optional) Optional, restrict to samples on that project
     * @param dataPackageId (optional) Optional, restrict to samples in that data package
     */
    getSamplesOnGrowthRun(growthId: string, projectIdOrLabel: string | null | undefined, dataPackageId: number | null | undefined): Promise<SampleDto[]> {
        let url_ = this.baseUrl + "/api/v1/samples/{growthId}/sub-samples?";
        if (growthId === undefined || growthId === null)
            throw new globalThis.Error("The parameter 'growthId' must be defined.");
        url_ = url_.replace("{growthId}", encodeURIComponent("" + growthId));
        if (projectIdOrLabel !== undefined && projectIdOrLabel !== null)
            url_ += "projectIdOrLabel=" + encodeURIComponent("" + projectIdOrLabel) + "&";
        if (dataPackageId !== undefined && dataPackageId !== null)
            url_ += "dataPackageId=" + encodeURIComponent("" + dataPackageId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSamplesOnGrowthRun(_response));
        });
    }

    protected processGetSamplesOnGrowthRun(response: Response): Promise<SampleDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleDto[]>(null as any);
    }

    /**
     * Get a sample by numeric or sampleID
     */
    get(idOrLabel: string): Promise<SampleDto> {
        let url_ = this.baseUrl + "/api/v1/samples/{idOrLabel}";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<SampleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleDto>(null as any);
    }

    /**
     * Update a sample
     */
    update(idOrLabel: string, model: SampleDto): Promise<SampleDto> {
        let url_ = this.baseUrl + "/api/v1/samples/{idOrLabel}";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<SampleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Invalid sample ID, no folder could be created with that name", status, _responseText, _headers, result422);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleDto>(null as any);
    }

    deletePending(idOrLabel: string, userHasConfirmed: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/samples/{idOrLabel}?";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        if (userHasConfirmed === null)
            throw new globalThis.Error("The parameter 'userHasConfirmed' cannot be null.");
        else if (userHasConfirmed !== undefined)
            url_ += "userHasConfirmed=" + encodeURIComponent("" + userHasConfirmed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeletePending(_response));
        });
    }

    protected processDeletePending(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result424);
            });
        } else if (status === 428) {
            return response.text().then((_responseText) => {
            let result428: any = null;
            result428 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result428);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getActivities(idOrLabel: string, charTechnique: string | null | undefined, syn: string | null | undefined): Promise<SampleActivityDto[]> {
        let url_ = this.baseUrl + "/api/v1/samples/{idOrLabel}/activities?";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        if (charTechnique !== undefined && charTechnique !== null)
            url_ += "charTechnique=" + encodeURIComponent("" + charTechnique) + "&";
        if (syn !== undefined && syn !== null)
            url_ += "syn=" + encodeURIComponent("" + syn) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetActivities(_response));
        });
    }

    protected processGetActivities(response: Response): Promise<SampleActivityDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleActivityDto[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleActivityDto[]>(null as any);
    }

    getActivity(idOrLabel: string, activityId: number): Promise<SampleDto> {
        let url_ = this.baseUrl + "/api/v1/samples/{idOrLabel}/activities/{activityId}";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetActivity(_response));
        });
    }

    protected processGetActivity(response: Response): Promise<SampleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleDto;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleDto>(null as any);
    }

    /**
     * Checks whether the given file ids exist and are accessible for the sample. Returns (fileId, exists) pairs.
     * @param idOrLabel Sample ID or label.
     * @param fileIds (optional) Comma-separated file ids to check.
     * @deprecated
     */
    checkFile(idOrLabel: string, fileIds: string | null | undefined): Promise<FileCheckDto[]> {
        let url_ = this.baseUrl + "/api/v1/samples/{idOrLabel}/check-file?";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        if (fileIds !== undefined && fileIds !== null)
            url_ += "fileIds=" + encodeURIComponent("" + fileIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckFile(_response));
        });
    }

    protected processCheckFile(response: Response): Promise<FileCheckDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileCheckDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileCheckDto[]>(null as any);
    }

    /**
     * Updates file metadata for a logical file group. Same body as legacy PUT …/files.
     */
    updateFileGroup(idOrLabel: string, dto: FileMetaDataCreateOrUpdateRequest): Promise<FileMetaDataDto> {
        let url_ = this.baseUrl + "/api/v1/samples/{idOrLabel}/file-groups";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateFileGroup(_response));
        });
    }

    protected processUpdateFileGroup(response: Response): Promise<FileMetaDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto>(null as any);
    }

    /**
     * Returns file metadata groups attached to the sample.
     */
    getFileGroups(idOrLabel: string): Promise<FileMetaDataDto[]> {
        let url_ = this.baseUrl + "/api/v1/samples/{idOrLabel}/file-groups";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFileGroups(_response));
        });
    }

    protected processGetFileGroups(response: Response): Promise<FileMetaDataDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto[]>(null as any);
    }

    /**
     * Deletes every stored format in a logical file group on the sample.
     */
    deleteFileGroup(idOrLabel: string, fileGroupId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/samples/{idOrLabel}/file-groups/{fileGroupId}";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        if (fileGroupId === undefined || fileGroupId === null)
            throw new globalThis.Error("The parameter 'fileGroupId' must be defined.");
        url_ = url_.replace("{fileGroupId}", encodeURIComponent("" + fileGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteFileGroup(_response));
        });
    }

    protected processDeleteFileGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Updates file metadata for a file group on a sample. Send id or basename to identify the group.
     * @param idOrLabel Sample ID or label.
     * @param dto Writable metadata; identify the file group by id or basename (see GET files response).
     * @deprecated
     */
    updateFile(idOrLabel: string, dto: FileMetaDataCreateOrUpdateRequest): Promise<FileMetaDataDto> {
        let url_ = this.baseUrl + "/api/v1/samples/{idOrLabel}/files";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateFile(_response));
        });
    }

    protected processUpdateFile(response: Response): Promise<FileMetaDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto>(null as any);
    }

    /**
     * Returns file metadata for all files attached to a sample (filtered by access).
     * @param idOrLabel Sample ID or label.
     * @deprecated
     */
    getFiles(idOrLabel: string): Promise<FileMetaDataDto[]> {
        let url_ = this.baseUrl + "/api/v1/samples/{idOrLabel}/files";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFiles(_response));
        });
    }

    protected processGetFiles(response: Response): Promise<FileMetaDataDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto[]>(null as any);
    }

    /**
     * Uploads a file to a sample (FineUploader format). Returns success/error result for the upload widget.
     * @param idOrLabel Sample ID or label.
     * @param file File payload via FineUploadBinder.
     * @deprecated
     */
    uploadFile(idOrLabel: string, file: FineUploadFileDto): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/samples/{idOrLabel}/files";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(file);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadFile(_response));
        });
    }

    protected processUploadFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Raw file bytes (Content-Disposition: attachment), not a FileDto JSON body.
     * @param fileId File id.
     * @param idOrLabel Sample ID or label.
     */
    getFile(fileId: number, idOrLabel: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/samples/{idOrLabel}/files/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFile(_response));
        });
    }

    protected processGetFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param fileId File id.
     * @param idOrLabel Sample ID or label.
     */
    deleteFile(fileId: number, idOrLabel: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/samples/{idOrLabel}/files/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteFile(_response));
        });
    }

    protected processDeleteFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Checks physical file ids for the sample (same query as legacy check-file).
     * @param fileIds (optional) 
     */
    checkFilesUnderFilesRoute(idOrLabel: string, fileIds: string | null | undefined): Promise<FileCheckDto[]> {
        let url_ = this.baseUrl + "/api/v1/samples/{idOrLabel}/files/check?";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        if (fileIds !== undefined && fileIds !== null)
            url_ += "fileIds=" + encodeURIComponent("" + fileIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckFilesUnderFilesRoute(_response));
        });
    }

    protected processCheckFilesUnderFilesRoute(response: Response): Promise<FileCheckDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileCheckDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileCheckDto[]>(null as any);
    }

    /**
     * Upload a file to a sample via multipart form. Returns the created file metadata on success.
    Preferred over the legacy POST .../files endpoint (Fine Uploader only).
     * @param idOrLabel Sample ID or label.
     * @param uploadFile (optional) 
     * @param description (optional) 
     * @param visibility (optional) 
     * @param fields (optional) 
     */
    uploadSampleFileForm(idOrLabel: string, uploadFile: FileParameter | undefined, description: string | null | undefined, visibility: VisibilityDto | null | undefined, fields: FileMetaDataFieldWriteRequest[] | null | undefined): Promise<FileMetaDataDto> {
        let url_ = this.baseUrl + "/api/v1/samples/{idOrLabel}/files/upload";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (uploadFile === null || uploadFile === undefined)
            throw new globalThis.Error("The parameter 'uploadFile' cannot be null.");
        else
            content_.append("UploadFile", uploadFile.data, uploadFile.fileName ? uploadFile.fileName : "UploadFile");
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (visibility !== null && visibility !== undefined)
            content_.append("Visibility", visibility.toString());
        if (fields !== null && fields !== undefined)
            fields.forEach(item_ => content_.append("Fields", item_.toString()));

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadSampleFileForm(_response));
        });
    }

    protected processUploadSampleFileForm(response: Response): Promise<FileMetaDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto>(null as any);
    }

    createFolderLink(idOrLabel: string, anonymousLink: boolean | null | undefined): Promise<FolderShareLink> {
        let url_ = this.baseUrl + "/api/v1/samples/{idOrLabel}/getLink?";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        if (anonymousLink !== undefined && anonymousLink !== null)
            url_ += "anonymousLink=" + encodeURIComponent("" + anonymousLink) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateFolderLink(_response));
        });
    }

    protected processCreateFolderLink(response: Response): Promise<FolderShareLink> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FolderShareLink;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FolderShareLink>(null as any);
    }

    /**
     * Returns an image file for a sample inline (e.g. for display in browser).
     * @param idOrLabel Sample ID or label.
     * @param fileId File id.
     */
    getImage(idOrLabel: string, fileId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/samples/{idOrLabel}/images/{fileId}";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetImage(_response));
        });
    }

    protected processGetImage(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Replaces/saves all notes for a sample. Returns the saved notes (filtered by auth).
     * @param idOrLabel Sample ID or label.
     * @param dtos Notes to save; existing by ID, new with ID 0 or omitted.
     */
    saveNotes(idOrLabel: string, dtos: NoteDto[]): Promise<NoteDto[]> {
        let url_ = this.baseUrl + "/api/v1/samples/{idOrLabel}/notes";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dtos);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveNotes(_response));
        });
    }

    protected processSaveNotes(response: Response): Promise<NoteDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NoteDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoteDto[]>(null as any);
    }

    /**
     * Returns notes for a sample, filtered by the current user's access.
     * @param idOrLabel Sample ID or label.
     */
    getNotes(idOrLabel: string): Promise<NoteDto[]> {
        let url_ = this.baseUrl + "/api/v1/samples/{idOrLabel}/notes";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetNotes(_response));
        });
    }

    protected processGetNotes(response: Response): Promise<NoteDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NoteDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoteDto[]>(null as any);
    }

    /**
     * Deletes a note from a sample. Caller must be allowed to delete the note (e.g. owner).
     * @param idOrLabel Sample ID or label.
     * @param noteId Note id.
     */
    deleteNote(idOrLabel: string, noteId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/samples/{idOrLabel}/notes/{noteId}";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        if (noteId === undefined || noteId === null)
            throw new globalThis.Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteNote(_response));
        });
    }

    protected processDeleteNote(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Sets the reporting category on a sample. Uses the standard sample update authorization path
    (same semantics as updating the sample via PUT, but only changes the reporting category foreign key).
     */
    assignReportingCategoryToSample(idOrLabel: string, categoryId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/samples/{idOrLabel}/reporting-category/{categoryId}";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        if (categoryId === undefined || categoryId === null)
            throw new globalThis.Error("The parameter 'categoryId' must be defined.");
        url_ = url_.replace("{categoryId}", encodeURIComponent("" + categoryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAssignReportingCategoryToSample(_response));
        });
    }

    protected processAssignReportingCategoryToSample(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    resetPending(idOrLabel: string): Promise<SampleDto> {
        let url_ = this.baseUrl + "/api/v1/samples/{idOrLabel}/reset";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processResetPending(_response));
        });
    }

    protected processResetPending(response: Response): Promise<SampleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleDto>(null as any);
    }

    addSampleToGrowthRun(idOrLabel: string, sampleAsSubstrate: string | null | undefined): Promise<SampleDto> {
        let url_ = this.baseUrl + "/api/v1/samples/{idOrLabel}/sub-samples?";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        if (sampleAsSubstrate !== undefined && sampleAsSubstrate !== null)
            url_ += "sampleAsSubstrate=" + encodeURIComponent("" + sampleAsSubstrate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddSampleToGrowthRun(_response));
        });
    }

    protected processAddSampleToGrowthRun(response: Response): Promise<SampleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleDto>(null as any);
    }

    addSubSample(idOrLabel: string, subSample: string | null | undefined): Promise<SampleDto> {
        let url_ = this.baseUrl + "/api/v1/samples/{idOrLabel}/sub-samples?";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        if (subSample !== undefined && subSample !== null)
            url_ += "subSample=" + encodeURIComponent("" + subSample) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddSubSample(_response));
        });
    }

    protected processAddSubSample(response: Response): Promise<SampleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleDto>(null as any);
    }

    submit(idOrLabel: string, userHasConfirmed: boolean | undefined): Promise<SampleDto> {
        let url_ = this.baseUrl + "/api/v1/samples/{idOrLabel}/submit?";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        if (userHasConfirmed === null)
            throw new globalThis.Error("The parameter 'userHasConfirmed' cannot be null.");
        else if (userHasConfirmed !== undefined)
            url_ += "userHasConfirmed=" + encodeURIComponent("" + userHasConfirmed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSubmit(_response));
        });
    }

    protected processSubmit(response: Response): Promise<SampleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleDto;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result424);
            });
        } else if (status === 428) {
            return response.text().then((_responseText) => {
            let result428: any = null;
            result428 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result428);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleDto>(null as any);
    }

    transfer(idOrLabel: string, withoutActivity: boolean | undefined, targetLabels: string[]): Promise<number[]> {
        let url_ = this.baseUrl + "/api/v1/samples/{idOrLabel}/transfer?";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        if (withoutActivity === null)
            throw new globalThis.Error("The parameter 'withoutActivity' cannot be null.");
        else if (withoutActivity !== undefined)
            url_ += "withoutActivity=" + encodeURIComponent("" + withoutActivity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(targetLabels);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processTransfer(_response));
        });
    }

    protected processTransfer(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }

    /**
     * Splits a sample into a given number of pieces, or create new pieces if there are already pieces.
     * @param sampleId The ID of the sample to split.
     * @param nbOfPiece (optional) The number of pieces to split the sample into. Must be greater than 0
     */
    split(sampleId: number, nbOfPiece: number | undefined): Promise<SampleDto[]> {
        let url_ = this.baseUrl + "/api/v1/samples/{sampleId}/split?";
        if (sampleId === undefined || sampleId === null)
            throw new globalThis.Error("The parameter 'sampleId' must be defined.");
        url_ = url_.replace("{sampleId}", encodeURIComponent("" + sampleId));
        if (nbOfPiece === null)
            throw new globalThis.Error("The parameter 'nbOfPiece' cannot be null.");
        else if (nbOfPiece !== undefined)
            url_ += "nbOfPiece=" + encodeURIComponent("" + nbOfPiece) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSplit(_response));
        });
    }

    protected processSplit(response: Response): Promise<SampleDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleDto[]>(null as any);
    }

    getAccessRights(idOrLabel: string): Promise<PrivilegeDto[]> {
        let url_ = this.baseUrl + "/api/v1/samples/access-rights/{idOrLabel}";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAccessRights(_response));
        });
    }

    protected processGetAccessRights(response: Response): Promise<PrivilegeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PrivilegeDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PrivilegeDto[]>(null as any);
    }

    addToInventory(request: AddToInventoryRequest): Promise<AddToInventoryResponseDto> {
        let url_ = this.baseUrl + "/api/v1/samples/add-to-inventory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddToInventory(_response));
        });
    }

    protected processAddToInventory(response: Response): Promise<AddToInventoryResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddToInventoryResponseDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddToInventoryResponseDto>(null as any);
    }

    addToInventoryVaried(request: AddToInventoryVariedRequest): Promise<AddToInventoryResponseDto> {
        let url_ = this.baseUrl + "/api/v1/samples/add-to-inventory-varied";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddToInventoryVaried(_response));
        });
    }

    protected processAddToInventoryVaried(response: Response): Promise<AddToInventoryResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddToInventoryResponseDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddToInventoryResponseDto>(null as any);
    }

    addToInventoryVariedWithImages(sampleDataJson: string | null | undefined, uploadFiles: FileParameter[] | null | undefined, imageSpecimenIndexes: number[] | null | undefined): Promise<AddToInventoryResponseDto> {
        let url_ = this.baseUrl + "/api/v1/samples/add-to-inventory-varied-with-images";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (sampleDataJson !== null && sampleDataJson !== undefined)
            content_.append("SampleDataJson", sampleDataJson.toString());
        if (uploadFiles !== null && uploadFiles !== undefined)
            uploadFiles.forEach(item_ => content_.append("UploadFiles", item_.data, item_.fileName ? item_.fileName : "UploadFiles") );
        if (imageSpecimenIndexes !== null && imageSpecimenIndexes !== undefined)
            imageSpecimenIndexes.forEach(item_ => content_.append("ImageSpecimenIndexes", item_.toString()));

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddToInventoryVariedWithImages(_response));
        });
    }

    protected processAddToInventoryVariedWithImages(response: Response): Promise<AddToInventoryResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddToInventoryResponseDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddToInventoryResponseDto>(null as any);
    }

    addToInventoryWithImage(uploadFile: FileParameter | undefined, sampleDataJson: string | null | undefined): Promise<AddToInventoryResponseDto> {
        let url_ = this.baseUrl + "/api/v1/samples/add-to-inventory-with-image";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (uploadFile === null || uploadFile === undefined)
            throw new globalThis.Error("The parameter 'uploadFile' cannot be null.");
        else
            content_.append("UploadFile", uploadFile.data, uploadFile.fileName ? uploadFile.fileName : "UploadFile");
        if (sampleDataJson !== null && sampleDataJson !== undefined)
            content_.append("SampleDataJson", sampleDataJson.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddToInventoryWithImage(_response));
        });
    }

    protected processAddToInventoryWithImage(response: Response): Promise<AddToInventoryResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AddToInventoryResponseDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AddToInventoryResponseDto>(null as any);
    }

    /**
     * Create a new sample by combining one or more starting-material samples.
    This creates both the sample and an initial processing activity (synthesis or preparation).
    Starting materials can be specified as numeric IDs ("123") or labels ("S12345") in any combination.
    Labels are recommended for scripting as they're stable across environments.
     */
    combineStartingMaterials(request: CombineStartingMaterialsRequest): Promise<SampleDto> {
        let url_ = this.baseUrl + "/api/v1/samples/combine-starting-materials";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCombineStartingMaterials(_response));
        });
    }

    protected processCombineStartingMaterials(response: Response): Promise<SampleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleDto>(null as any);
    }

    copy(request: SampleCopyRequest): Promise<SampleDto> {
        let url_ = this.baseUrl + "/api/v1/samples/copy";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCopy(_response));
        });
    }

    protected processCopy(response: Response): Promise<SampleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleDto>(null as any);
    }

    /**
     * @deprecated
     */
    createGrowth(request: SampleCreationRequest): Promise<SampleDto> {
        let url_ = this.baseUrl + "/api/v1/samples/create-growth";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateGrowth(_response));
        });
    }

    protected processCreateGrowth(response: Response): Promise<SampleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleDto>(null as any);
    }

    /**
     * Create a multi-sample growth run: one parent sample (run), one SYN processing activity,
    and for each substrate either an existing sample attached to the run or a new sample with add-to-inventory.
     */
    createMultiSampleGrowth(request: CreateMultiSampleGrowthRequest): Promise<SampleDto> {
        let url_ = this.baseUrl + "/api/v1/samples/create-multi-sample-growth";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateMultiSampleGrowth(_response));
        });
    }

    protected processCreateMultiSampleGrowth(response: Response): Promise<SampleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleDto>(null as any);
    }

    getDropdownChoices(technique: string | null | undefined, projectId: number | null | undefined): Promise<SampleDropdownChoicesDto> {
        let url_ = this.baseUrl + "/api/v1/samples/drop-down-choices?";
        if (technique !== undefined && technique !== null)
            url_ += "technique=" + encodeURIComponent("" + technique) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDropdownChoices(_response));
        });
    }

    protected processGetDropdownChoices(response: Response): Promise<SampleDropdownChoicesDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleDropdownChoicesDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleDropdownChoicesDto>(null as any);
    }

    /**
     * Returns whether a sample exists and the current user can read it. Always 200 with
    Exists true or false; does not throw 403/404.
     */
    exists(idOrLabel: string): Promise<ExistsResult> {
        let url_ = this.baseUrl + "/api/v1/samples/exist/{idOrLabel}";
        if (idOrLabel === undefined || idOrLabel === null)
            throw new globalThis.Error("The parameter 'idOrLabel' must be defined.");
        url_ = url_.replace("{idOrLabel}", encodeURIComponent("" + idOrLabel));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExists(_response));
        });
    }

    protected processExists(response: Response): Promise<ExistsResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExistsResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExistsResult>(null as any);
    }

    /**
     * @deprecated
     */
    create(request: ExternalSampleCreationRequest): Promise<SampleDto> {
        let url_ = this.baseUrl + "/api/v1/samples/external";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<SampleDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleDto>(null as any);
    }

    getFreeLabel(prefix: string | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/samples/get-free-label?";
        if (prefix !== undefined && prefix !== null)
            url_ += "prefix=" + encodeURIComponent("" + prefix) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFreeLabel(_response));
        });
    }

    protected processGetFreeLabel(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    isLabelUsed(label: string | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/v1/samples/is-label-used?";
        if (label !== undefined && label !== null)
            url_ += "label=" + encodeURIComponent("" + label) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsLabelUsed(_response));
        });
    }

    protected processIsLabelUsed(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    listReportingCategories(includeUsage: boolean | undefined): Promise<ReportingCategoryDto[]> {
        let url_ = this.baseUrl + "/api/v1/samples/reporting-categories?";
        if (includeUsage === null)
            throw new globalThis.Error("The parameter 'includeUsage' cannot be null.");
        else if (includeUsage !== undefined)
            url_ += "includeUsage=" + encodeURIComponent("" + includeUsage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processListReportingCategories(_response));
        });
    }

    protected processListReportingCategories(response: Response): Promise<ReportingCategoryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportingCategoryDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportingCategoryDto[]>(null as any);
    }

    createReportingCategory(category: ReportingCategoryDto): Promise<ReportingCategoryDto> {
        let url_ = this.baseUrl + "/api/v1/samples/reporting-categories";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(category);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateReportingCategory(_response));
        });
    }

    protected processCreateReportingCategory(response: Response): Promise<ReportingCategoryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportingCategoryDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportingCategoryDto>(null as any);
    }

    updateReportingCategory(id: number, category: ReportingCategoryDto): Promise<ReportingCategoryDto> {
        let url_ = this.baseUrl + "/api/v1/samples/reporting-categories/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(category);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateReportingCategory(_response));
        });
    }

    protected processUpdateReportingCategory(response: Response): Promise<ReportingCategoryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportingCategoryDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportingCategoryDto>(null as any);
    }

    deleteReportingCategory(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/samples/reporting-categories/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteReportingCategory(_response));
        });
    }

    protected processDeleteReportingCategory(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Search for samples matching the given criteria.
     * @param sortColumn (optional) 
     * @param sortOrder (optional) 
     * @param start (optional) 
     * @param length (optional) 
     * @param draw (optional) 
     * @param criteria Search filters. Growth-run parent rows are never returned; the run label appears on child rows via
    ParentLabel. MultiSampleGrowthOnly
    toggles between all searchable samples (default) and growth-run child samples only.
     * @return Paged sample search results.
     */
    search(sortColumn: string | null | undefined, sortOrder: string | null | undefined, start: number | undefined, length: number | undefined, draw: number | undefined, criteria: SampleSearchCriteria): Promise<PagingResultOfSampleSearchResultDto> {
        let url_ = this.baseUrl + "/api/v1/samples/search?";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (length === null)
            throw new globalThis.Error("The parameter 'length' cannot be null.");
        else if (length !== undefined)
            url_ += "length=" + encodeURIComponent("" + length) + "&";
        if (draw === null)
            throw new globalThis.Error("The parameter 'draw' cannot be null.");
        else if (draw !== undefined)
            url_ += "draw=" + encodeURIComponent("" + draw) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(criteria);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearch(_response));
        });
    }

    protected processSearch(response: Response): Promise<PagingResultOfSampleSearchResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingResultOfSampleSearchResultDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingResultOfSampleSearchResultDto>(null as any);
    }

    addPieces(activityId: number | undefined, nbOfPiece: number | null | undefined): Promise<SampleDto[]> {
        let url_ = this.baseUrl + "/api/v1/samples/split?";
        if (activityId === null)
            throw new globalThis.Error("The parameter 'activityId' cannot be null.");
        else if (activityId !== undefined)
            url_ += "activityId=" + encodeURIComponent("" + activityId) + "&";
        if (nbOfPiece !== undefined && nbOfPiece !== null)
            url_ += "nbOfPiece=" + encodeURIComponent("" + nbOfPiece) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddPieces(_response));
        });
    }

    protected processAddPieces(response: Response): Promise<SampleDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleDto[]>(null as any);
    }

    getUsedInstruments(projectId: number | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/samples/used-instruments?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUsedInstruments(_response));
        });
    }

    protected processGetUsedInstruments(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getUsedMaterials(projectId: number | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/samples/used-materials?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUsedMaterials(_response));
        });
    }

    protected processGetUsedMaterials(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export interface IShippingApiRepository {

    create(request: ShippingRequest): Promise<ShippingDto>;

    /**
     * Gets a shipping by ID
     * @param id The shipping ID
     * @return Returns the shipping
     */
    read(id: number): Promise<ShippingDto>;

    update(id: number, request: ShippingRequest): Promise<ShippingDto>;

    /**
     * Deletes a shipping
     * @param id The shipping ID to delete
     * @return No content on success
     */
    delete(id: number): Promise<FileResponse>;

    createFolderLink(id: number): Promise<FolderShareLink>;

    resetPending(id: number): Promise<ShippingDto>;

    getSamples(id: number): Promise<SampleDto[]>;

    shipped(id: number): Promise<ShippingDto>;

    /**
     * Submits a shipping for processing
     * @param id The shipping ID to submit
     * @return Shipping submitted successfully
     */
    submit(id: number): Promise<ShippingDto>;

    /**
     * Checks whether the given file ids exist and are accessible for the shipping. Returns (fileId, exists) pairs.
     * @param shippingId Shipping id.
     * @param fileIds (optional) Comma-separated file ids to check.
     * @deprecated
     */
    checkFile(shippingId: number, fileIds: string | null | undefined): Promise<FileCheckDto[]>;

    /**
     * Updates file metadata for a logical file group. Same body as legacy PUT …/files.
     */
    updateFileGroup(shippingId: number, dto: FileMetaDataCreateOrUpdateRequest): Promise<FileMetaDataDto>;

    /**
     * Returns logical file groups attached to a shipping (filtered by access).
     */
    getFileGroups(shippingId: number): Promise<FileMetaDataDto[]>;

    /**
     * Deletes every stored format in a logical file group on the shipping.
     */
    deleteFileGroup(shippingId: number, fileGroupId: number): Promise<void>;

    /**
     * Legacy file upload using Fine Uploader request body. Prefer UploadShippingFileForm (multipart form).
    Uploads a file to a shipping (FineUploader format). Returns success/error result for the upload widget.
     * @param shippingId Shipping id.
     * @param file File payload via FineUploadBinder.
     * @deprecated
     */
    uploadFile(shippingId: number, file: FineUploadFileDto): Promise<FileResponse>;

    /**
     * Updates file metadata for a file group on a shipping. Send id or basename to identify the group.
     * @param shippingId Shipping id.
     * @param dto Writable metadata; identify the file group by id or basename (see GET files response).
     * @deprecated
     */
    updateFile(shippingId: number, dto: FileMetaDataCreateOrUpdateRequest): Promise<FileMetaDataDto>;

    /**
     * Returns file metadata for all files attached to a shipping (filtered by access).
     * @param shippingId Shipping id.
     * @deprecated
     */
    getFiles(shippingId: number): Promise<FileMetaDataDto[]>;

    /**
     * Raw file bytes (Content-Disposition: attachment), not a FileDto JSON body.
    May return 410 if file no longer exists in storage.
     * @param fileId File id.
     * @param shippingId Shipping id.
     */
    getFile(fileId: number, shippingId: number): Promise<FileResponse>;

    /**
     * Deletes a file attached to a shipping.
     * @param fileId File id.
     * @param shippingId Shipping id.
     */
    deleteFile(fileId: number, shippingId: number): Promise<void>;

    /**
     * Checks physical file ids for the shipping (same query as legacy check-file).
     * @param fileIds (optional) 
     */
    checkFilesUnderFilesRoute(shippingId: number, fileIds: string | null | undefined): Promise<FileCheckDto[]>;

    /**
     * Upload a file to a shipping via multipart form. Returns the created file metadata on success.
    Preferred over the legacy POST .../files endpoint (Fine Uploader only).
     * @param uploadFile (optional) 
     * @param description (optional) 
     * @param visibility (optional) 
     * @param fields (optional) 
     */
    uploadShippingFileForm(shippingId: number, uploadFile: FileParameter | undefined, description: string | null | undefined, visibility: VisibilityDto | null | undefined, fields: FileMetaDataFieldWriteRequest[] | null | undefined): Promise<FileMetaDataDto>;

    /**
     * Returns an image file for a shipping inline (e.g. for display in browser).
     * @param shippingId Shipping id.
     * @param fileId File id.
     */
    getImage(shippingId: number, fileId: number): Promise<FileResponse>;

    getContactDetails(projectId: number | undefined, contactName: string | null | undefined): Promise<ShippingContactDto>;

    /**
     * Returns whether a shipping exists and the current user can read it. Always 200 with
    Exists true or false; does not throw 403/404.
     */
    exists(id: number): Promise<ExistsResult>;

    getLabelTypes(): Promise<string[]>;

    getReturnAddress(): Promise<string>;

    /**
     * Search for shippings
     * @param sortColumn (optional) Column to sort by
     * @param sortOrder (optional) Sort order (Asc/Desc)
     * @param start (optional) Offset
     * @param length (optional) Maximum number of shippings to return
     * @param draw (optional) Draw counter for DataTables
     * @param criteria Search Criteria
     */
    search(sortColumn: string | null | undefined, sortOrder: string | null | undefined, start: number | undefined, length: number | undefined, draw: number | undefined, criteria: ShippingSearchCriteriaDto): Promise<PagingResultOfShippingDto>;

    getShippingTypes(): Promise<string[]>;
}

export class ShippingApiRepository extends AuthorizedApiBase implements IShippingApiRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    create(request: ShippingRequest): Promise<ShippingDto> {
        let url_ = this.baseUrl + "/api/v1/shippings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<ShippingDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ShippingDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShippingDto>(null as any);
    }

    /**
     * Gets a shipping by ID
     * @param id The shipping ID
     * @return Returns the shipping
     */
    read(id: number): Promise<ShippingDto> {
        let url_ = this.baseUrl + "/api/v1/shippings/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRead(_response));
        });
    }

    protected processRead(response: Response): Promise<ShippingDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ShippingDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShippingDto>(null as any);
    }

    update(id: number, request: ShippingRequest): Promise<ShippingDto> {
        let url_ = this.baseUrl + "/api/v1/shippings/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<ShippingDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ShippingDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShippingDto>(null as any);
    }

    /**
     * Deletes a shipping
     * @param id The shipping ID to delete
     * @return No content on success
     */
    delete(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/shippings/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    createFolderLink(id: number): Promise<FolderShareLink> {
        let url_ = this.baseUrl + "/api/v1/shippings/{id}/getLink";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateFolderLink(_response));
        });
    }

    protected processCreateFolderLink(response: Response): Promise<FolderShareLink> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FolderShareLink;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FolderShareLink>(null as any);
    }

    resetPending(id: number): Promise<ShippingDto> {
        let url_ = this.baseUrl + "/api/v1/shippings/{id}/reset";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processResetPending(_response));
        });
    }

    protected processResetPending(response: Response): Promise<ShippingDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ShippingDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShippingDto>(null as any);
    }

    getSamples(id: number): Promise<SampleDto[]> {
        let url_ = this.baseUrl + "/api/v1/shippings/{id}/samples";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSamples(_response));
        });
    }

    protected processGetSamples(response: Response): Promise<SampleDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SampleDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SampleDto[]>(null as any);
    }

    shipped(id: number): Promise<ShippingDto> {
        let url_ = this.baseUrl + "/api/v1/shippings/{id}/shipped";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processShipped(_response));
        });
    }

    protected processShipped(response: Response): Promise<ShippingDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ShippingDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShippingDto>(null as any);
    }

    /**
     * Submits a shipping for processing
     * @param id The shipping ID to submit
     * @return Shipping submitted successfully
     */
    submit(id: number): Promise<ShippingDto> {
        let url_ = this.baseUrl + "/api/v1/shippings/{id}/submit";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSubmit(_response));
        });
    }

    protected processSubmit(response: Response): Promise<ShippingDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ShippingDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShippingDto>(null as any);
    }

    /**
     * Checks whether the given file ids exist and are accessible for the shipping. Returns (fileId, exists) pairs.
     * @param shippingId Shipping id.
     * @param fileIds (optional) Comma-separated file ids to check.
     * @deprecated
     */
    checkFile(shippingId: number, fileIds: string | null | undefined): Promise<FileCheckDto[]> {
        let url_ = this.baseUrl + "/api/v1/shippings/{shippingId}/check-file?";
        if (shippingId === undefined || shippingId === null)
            throw new globalThis.Error("The parameter 'shippingId' must be defined.");
        url_ = url_.replace("{shippingId}", encodeURIComponent("" + shippingId));
        if (fileIds !== undefined && fileIds !== null)
            url_ += "fileIds=" + encodeURIComponent("" + fileIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckFile(_response));
        });
    }

    protected processCheckFile(response: Response): Promise<FileCheckDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileCheckDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileCheckDto[]>(null as any);
    }

    /**
     * Updates file metadata for a logical file group. Same body as legacy PUT …/files.
     */
    updateFileGroup(shippingId: number, dto: FileMetaDataCreateOrUpdateRequest): Promise<FileMetaDataDto> {
        let url_ = this.baseUrl + "/api/v1/shippings/{shippingId}/file-groups";
        if (shippingId === undefined || shippingId === null)
            throw new globalThis.Error("The parameter 'shippingId' must be defined.");
        url_ = url_.replace("{shippingId}", encodeURIComponent("" + shippingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateFileGroup(_response));
        });
    }

    protected processUpdateFileGroup(response: Response): Promise<FileMetaDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto>(null as any);
    }

    /**
     * Returns logical file groups attached to a shipping (filtered by access).
     */
    getFileGroups(shippingId: number): Promise<FileMetaDataDto[]> {
        let url_ = this.baseUrl + "/api/v1/shippings/{shippingId}/file-groups";
        if (shippingId === undefined || shippingId === null)
            throw new globalThis.Error("The parameter 'shippingId' must be defined.");
        url_ = url_.replace("{shippingId}", encodeURIComponent("" + shippingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFileGroups(_response));
        });
    }

    protected processGetFileGroups(response: Response): Promise<FileMetaDataDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto[]>(null as any);
    }

    /**
     * Deletes every stored format in a logical file group on the shipping.
     */
    deleteFileGroup(shippingId: number, fileGroupId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/shippings/{shippingId}/file-groups/{fileGroupId}";
        if (shippingId === undefined || shippingId === null)
            throw new globalThis.Error("The parameter 'shippingId' must be defined.");
        url_ = url_.replace("{shippingId}", encodeURIComponent("" + shippingId));
        if (fileGroupId === undefined || fileGroupId === null)
            throw new globalThis.Error("The parameter 'fileGroupId' must be defined.");
        url_ = url_.replace("{fileGroupId}", encodeURIComponent("" + fileGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteFileGroup(_response));
        });
    }

    protected processDeleteFileGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Legacy file upload using Fine Uploader request body. Prefer UploadShippingFileForm (multipart form).
    Uploads a file to a shipping (FineUploader format). Returns success/error result for the upload widget.
     * @param shippingId Shipping id.
     * @param file File payload via FineUploadBinder.
     * @deprecated
     */
    uploadFile(shippingId: number, file: FineUploadFileDto): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/shippings/{shippingId}/files";
        if (shippingId === undefined || shippingId === null)
            throw new globalThis.Error("The parameter 'shippingId' must be defined.");
        url_ = url_.replace("{shippingId}", encodeURIComponent("" + shippingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(file);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadFile(_response));
        });
    }

    protected processUploadFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Updates file metadata for a file group on a shipping. Send id or basename to identify the group.
     * @param shippingId Shipping id.
     * @param dto Writable metadata; identify the file group by id or basename (see GET files response).
     * @deprecated
     */
    updateFile(shippingId: number, dto: FileMetaDataCreateOrUpdateRequest): Promise<FileMetaDataDto> {
        let url_ = this.baseUrl + "/api/v1/shippings/{shippingId}/files";
        if (shippingId === undefined || shippingId === null)
            throw new globalThis.Error("The parameter 'shippingId' must be defined.");
        url_ = url_.replace("{shippingId}", encodeURIComponent("" + shippingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateFile(_response));
        });
    }

    protected processUpdateFile(response: Response): Promise<FileMetaDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto>(null as any);
    }

    /**
     * Returns file metadata for all files attached to a shipping (filtered by access).
     * @param shippingId Shipping id.
     * @deprecated
     */
    getFiles(shippingId: number): Promise<FileMetaDataDto[]> {
        let url_ = this.baseUrl + "/api/v1/shippings/{shippingId}/files";
        if (shippingId === undefined || shippingId === null)
            throw new globalThis.Error("The parameter 'shippingId' must be defined.");
        url_ = url_.replace("{shippingId}", encodeURIComponent("" + shippingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFiles(_response));
        });
    }

    protected processGetFiles(response: Response): Promise<FileMetaDataDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto[]>(null as any);
    }

    /**
     * Raw file bytes (Content-Disposition: attachment), not a FileDto JSON body.
    May return 410 if file no longer exists in storage.
     * @param fileId File id.
     * @param shippingId Shipping id.
     */
    getFile(fileId: number, shippingId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/shippings/{shippingId}/files/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        if (shippingId === undefined || shippingId === null)
            throw new globalThis.Error("The parameter 'shippingId' must be defined.");
        url_ = url_.replace("{shippingId}", encodeURIComponent("" + shippingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFile(_response));
        });
    }

    protected processGetFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 410) {
            return response.text().then((_responseText) => {
            let result410: any = null;
            result410 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result410);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Deletes a file attached to a shipping.
     * @param fileId File id.
     * @param shippingId Shipping id.
     */
    deleteFile(fileId: number, shippingId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/shippings/{shippingId}/files/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        if (shippingId === undefined || shippingId === null)
            throw new globalThis.Error("The parameter 'shippingId' must be defined.");
        url_ = url_.replace("{shippingId}", encodeURIComponent("" + shippingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteFile(_response));
        });
    }

    protected processDeleteFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Checks physical file ids for the shipping (same query as legacy check-file).
     * @param fileIds (optional) 
     */
    checkFilesUnderFilesRoute(shippingId: number, fileIds: string | null | undefined): Promise<FileCheckDto[]> {
        let url_ = this.baseUrl + "/api/v1/shippings/{shippingId}/files/check?";
        if (shippingId === undefined || shippingId === null)
            throw new globalThis.Error("The parameter 'shippingId' must be defined.");
        url_ = url_.replace("{shippingId}", encodeURIComponent("" + shippingId));
        if (fileIds !== undefined && fileIds !== null)
            url_ += "fileIds=" + encodeURIComponent("" + fileIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckFilesUnderFilesRoute(_response));
        });
    }

    protected processCheckFilesUnderFilesRoute(response: Response): Promise<FileCheckDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileCheckDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileCheckDto[]>(null as any);
    }

    /**
     * Upload a file to a shipping via multipart form. Returns the created file metadata on success.
    Preferred over the legacy POST .../files endpoint (Fine Uploader only).
     * @param uploadFile (optional) 
     * @param description (optional) 
     * @param visibility (optional) 
     * @param fields (optional) 
     */
    uploadShippingFileForm(shippingId: number, uploadFile: FileParameter | undefined, description: string | null | undefined, visibility: VisibilityDto | null | undefined, fields: FileMetaDataFieldWriteRequest[] | null | undefined): Promise<FileMetaDataDto> {
        let url_ = this.baseUrl + "/api/v1/shippings/{shippingId}/files/upload";
        if (shippingId === undefined || shippingId === null)
            throw new globalThis.Error("The parameter 'shippingId' must be defined.");
        url_ = url_.replace("{shippingId}", encodeURIComponent("" + shippingId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (uploadFile === null || uploadFile === undefined)
            throw new globalThis.Error("The parameter 'uploadFile' cannot be null.");
        else
            content_.append("UploadFile", uploadFile.data, uploadFile.fileName ? uploadFile.fileName : "UploadFile");
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (visibility !== null && visibility !== undefined)
            content_.append("Visibility", visibility.toString());
        if (fields !== null && fields !== undefined)
            fields.forEach(item_ => content_.append("Fields", item_.toString()));

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadShippingFileForm(_response));
        });
    }

    protected processUploadShippingFileForm(response: Response): Promise<FileMetaDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto>(null as any);
    }

    /**
     * Returns an image file for a shipping inline (e.g. for display in browser).
     * @param shippingId Shipping id.
     * @param fileId File id.
     */
    getImage(shippingId: number, fileId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/shippings/{shippingId}/images/{fileId}";
        if (shippingId === undefined || shippingId === null)
            throw new globalThis.Error("The parameter 'shippingId' must be defined.");
        url_ = url_.replace("{shippingId}", encodeURIComponent("" + shippingId));
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetImage(_response));
        });
    }

    protected processGetImage(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 410) {
            return response.text().then((_responseText) => {
            let result410: any = null;
            result410 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result410);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getContactDetails(projectId: number | undefined, contactName: string | null | undefined): Promise<ShippingContactDto> {
        let url_ = this.baseUrl + "/api/v1/shippings/contact-details?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        if (contactName !== undefined && contactName !== null)
            url_ += "contactName=" + encodeURIComponent("" + contactName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetContactDetails(_response));
        });
    }

    protected processGetContactDetails(response: Response): Promise<ShippingContactDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ShippingContactDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShippingContactDto>(null as any);
    }

    /**
     * Returns whether a shipping exists and the current user can read it. Always 200 with
    Exists true or false; does not throw 403/404.
     */
    exists(id: number): Promise<ExistsResult> {
        let url_ = this.baseUrl + "/api/v1/shippings/exists/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExists(_response));
        });
    }

    protected processExists(response: Response): Promise<ExistsResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExistsResult;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExistsResult>(null as any);
    }

    getLabelTypes(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/shippings/labels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLabelTypes(_response));
        });
    }

    protected processGetLabelTypes(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getReturnAddress(): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/shippings/return-address";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetReturnAddress(_response));
        });
    }

    protected processGetReturnAddress(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Search for shippings
     * @param sortColumn (optional) Column to sort by
     * @param sortOrder (optional) Sort order (Asc/Desc)
     * @param start (optional) Offset
     * @param length (optional) Maximum number of shippings to return
     * @param draw (optional) Draw counter for DataTables
     * @param criteria Search Criteria
     */
    search(sortColumn: string | null | undefined, sortOrder: string | null | undefined, start: number | undefined, length: number | undefined, draw: number | undefined, criteria: ShippingSearchCriteriaDto): Promise<PagingResultOfShippingDto> {
        let url_ = this.baseUrl + "/api/v1/shippings/search?";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (length === null)
            throw new globalThis.Error("The parameter 'length' cannot be null.");
        else if (length !== undefined)
            url_ += "length=" + encodeURIComponent("" + length) + "&";
        if (draw === null)
            throw new globalThis.Error("The parameter 'draw' cannot be null.");
        else if (draw !== undefined)
            url_ += "draw=" + encodeURIComponent("" + draw) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(criteria);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearch(_response));
        });
    }

    protected processSearch(response: Response): Promise<PagingResultOfShippingDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingResultOfShippingDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingResultOfShippingDto>(null as any);
    }

    getShippingTypes(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/v1/shippings/types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetShippingTypes(_response));
        });
    }

    protected processGetShippingTypes(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export interface ISimulationDatasetApiRepository {

    list(technique: string | null | undefined): Promise<SimulationDataSetDto[]>;

    uploadFile(uploadFile: FileParameter | undefined, metadata: string | null | undefined): Promise<SimulationDataSetDto>;

    delete(id: number): Promise<void>;

    update(id: number, dto: SimulationDataSetUpdateRequest): Promise<SimulationDataSetDto>;

    read(id: number): Promise<SimulationDataSetDto>;

    getFile(fileId: number, userId: string | null | undefined): Promise<FileResponse>;

    setDownloadUser(user: FileDownloadUser): Promise<string>;
}

export class SimulationDatasetApiRepository extends AuthorizedApiBase implements ISimulationDatasetApiRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    list(technique: string | null | undefined): Promise<SimulationDataSetDto[]> {
        let url_ = this.baseUrl + "/api/v1/simulation-dataset?";
        if (technique !== undefined && technique !== null)
            url_ += "technique=" + encodeURIComponent("" + technique) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<SimulationDataSetDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimulationDataSetDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimulationDataSetDto[]>(null as any);
    }

    uploadFile(uploadFile: FileParameter | undefined, metadata: string | null | undefined): Promise<SimulationDataSetDto> {
        let url_ = this.baseUrl + "/api/v1/simulation-dataset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (uploadFile === null || uploadFile === undefined)
            throw new globalThis.Error("The parameter 'uploadFile' cannot be null.");
        else
            content_.append("UploadFile", uploadFile.data, uploadFile.fileName ? uploadFile.fileName : "UploadFile");
        if (metadata !== null && metadata !== undefined)
            content_.append("Metadata", metadata.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadFile(_response));
        });
    }

    protected processUploadFile(response: Response): Promise<SimulationDataSetDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimulationDataSetDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimulationDataSetDto>(null as any);
    }

    delete(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/simulation-dataset/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    update(id: number, dto: SimulationDataSetUpdateRequest): Promise<SimulationDataSetDto> {
        let url_ = this.baseUrl + "/api/v1/simulation-dataset/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<SimulationDataSetDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimulationDataSetDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimulationDataSetDto>(null as any);
    }

    read(id: number): Promise<SimulationDataSetDto> {
        let url_ = this.baseUrl + "/api/v1/simulation-dataset/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRead(_response));
        });
    }

    protected processRead(response: Response): Promise<SimulationDataSetDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimulationDataSetDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimulationDataSetDto>(null as any);
    }

    getFile(fileId: number, userId: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/simulation-dataset/files/{fileId}?";
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        if (userId !== undefined && userId !== null)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFile(_response));
        });
    }

    protected processGetFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    setDownloadUser(user: FileDownloadUser): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/simulation-dataset/files/user";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(user);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSetDownloadUser(_response));
        });
    }

    protected processSetDownloadUser(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface ISubstrateApiRepository {

    list(): Promise<SubstrateDto[]>;

    getDropdownChoices(): Promise<SubstrateDropdownChoicesDto>;
}

export class SubstrateApiRepository extends AuthorizedApiBase implements ISubstrateApiRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    list(): Promise<SubstrateDto[]> {
        let url_ = this.baseUrl + "/api/v1/substrates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<SubstrateDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubstrateDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubstrateDto[]>(null as any);
    }

    getDropdownChoices(): Promise<SubstrateDropdownChoicesDto> {
        let url_ = this.baseUrl + "/api/v1/substrates/drop-down-choices";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDropdownChoices(_response));
        });
    }

    protected processGetDropdownChoices(response: Response): Promise<SubstrateDropdownChoicesDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SubstrateDropdownChoicesDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubstrateDropdownChoicesDto>(null as any);
    }
}

export interface ISynInstrumentTypeApiRepository {

    /**
     * Returns all synthesis instrument types.
     */
    list(): Promise<SynthesisInstrumentTypeDto[]>;

    /**
     * Creates a synthesis instrument type.
     */
    create(instrumentType: SynthesisInstrumentTypeDto): Promise<SynthesisInstrumentTypeDto>;

    /**
     * Updates a synthesis instrument type. Body ID must match route id.
     */
    update(id: string, instrumentType: SynthesisInstrumentTypeDto): Promise<SynthesisInstrumentTypeDto>;
}

export class SynInstrumentTypeApiRepository extends AuthorizedApiBase implements ISynInstrumentTypeApiRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Returns all synthesis instrument types.
     */
    list(): Promise<SynthesisInstrumentTypeDto[]> {
        let url_ = this.baseUrl + "/api/v1/synthesis-instrument-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<SynthesisInstrumentTypeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SynthesisInstrumentTypeDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SynthesisInstrumentTypeDto[]>(null as any);
    }

    /**
     * Creates a synthesis instrument type.
     */
    create(instrumentType: SynthesisInstrumentTypeDto): Promise<SynthesisInstrumentTypeDto> {
        let url_ = this.baseUrl + "/api/v1/synthesis-instrument-types";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(instrumentType);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<SynthesisInstrumentTypeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SynthesisInstrumentTypeDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SynthesisInstrumentTypeDto>(null as any);
    }

    /**
     * Updates a synthesis instrument type. Body ID must match route id.
     */
    update(id: string, instrumentType: SynthesisInstrumentTypeDto): Promise<SynthesisInstrumentTypeDto> {
        let url_ = this.baseUrl + "/api/v1/synthesis-instrument-types/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(instrumentType);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<SynthesisInstrumentTypeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SynthesisInstrumentTypeDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SynthesisInstrumentTypeDto>(null as any);
    }
}

export interface ISynInstrumentApiRepository {

    list(technique: string | null | undefined, exclude: boolean | null | undefined, loadDefaultConfig: boolean | undefined): Promise<SynthesisInstrumentDto[]>;

    create(instrument: SynthesisInstrumentDto): Promise<SynthesisInstrumentDto>;

    update(id: string, instrument: SynthesisInstrumentDto): Promise<SynthesisInstrumentDto>;

    /**
     * Lists instrument funding options. Allowed for SynthesisInstrument.List (dropdowns / instrument
    customizing) or InstrumentFunding Create/Delete (funding catalog management).
     * @param includeUsage (optional) 
     */
    listInstrumentFunding(includeUsage: boolean | undefined): Promise<InstrumentFundingDto[]>;

    createInstrumentFunding(funding: InstrumentFundingDto): Promise<InstrumentFundingDto>;

    deleteInstrumentFunding(id: number): Promise<void>;
}

export class SynInstrumentApiRepository extends AuthorizedApiBase implements ISynInstrumentApiRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    list(technique: string | null | undefined, exclude: boolean | null | undefined, loadDefaultConfig: boolean | undefined): Promise<SynthesisInstrumentDto[]> {
        let url_ = this.baseUrl + "/api/v1/synthesis-instruments?";
        if (technique !== undefined && technique !== null)
            url_ += "technique=" + encodeURIComponent("" + technique) + "&";
        if (exclude !== undefined && exclude !== null)
            url_ += "exclude=" + encodeURIComponent("" + exclude) + "&";
        if (loadDefaultConfig === null)
            throw new globalThis.Error("The parameter 'loadDefaultConfig' cannot be null.");
        else if (loadDefaultConfig !== undefined)
            url_ += "loadDefaultConfig=" + encodeURIComponent("" + loadDefaultConfig) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processList(_response));
        });
    }

    protected processList(response: Response): Promise<SynthesisInstrumentDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SynthesisInstrumentDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SynthesisInstrumentDto[]>(null as any);
    }

    create(instrument: SynthesisInstrumentDto): Promise<SynthesisInstrumentDto> {
        let url_ = this.baseUrl + "/api/v1/synthesis-instruments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(instrument);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<SynthesisInstrumentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SynthesisInstrumentDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SynthesisInstrumentDto>(null as any);
    }

    update(id: string, instrument: SynthesisInstrumentDto): Promise<SynthesisInstrumentDto> {
        let url_ = this.baseUrl + "/api/v1/synthesis-instruments/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(instrument);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<SynthesisInstrumentDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SynthesisInstrumentDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SynthesisInstrumentDto>(null as any);
    }

    /**
     * Lists instrument funding options. Allowed for SynthesisInstrument.List (dropdowns / instrument
    customizing) or InstrumentFunding Create/Delete (funding catalog management).
     * @param includeUsage (optional) 
     */
    listInstrumentFunding(includeUsage: boolean | undefined): Promise<InstrumentFundingDto[]> {
        let url_ = this.baseUrl + "/api/v1/synthesis-instruments/instrument-funding?";
        if (includeUsage === null)
            throw new globalThis.Error("The parameter 'includeUsage' cannot be null.");
        else if (includeUsage !== undefined)
            url_ += "includeUsage=" + encodeURIComponent("" + includeUsage) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processListInstrumentFunding(_response));
        });
    }

    protected processListInstrumentFunding(response: Response): Promise<InstrumentFundingDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InstrumentFundingDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentFundingDto[]>(null as any);
    }

    createInstrumentFunding(funding: InstrumentFundingDto): Promise<InstrumentFundingDto> {
        let url_ = this.baseUrl + "/api/v1/synthesis-instruments/instrument-funding";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(funding);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateInstrumentFunding(_response));
        });
    }

    protected processCreateInstrumentFunding(response: Response): Promise<InstrumentFundingDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InstrumentFundingDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InstrumentFundingDto>(null as any);
    }

    deleteInstrumentFunding(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/synthesis-instruments/instrument-funding/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteInstrumentFunding(_response));
        });
    }

    protected processDeleteInstrumentFunding(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ISynTechniqueApiRepository {

    /**
     * Lists synthesis techniques, optionally filtered by parent technique ID.
     * @param parentTechnique (optional) 
     */
    get(parentTechnique: string | null | undefined): Promise<SynthesisTechniqueDto[]>;

    /**
     * Creates a synthesis technique.
     */
    create(technique: SynthesisTechniqueDto): Promise<SynthesisTechniqueDto>;

    /**
     * Updates a synthesis technique. Route id must match body ID; parent must not equal self.
     */
    update(id: string, technique: SynthesisTechniqueDto): Promise<SynthesisTechniqueDto>;
}

export class SynTechniqueApiRepository extends AuthorizedApiBase implements ISynTechniqueApiRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Lists synthesis techniques, optionally filtered by parent technique ID.
     * @param parentTechnique (optional) 
     */
    get(parentTechnique: string | null | undefined): Promise<SynthesisTechniqueDto[]> {
        let url_ = this.baseUrl + "/api/v1/synthesis-techniques?";
        if (parentTechnique !== undefined && parentTechnique !== null)
            url_ += "parentTechnique=" + encodeURIComponent("" + parentTechnique) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<SynthesisTechniqueDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SynthesisTechniqueDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SynthesisTechniqueDto[]>(null as any);
    }

    /**
     * Creates a synthesis technique.
     */
    create(technique: SynthesisTechniqueDto): Promise<SynthesisTechniqueDto> {
        let url_ = this.baseUrl + "/api/v1/synthesis-techniques";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(technique);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<SynthesisTechniqueDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SynthesisTechniqueDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SynthesisTechniqueDto>(null as any);
    }

    /**
     * Updates a synthesis technique. Route id must match body ID; parent must not equal self.
     */
    update(id: string, technique: SynthesisTechniqueDto): Promise<SynthesisTechniqueDto> {
        let url_ = this.baseUrl + "/api/v1/synthesis-techniques/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(technique);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<SynthesisTechniqueDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SynthesisTechniqueDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SynthesisTechniqueDto>(null as any);
    }
}

export interface ISystemConfigRepository {

    /**
     * Get system configuration details (OrgName, DataManagerEmail, LogoPath, Author explanation, Environment).
     * @return A JSON object containing OrgConfig data.
     */
    getSystemConfig(): Promise<SysDto>;
}

export class SystemConfigRepository extends AuthorizedApiBase implements ISystemConfigRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get system configuration details (OrgName, DataManagerEmail, LogoPath, Author explanation, Environment).
     * @return A JSON object containing OrgConfig data.
     */
    getSystemConfig(): Promise<SysDto> {
        let url_ = this.baseUrl + "/api/v1/system-config";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSystemConfig(_response));
        });
    }

    protected processGetSystemConfig(response: Response): Promise<SysDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SysDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SysDto>(null as any);
    }
}

export interface ITheoryActivityApiRepository {

    create(activity: CreateTheoryActivityRequest): Promise<TheoryActivityDto>;

    /**
     * Checks whether the given file ids exist and are accessible for the activity. Returns a list of (fileId, exists) pairs.
     * @param activityId Activity id.
     * @param fileIds (optional) Comma-separated file ids to check.
     * @deprecated
     */
    checkFile(activityId: number, fileIds: string | null | undefined): Promise<FileCheckDto[]>;

    /**
     * Updates file metadata for a logical file group. Same body as legacy PUT …/files.
     */
    updateFileGroup(activityId: number, dto: FileMetaDataCreateOrUpdateRequest): Promise<FileMetaDataDto>;

    /**
     * Returns file metadata groups (logical attachments) for the activity.
     */
    getFileGroups(activityId: number): Promise<FileMetaDataDto[]>;

    /**
     * Deletes every stored format in a logical file group (same semantics as removing each physical file in turn).
     */
    deleteFileGroup(activityId: number, fileGroupId: number): Promise<void>;

    /**
     * Uploads a file to an activity (FineUploader format). Returns success/error result for the upload widget.
     * @param activityId Activity id.
     * @param file File payload (base64 or blob) and name, via FineUploadBinder.
     * @deprecated
     */
    uploadFile(activityId: number, file: FineUploadFileDto): Promise<FileResponse>;

    /**
     * Updates file metadata for a file group on an activity. Send id or basename to identify the group.
     * @param activityId Activity id.
     * @param dto Writable metadata; identify the file group by id or basename (see GET files response).
     * @deprecated
     */
    updateFile(activityId: number, dto: FileMetaDataCreateOrUpdateRequest): Promise<FileMetaDataDto>;

    /**
     * Returns file metadata for all files attached to an activity (filtered by access).
     * @param activityId Activity id.
     * @deprecated
     */
    getFiles(activityId: number): Promise<FileMetaDataDto[]>;

    /**
     * Raw file bytes (Content-Disposition: attachment), not a FileDto JSON body.
     * @param fileId File id.
     * @param activityId Activity id.
     */
    getFile(fileId: number, activityId: number): Promise<FileResponse>;

    /**
     * Deletes a file attached to an activity.
     * @param fileId File id.
     * @param activityId Activity id.
     */
    deleteFile(fileId: number, activityId: number): Promise<void>;

    /**
     * Checks whether the given physical file ids exist and are accessible for the activity.
     * @param fileIds (optional) 
     */
    checkFilesUnderFilesRoute(activityId: number, fileIds: string | null | undefined): Promise<FileCheckDto[]>;

    /**
     * Upload a file to an activity via multipart form. Returns the created file metadata on success.
    Default intent is attachment-only (no recipe parsing for sample processing activities).
    Preferred over the legacy POST .../files endpoint (Fine Uploader only).
     * @param activityId Activity id.
     * @param uploadFile (optional) 
     * @param description (optional) 
     * @param visibility (optional) 
     * @param fields (optional) 
     */
    uploadActivityFileForm(activityId: number, uploadFile: FileParameter | undefined, description: string | null | undefined, visibility: VisibilityDto | null | undefined, fields: FileMetaDataFieldWriteRequest[] | null | undefined): Promise<FileMetaDataDto>;

    /**
     * Returns an image file inline (e.g. for display in browser).
     * @param fileId File id.
     * @param activityId Activity id.
     */
    getImage(fileId: number, activityId: number): Promise<FileResponse>;

    /**
     * Replaces/saves all notes for an activity. Returns the saved notes (filtered by auth).
     * @param activityId Activity id.
     * @param dtos Notes to save; existing notes are updated by ID, new notes have ID 0 or omitted.
     */
    saveNotes(activityId: number, dtos: NoteDto[]): Promise<NoteDto[]>;

    /**
     * Returns notes for an activity, filtered by the current user's access.
     * @param activityId Activity id.
     */
    getNotes(activityId: number): Promise<NoteDto[]>;

    /**
     * Deletes a note from an activity. Caller must be allowed to delete the note (e.g. owner).
     * @param activityId Activity id.
     * @param noteId Note id.
     */
    deleteNote(activityId: number, noteId: number): Promise<void>;

    update(id: number, activity: UpdateTheoryActivityRequest): Promise<TheoryActivityDto>;

    get(id: number): Promise<TheoryActivityDto>;

    deletePending(id: number, userHasConfirmed: boolean | undefined): Promise<void>;

    createFolderLink(id: number): Promise<string>;

    resetPending(id: number): Promise<TheoryActivityDto>;

    submit(id: number, userHasConfirmed: boolean | undefined): Promise<TheoryActivityDto>;

    search(sortColumn: string | null | undefined, sortOrder: string | null | undefined, start: number | undefined, length: number | undefined, draw: number | undefined, criteria: TheoryActivitySearchCriteria): Promise<PagingResultOfTheoryActivityDto>;

    getUsedSoftware(method: string | null | undefined): Promise<void>;

    getVersions(method: string | null | undefined, software: string | null | undefined): Promise<void>;
}

export class TheoryActivityApiRepository extends AuthorizedApiBase implements ITheoryActivityApiRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    create(activity: CreateTheoryActivityRequest): Promise<TheoryActivityDto> {
        let url_ = this.baseUrl + "/api/v1/theory-activities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(activity);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<TheoryActivityDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TheoryActivityDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TheoryActivityDto>(null as any);
    }

    /**
     * Checks whether the given file ids exist and are accessible for the activity. Returns a list of (fileId, exists) pairs.
     * @param activityId Activity id.
     * @param fileIds (optional) Comma-separated file ids to check.
     * @deprecated
     */
    checkFile(activityId: number, fileIds: string | null | undefined): Promise<FileCheckDto[]> {
        let url_ = this.baseUrl + "/api/v1/theory-activities/{activityId}/check-file?";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (fileIds !== undefined && fileIds !== null)
            url_ += "fileIds=" + encodeURIComponent("" + fileIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckFile(_response));
        });
    }

    protected processCheckFile(response: Response): Promise<FileCheckDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileCheckDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileCheckDto[]>(null as any);
    }

    /**
     * Updates file metadata for a logical file group. Same body as legacy PUT …/files.
     */
    updateFileGroup(activityId: number, dto: FileMetaDataCreateOrUpdateRequest): Promise<FileMetaDataDto> {
        let url_ = this.baseUrl + "/api/v1/theory-activities/{activityId}/file-groups";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateFileGroup(_response));
        });
    }

    protected processUpdateFileGroup(response: Response): Promise<FileMetaDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto>(null as any);
    }

    /**
     * Returns file metadata groups (logical attachments) for the activity.
     */
    getFileGroups(activityId: number): Promise<FileMetaDataDto[]> {
        let url_ = this.baseUrl + "/api/v1/theory-activities/{activityId}/file-groups";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFileGroups(_response));
        });
    }

    protected processGetFileGroups(response: Response): Promise<FileMetaDataDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto[]>(null as any);
    }

    /**
     * Deletes every stored format in a logical file group (same semantics as removing each physical file in turn).
     */
    deleteFileGroup(activityId: number, fileGroupId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/theory-activities/{activityId}/file-groups/{fileGroupId}";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (fileGroupId === undefined || fileGroupId === null)
            throw new globalThis.Error("The parameter 'fileGroupId' must be defined.");
        url_ = url_.replace("{fileGroupId}", encodeURIComponent("" + fileGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteFileGroup(_response));
        });
    }

    protected processDeleteFileGroup(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Uploads a file to an activity (FineUploader format). Returns success/error result for the upload widget.
     * @param activityId Activity id.
     * @param file File payload (base64 or blob) and name, via FineUploadBinder.
     * @deprecated
     */
    uploadFile(activityId: number, file: FineUploadFileDto): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/theory-activities/{activityId}/files";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(file);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadFile(_response));
        });
    }

    protected processUploadFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Updates file metadata for a file group on an activity. Send id or basename to identify the group.
     * @param activityId Activity id.
     * @param dto Writable metadata; identify the file group by id or basename (see GET files response).
     * @deprecated
     */
    updateFile(activityId: number, dto: FileMetaDataCreateOrUpdateRequest): Promise<FileMetaDataDto> {
        let url_ = this.baseUrl + "/api/v1/theory-activities/{activityId}/files";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateFile(_response));
        });
    }

    protected processUpdateFile(response: Response): Promise<FileMetaDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto>(null as any);
    }

    /**
     * Returns file metadata for all files attached to an activity (filtered by access).
     * @param activityId Activity id.
     * @deprecated
     */
    getFiles(activityId: number): Promise<FileMetaDataDto[]> {
        let url_ = this.baseUrl + "/api/v1/theory-activities/{activityId}/files";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFiles(_response));
        });
    }

    protected processGetFiles(response: Response): Promise<FileMetaDataDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto[]>(null as any);
    }

    /**
     * Raw file bytes (Content-Disposition: attachment), not a FileDto JSON body.
     * @param fileId File id.
     * @param activityId Activity id.
     */
    getFile(fileId: number, activityId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/theory-activities/{activityId}/files/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetFile(_response));
        });
    }

    protected processGetFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Deletes a file attached to an activity.
     * @param fileId File id.
     * @param activityId Activity id.
     */
    deleteFile(fileId: number, activityId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/theory-activities/{activityId}/files/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteFile(_response));
        });
    }

    protected processDeleteFile(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Checks whether the given physical file ids exist and are accessible for the activity.
     * @param fileIds (optional) 
     */
    checkFilesUnderFilesRoute(activityId: number, fileIds: string | null | undefined): Promise<FileCheckDto[]> {
        let url_ = this.baseUrl + "/api/v1/theory-activities/{activityId}/files/check?";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (fileIds !== undefined && fileIds !== null)
            url_ += "fileIds=" + encodeURIComponent("" + fileIds) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckFilesUnderFilesRoute(_response));
        });
    }

    protected processCheckFilesUnderFilesRoute(response: Response): Promise<FileCheckDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileCheckDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileCheckDto[]>(null as any);
    }

    /**
     * Upload a file to an activity via multipart form. Returns the created file metadata on success.
    Default intent is attachment-only (no recipe parsing for sample processing activities).
    Preferred over the legacy POST .../files endpoint (Fine Uploader only).
     * @param activityId Activity id.
     * @param uploadFile (optional) 
     * @param description (optional) 
     * @param visibility (optional) 
     * @param fields (optional) 
     */
    uploadActivityFileForm(activityId: number, uploadFile: FileParameter | undefined, description: string | null | undefined, visibility: VisibilityDto | null | undefined, fields: FileMetaDataFieldWriteRequest[] | null | undefined): Promise<FileMetaDataDto> {
        let url_ = this.baseUrl + "/api/v1/theory-activities/{activityId}/files/upload";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (uploadFile === null || uploadFile === undefined)
            throw new globalThis.Error("The parameter 'uploadFile' cannot be null.");
        else
            content_.append("UploadFile", uploadFile.data, uploadFile.fileName ? uploadFile.fileName : "UploadFile");
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (visibility !== null && visibility !== undefined)
            content_.append("Visibility", visibility.toString());
        if (fields !== null && fields !== undefined)
            fields.forEach(item_ => content_.append("Fields", item_.toString()));

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUploadActivityFileForm(_response));
        });
    }

    protected processUploadActivityFileForm(response: Response): Promise<FileMetaDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as FileMetaDataDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileMetaDataDto>(null as any);
    }

    /**
     * Returns an image file inline (e.g. for display in browser).
     * @param fileId File id.
     * @param activityId Activity id.
     */
    getImage(fileId: number, activityId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/theory-activities/{activityId}/images/{fileId}";
        if (fileId === undefined || fileId === null)
            throw new globalThis.Error("The parameter 'fileId' must be defined.");
        url_ = url_.replace("{fileId}", encodeURIComponent("" + fileId));
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetImage(_response));
        });
    }

    protected processGetImage(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Replaces/saves all notes for an activity. Returns the saved notes (filtered by auth).
     * @param activityId Activity id.
     * @param dtos Notes to save; existing notes are updated by ID, new notes have ID 0 or omitted.
     */
    saveNotes(activityId: number, dtos: NoteDto[]): Promise<NoteDto[]> {
        let url_ = this.baseUrl + "/api/v1/theory-activities/{activityId}/notes";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dtos);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveNotes(_response));
        });
    }

    protected processSaveNotes(response: Response): Promise<NoteDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NoteDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoteDto[]>(null as any);
    }

    /**
     * Returns notes for an activity, filtered by the current user's access.
     * @param activityId Activity id.
     */
    getNotes(activityId: number): Promise<NoteDto[]> {
        let url_ = this.baseUrl + "/api/v1/theory-activities/{activityId}/notes";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetNotes(_response));
        });
    }

    protected processGetNotes(response: Response): Promise<NoteDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NoteDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoteDto[]>(null as any);
    }

    /**
     * Deletes a note from an activity. Caller must be allowed to delete the note (e.g. owner).
     * @param activityId Activity id.
     * @param noteId Note id.
     */
    deleteNote(activityId: number, noteId: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/theory-activities/{activityId}/notes/{noteId}";
        if (activityId === undefined || activityId === null)
            throw new globalThis.Error("The parameter 'activityId' must be defined.");
        url_ = url_.replace("{activityId}", encodeURIComponent("" + activityId));
        if (noteId === undefined || noteId === null)
            throw new globalThis.Error("The parameter 'noteId' must be defined.");
        url_ = url_.replace("{noteId}", encodeURIComponent("" + noteId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteNote(_response));
        });
    }

    protected processDeleteNote(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    update(id: number, activity: UpdateTheoryActivityRequest): Promise<TheoryActivityDto> {
        let url_ = this.baseUrl + "/api/v1/theory-activities/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(activity);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<TheoryActivityDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TheoryActivityDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result422);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TheoryActivityDto>(null as any);
    }

    get(id: number): Promise<TheoryActivityDto> {
        let url_ = this.baseUrl + "/api/v1/theory-activities/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<TheoryActivityDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TheoryActivityDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TheoryActivityDto>(null as any);
    }

    deletePending(id: number, userHasConfirmed: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/theory-activities/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userHasConfirmed === null)
            throw new globalThis.Error("The parameter 'userHasConfirmed' cannot be null.");
        else if (userHasConfirmed !== undefined)
            url_ += "userHasConfirmed=" + encodeURIComponent("" + userHasConfirmed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeletePending(_response));
        });
    }

    protected processDeletePending(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result424);
            });
        } else if (status === 428) {
            return response.text().then((_responseText) => {
            let result428: any = null;
            result428 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result428);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    createFolderLink(id: number): Promise<string> {
        let url_ = this.baseUrl + "/api/v1/theory-activities/{id}/getLink";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateFolderLink(_response));
        });
    }

    protected processCreateFolderLink(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    resetPending(id: number): Promise<TheoryActivityDto> {
        let url_ = this.baseUrl + "/api/v1/theory-activities/{id}/reset";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processResetPending(_response));
        });
    }

    protected processResetPending(response: Response): Promise<TheoryActivityDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TheoryActivityDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TheoryActivityDto>(null as any);
    }

    submit(id: number, userHasConfirmed: boolean | undefined): Promise<TheoryActivityDto> {
        let url_ = this.baseUrl + "/api/v1/theory-activities/{id}/submit?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (userHasConfirmed === null)
            throw new globalThis.Error("The parameter 'userHasConfirmed' cannot be null.");
        else if (userHasConfirmed !== undefined)
            url_ += "userHasConfirmed=" + encodeURIComponent("" + userHasConfirmed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSubmit(_response));
        });
    }

    protected processSubmit(response: Response): Promise<TheoryActivityDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TheoryActivityDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 424) {
            return response.text().then((_responseText) => {
            let result424: any = null;
            result424 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result424);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TheoryActivityDto>(null as any);
    }

    search(sortColumn: string | null | undefined, sortOrder: string | null | undefined, start: number | undefined, length: number | undefined, draw: number | undefined, criteria: TheoryActivitySearchCriteria): Promise<PagingResultOfTheoryActivityDto> {
        let url_ = this.baseUrl + "/api/v1/theory-activities/search?";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "sortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortOrder !== undefined && sortOrder !== null)
            url_ += "sortOrder=" + encodeURIComponent("" + sortOrder) + "&";
        if (start === null)
            throw new globalThis.Error("The parameter 'start' cannot be null.");
        else if (start !== undefined)
            url_ += "start=" + encodeURIComponent("" + start) + "&";
        if (length === null)
            throw new globalThis.Error("The parameter 'length' cannot be null.");
        else if (length !== undefined)
            url_ += "length=" + encodeURIComponent("" + length) + "&";
        if (draw === null)
            throw new globalThis.Error("The parameter 'draw' cannot be null.");
        else if (draw !== undefined)
            url_ += "draw=" + encodeURIComponent("" + draw) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(criteria);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSearch(_response));
        });
    }

    protected processSearch(response: Response): Promise<PagingResultOfTheoryActivityDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PagingResultOfTheoryActivityDto;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PagingResultOfTheoryActivityDto>(null as any);
    }

    getUsedSoftware(method: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/theory-activities/used-software?";
        if (method !== undefined && method !== null)
            url_ += "method=" + encodeURIComponent("" + method) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUsedSoftware(_response));
        });
    }

    protected processGetUsedSoftware(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getVersions(method: string | null | undefined, software: string | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/theory-activities/used-versions?";
        if (method !== undefined && method !== null)
            url_ += "method=" + encodeURIComponent("" + method) + "&";
        if (software !== undefined && software !== null)
            url_ += "software=" + encodeURIComponent("" + software) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetVersions(_response));
        });
    }

    protected processGetVersions(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IUserRepository {

    /**
     * Creates a collaborator and converts duplicate-identifier persistence failures into 409 conflicts.
     */
    create(collaborator: CreateCollaboratorRequest): Promise<CollaboratorDto>;

    get(id: string): Promise<CollaboratorDto>;

    /**
     * Updates a collaborator and converts duplicate-identifier persistence failures into 409 conflicts.
     */
    update(id: string, collaborator: UpdateCollaboratorRequest): Promise<CollaboratorDto>;

    delete(id: string): Promise<void>;

    /**
     * Affiliation/profile timeslice history for admin display (read-only).
     */
    getHistory(id: string): Promise<CollaboratorHistorySliceDto[]>;

    /**
     * Gets a list of community users
     * @param customizing (optional) Include all user data. Requires User.List privilege.
     */
    getUsers(customizing: boolean | undefined): Promise<CollaboratorDto[]>;

    getCurrent(): Promise<CurrentUserDto>;

    getStaff(customizing: boolean | undefined): Promise<CollaboratorDto[]>;

    /**
     * @deprecated
     */
    lastProject(id: number): Promise<void>;

    /**
     * @deprecated
     */
    lastSample(id: number): Promise<void>;

    /**
     * Self-service profile update for the signed-in user (own record only).
     */
    updateProfile(request: UpdateProfileRequest): Promise<CurrentUserDto>;

    /**
     * @deprecated
     */
    projectSearchCriteria(criteria: ProjectSearchCriteria): Promise<void>;

    getRoles(): Promise<RoleDto[]>;

    /**
     * @deprecated
     */
    sampleFilterPUT(filter: SampleFilter): Promise<void>;

    /**
     * @deprecated
     */
    sampleFilterDELETE(): Promise<void>;

    /**
     * @deprecated
     */
    sampleSearchCriteria(criteria: SampleSearchCriteria): Promise<void>;

    saveSettings(settings: UserSettingsDto): Promise<void>;
}

export class UserRepository extends AuthorizedApiBase implements IUserRepository {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: IAuthContext, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Creates a collaborator and converts duplicate-identifier persistence failures into 409 conflicts.
     */
    create(collaborator: CreateCollaboratorRequest): Promise<CollaboratorDto> {
        let url_ = this.baseUrl + "/api/v1/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(collaborator);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<CollaboratorDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CollaboratorDto;
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CollaboratorDto>(null as any);
    }

    get(id: string): Promise<CollaboratorDto> {
        let url_ = this.baseUrl + "/api/v1/users/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGet(_response));
        });
    }

    protected processGet(response: Response): Promise<CollaboratorDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CollaboratorDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CollaboratorDto>(null as any);
    }

    /**
     * Updates a collaborator and converts duplicate-identifier persistence failures into 409 conflicts.
     */
    update(id: string, collaborator: UpdateCollaboratorRequest): Promise<CollaboratorDto> {
        let url_ = this.baseUrl + "/api/v1/users/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(collaborator);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<CollaboratorDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CollaboratorDto;
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CollaboratorDto>(null as any);
    }

    delete(id: string): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/users/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Affiliation/profile timeslice history for admin display (read-only).
     */
    getHistory(id: string): Promise<CollaboratorHistorySliceDto[]> {
        let url_ = this.baseUrl + "/api/v1/users/{id}/history";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetHistory(_response));
        });
    }

    protected processGetHistory(response: Response): Promise<CollaboratorHistorySliceDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CollaboratorHistorySliceDto[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CollaboratorHistorySliceDto[]>(null as any);
    }

    /**
     * Gets a list of community users
     * @param customizing (optional) Include all user data. Requires User.List privilege.
     */
    getUsers(customizing: boolean | undefined): Promise<CollaboratorDto[]> {
        let url_ = this.baseUrl + "/api/v1/users/community?";
        if (customizing === null)
            throw new globalThis.Error("The parameter 'customizing' cannot be null.");
        else if (customizing !== undefined)
            url_ += "customizing=" + encodeURIComponent("" + customizing) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUsers(_response));
        });
    }

    protected processGetUsers(response: Response): Promise<CollaboratorDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CollaboratorDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CollaboratorDto[]>(null as any);
    }

    getCurrent(): Promise<CurrentUserDto> {
        let url_ = this.baseUrl + "/api/v1/users/current";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCurrent(_response));
        });
    }

    protected processGetCurrent(response: Response): Promise<CurrentUserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CurrentUserDto;
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CurrentUserDto>(null as any);
    }

    getStaff(customizing: boolean | undefined): Promise<CollaboratorDto[]> {
        let url_ = this.baseUrl + "/api/v1/users/inhouse?";
        if (customizing === null)
            throw new globalThis.Error("The parameter 'customizing' cannot be null.");
        else if (customizing !== undefined)
            url_ += "customizing=" + encodeURIComponent("" + customizing) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStaff(_response));
        });
    }

    protected processGetStaff(response: Response): Promise<CollaboratorDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CollaboratorDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            result403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CollaboratorDto[]>(null as any);
    }

    /**
     * @deprecated
     */
    lastProject(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/users/last-project";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(id);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLastProject(_response));
        });
    }

    protected processLastProject(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @deprecated
     */
    lastSample(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/users/last-sample";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(id);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLastSample(_response));
        });
    }

    protected processLastSample(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Self-service profile update for the signed-in user (own record only).
     */
    updateProfile(request: UpdateProfileRequest): Promise<CurrentUserDto> {
        let url_ = this.baseUrl + "/api/v1/users/me/profile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateProfile(_response));
        });
    }

    protected processUpdateProfile(response: Response): Promise<CurrentUserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CurrentUserDto;
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CurrentUserDto>(null as any);
    }

    /**
     * @deprecated
     */
    projectSearchCriteria(criteria: ProjectSearchCriteria): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/users/project-search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(criteria);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProjectSearchCriteria(_response));
        });
    }

    protected processProjectSearchCriteria(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getRoles(): Promise<RoleDto[]> {
        let url_ = this.baseUrl + "/api/v1/users/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRoles(_response));
        });
    }

    protected processGetRoles(response: Response): Promise<RoleDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RoleDto[];
            return result200;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoleDto[]>(null as any);
    }

    /**
     * @deprecated
     */
    sampleFilterPUT(filter: SampleFilter): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/users/sample-filter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSampleFilterPUT(_response));
        });
    }

    protected processSampleFilterPUT(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @deprecated
     */
    sampleFilterDELETE(): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/users/sample-filter";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSampleFilterDELETE(_response));
        });
    }

    protected processSampleFilterDELETE(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @deprecated
     */
    sampleSearchCriteria(criteria: SampleSearchCriteria): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/users/sample-search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(criteria);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSampleSearchCriteria(_response));
        });
    }

    protected processSampleSearchCriteria(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    saveSettings(settings: UserSettingsDto): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/users/save-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveSettings(_response));
        });
    }

    protected processSaveSettings(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

/** Activity category. Used for sample/data package activities. • **PROJ** – Project • **THEO** – Theory • **TRASH** – Trash • **TRANS** – Transfer • **STOR** – Storage • **PROC** – Processing • **CHAR** – Characterization • **INVE** – Inventory */
export enum ActivityCategoryDto {
    Project = "PROJ",
    Theory = "THEO",
    Trash = "TRASH",
    Transfer = "TRANS",
    Storage = "STOR",
    Processing = "PROC",
    Characterization = "CHAR",
    Inventory = "INVE",
}

export interface ActivityDto {
    id?: number | undefined;
    date?: Date | undefined;
    userId?: string | undefined;
    runtime?: number | undefined;
    /** Visibility: P (On Publication), U (User PI), I (Internal) */
    visibility?: VisibilityDto | undefined;
    /** Activity category (e.g. PROC, CHAR, PROJ) */
    category?: ActivityCategoryDto | undefined;
    /** Activity type (e.g. PREP, SYN, PUB) */
    type?: ActivityTypeDto | undefined;
    lastChangedDate?: Date | undefined;
    lastChangedByUser?: string | undefined;
    files?: FileMetaDataDto[] | undefined;
    status?: StatusDto | undefined;
    desc?: string | undefined;
}

export interface ActivityMaterialDto {
    layer?: number;
    id?: number;
    name?: string | undefined;
    asSampleMaterial?: boolean;
}

/** Activity type. Used for sample/data package activities. PUB=Publication, PRES=Presentation, PROP=Proposal, APPROV=Award, DEC=Decision, DOC=Document, REP=Report. • **PREP** – Preparation (Processing) • **SYN** – Synthesis (Processing) • **POST** – PostTreatment (Processing) • **DIC** – Dicing (Processing) • **GRP** – Grouping (Processing) • **PUB** – Publication (Project) • **PRES** – Presentation (Project) • **PROP** – Proposal (Project) • **APPROV** – Project awarded (Project) • **DEC** – Decision (Project) • **DOC** – Document (Project) • **REP** – Report (Project) */
export enum ActivityTypeDto {
    Preparation = "PREP",
    Synthesis = "SYN",
    PostTreatment = "POST",
    Dicing = "DIC",
    Grouping = "GRP",
    Publication = "PUB",
    Presentation = "PRES",
    Proposal = "PROP",
    Award = "APPROV",
    Decision = "DEC",
    Document = "DOC",
    Report = "REP",
}

export interface AddToInventoryRequest {
    label?: string | undefined;
    /** How many separate samples to register with the same metadata (e.g. a box of ten identical wafers).
Each gets its own sample ID and inventory activity. Values below 1 are treated as 1.
Capped on the server (see sample service). Per-specimen differences require a future batch API extension. */
    quantity?: number;
    /** Substrate vendor/lot/orientation and related physical fields. The API persists these only when the resolved
technique grows on a substrate (or when no technique is set, legacy substrate-only inventory).
When the technique does not use substrates, send empty values; the server clears them. */
    substrateName?: string | undefined;
    substrateVendor?: string | undefined;
    substrateLot?: string | undefined;
    substrateOrientation?: string | undefined;
    sampleHolder?: string | undefined;
    thickness?: string | undefined;
    quality?: string | undefined;
    size?: string | undefined;
    date?: Date | undefined;
    projectIds?: number[];
    reportingCategory?: ReportingCategoryDto | undefined;
    /** Wafer / substrate catalog material IDs. Prefer materials with IsSubstrate = true; inline create
from substrate pickers sets that flag. Required when the resolved technique grows on a substrate, or
when no technique is specified (legacy substrate-only inventory). Do not send when the technique does not
grow on a substrate. */
    substrateMaterialIds?: number[];
    /** Sample (film / product) catalog materials for a grown stack (stored with IsSubstrate = false).
Use when registering a grown sample; when non-empty, TechniqueId is required. */
    productMaterialIds?: number[];
    techniqueId?: string | undefined;
    researcherKey: string;
    description?: string;
}

/** Result of add-to-inventory. Samples length equals the effective quantity from the request (one entry per physical specimen, each with its own sample ID and inventory activity). */
export interface AddToInventoryResponseDto {
    samples?: SampleDto[];
}

/** One specimen in a "customize each" (varied) add-to-inventory request. Each item becomes its own standalone inventory sample with a unique sample ID and inventory activity. */
export interface AddToInventorySpecimenItemDto {
    /** Optional explicit sample label. When null/empty the server auto-generates one. */
    label?: string | undefined;
    /** Optional catalog-style substrate name (e.g. wafer product name). */
    substrateName?: string | undefined;
    substrateVendor?: string | undefined;
    substrateLot?: string | undefined;
    substrateOrientation?: string | undefined;
    sampleHolder?: string | undefined;
    thickness?: string | undefined;
    quality?: string | undefined;
    size?: string | undefined;
    /** Wafer / substrate catalog materials for this specimen (stored with IsSubstrate = true).
At least one is required per row in substrate-only varied registration. */
    substrateMaterialIds?: number[];
}

/** Request to add several different specimens to inventory in one atomic operation ("customize each" mode). Substrate-only scope (v1). */
export interface AddToInventoryVariedRequest {
    date?: Date | undefined;
    projectIds?: number[];
    researcherKey: string;
    reportingCategory?: ReportingCategoryDto | undefined;
    description?: string;
    /** Optional technique for all specimens. Substrate-only scope: when set, it must be a technique that grows on
a substrate; product (film) techniques are rejected because per-row product stacks are out of scope in v1. */
    techniqueId?: string | undefined;
    /** The specimens to register. Each becomes its own sample. At least one is required; the count is capped by
MaxQuantity on the server. */
    specimens: AddToInventorySpecimenItemDto[];
}

export interface ApiKeyDto {
    id?: number;
    name: string;
    roleId?: number;
    role?: RoleDto | undefined;
    created?: Date | undefined;
    projects?: ApiProjectAccessDto[] | undefined;
    validTo: Date;
    allowInternalApi?: boolean;
    userId?: string | undefined;
    /** ID of the user who created this API key */
    createdByUserId?: string | undefined;
    /** Display name of the user who created this API key (First Last). */
    createdByUserName?: string | undefined;
    /** Display name of the user this key is assigned to (First Last). Empty for role-based keys. */
    userName?: string | undefined;
    /** Email for identification (used for anonymous user-created keys) */
    email?: string | undefined;
    /** Institution for identification (used for anonymous user-created keys) */
    institution?: string | undefined;
    key?: string | undefined;
    /** Whether the current user may update this key (computed per request; ignored on input). */
    canUpdate?: boolean;
    /** Whether the current user may move the expiry later (computed per request; ignored on input).
Without it, the expiry can only be shortened. */
    canExtend?: boolean;
    /** Whether the current user may delete this key (computed per request; ignored on input). */
    canDelete?: boolean;
}

export interface ApiProjectAccessDto {
    projectId?: number;
    projectLabel?: string | undefined;
    roleId?: number;
}

export interface AutoSubmitConfig {
    checkInterval?: number | undefined;
    checkCron?: string | undefined;
    fullCheckCron?: string | undefined;
    retryCron?: string | undefined;
    cleanupCron?: string | undefined;
    cleanupMaxAge?: number | undefined;
    name?: string | undefined;
    id?: string | undefined;
    restartPending?: boolean;
    researchGroup?: string | undefined;
    submitAfter?: number;
    withoutMaterial?: string | undefined;
    withoutSynthesis?: string | undefined;
    withoutSynthesisOrPreparation?: string | undefined;
    withoutRecipe?: string | undefined;
    legacyBefore?: string | undefined;
    limit?: number;
    submitGrowthRuns?: boolean;
}

/** Filter preset for auto-submit monitor records. Omit or null = no filter (all records). • **error** – Records with error status (E) • **notValid** – Records with sample not valid (S) • **anyIssue** – Records with any issue (E, S) • **pending** – Records pending (P) */
export enum AutoSubmitFilterStatusDto {
    Error = "error",
    NotValid = "notValid",
    AnyIssue = "anyIssue",
    Pending = "pending",
}

export interface AutoSubmitRecordDto {
    id?: number;
    collaboratorId?: string | undefined;
    sampleId?: number | undefined;
    sampleLabel?: string | undefined;
    projectLabel?: string | undefined;
    status?: string | undefined;
    processDate?: string | undefined;
    creationDate?: string | undefined;
    retries?: number;
    message?: string | undefined;
}

export interface AvailableTemplate {
    name?: string | undefined;
    usesInstrument?: boolean;
}

export interface AzureAdConfig {
    instance: string;
    tenantId: string;
    clientId: string;
    domain: string;
    callbackPath: string;
    redirectUri: string;
    scope: string;
}

export interface BaseEnum {
    id?: string | undefined;
    label?: string | undefined;
}

export interface BuildInfoDto {
    branch?: string | undefined;
    commitHash?: string | undefined;
    buildDate?: string | undefined;
    version?: string | undefined;
}

export interface BulkElementDto {
    id?: number;
    name?: string | undefined;
    molarMass?: number;
}

export interface BulkRawMaterialDto {
    id?: number | undefined;
    name: string;
    vendor?: string | undefined;
    lot?: string | undefined;
    purity?: number | undefined;
    granularity?: string | undefined;
    usage?: number | undefined;
    techniques?: string[] | undefined;
    material?: MaterialDto | undefined;
    materialID?: number;
}

export interface BulkSampleDto {
    growthId?: number | undefined;
    projectId?: number | undefined;
    projectLabel?: string | undefined;
    projectUser?: string | undefined;
    projectType?: string | undefined;
    /** When true, reporting category is a required field (before submit),
and it should be editable in list/grid UIs.
Computed server-side from the sample's project type (internal). */
    reportingCategoryRequired?: boolean;
    /** Whether the current user may update this sample row (inline reporting category, etc.). */
    canUpdateSample?: boolean;
    /** Sample owner user id; used for strip-all UI on bulk transfer. */
    userId?: string | undefined;
    id: number;
    sampleLabel: string;
    /** Label of the sample this row was split from (dicing parent). Null when the row is not a split piece. */
    splitFromLabel?: string | undefined;
    status?: StatusDto | undefined;
    reportingCategory?: string | undefined;
    pieces: number;
    shipped?: number;
    quality?: string | undefined;
    description?: string | undefined;
    usedAsRawMaterial?: boolean | undefined;
    material?: string | undefined;
    materialId?: number | undefined;
    roles?: number[] | undefined;
    startingMaterials?: BulkStartingMaterialDTO[] | undefined;
}

export interface BulkSamplesDto {
    samples?: BulkSampleDto[] | undefined;
    growths?: GrowthRunDto[] | undefined;
    privileges?: RoleWithPrivilegesDto[] | undefined;
    draw?: number;
    recordsTotal?: number;
    recordsFiltered?: number;
}

export interface BulkShippingResolveRequestDto {
    samples: BulkShippingSampleSpecDto[];
}

export interface BulkShippingSampleSpecDto {
    sampleId: number;
    /** Empty/null = ship whole parent. Otherwise range/list, e.g. "1-3", "A,B,E". */
    pieceSpec?: string | undefined;
}

export interface BulkStartingMaterialDTO {
    preparationId?: number;
    preparationMethod?: string | undefined;
    preparationDate?: string | undefined;
    preparationUserId?: string | undefined;
    refSampleLabel?: string | undefined;
    precompoundedID?: number | undefined;
    precompoundedLabel?: string | undefined;
    preparation?: SampleActivityDto | undefined;
    size?: string | undefined;
    weight?: string | undefined;
    composition?: string | undefined;
    transportAgent?: string | undefined;
    materialId?: number | undefined;
    material?: string | undefined;
    description?: string | undefined;
    rawVendors?: string | undefined;
}

export interface CharacterizationInstrumentDto {
    id?: string | undefined;
    name?: string | undefined;
    location?: string | undefined;
    description?: string | undefined;
    facility?: string | undefined;
    characterizationTechnique?: string | undefined;
    techniqueLabel?: string | undefined;
    metadataConfig?: FileMetaDataConfigDto | undefined;
    doi?: string | undefined;
}

export interface CharacterizationInstrumentFilter {
    ids?: string | undefined;
    excludeIds?: string | undefined;
}

export interface CharacterizationTechniqueDto {
    id?: string | undefined;
    name?: string | undefined;
}

export interface CharacterizationUploadConfig {
    enabled?: boolean | undefined;
    isActive?: boolean;
    name?: string | undefined;
    id?: string | undefined;
    prio?: number;
    filter?: FileFilterConfig | undefined;
    source?: FileHostingRootConfig | undefined;
    errorFolderName?: string | undefined;
    copyToFolder?: string | undefined;
    limit?: number;
    useFileDate?: boolean;
    checkCron?: string | undefined;
    fullCheckCron?: string | undefined;
    retryCron?: string | undefined;
    cleanupCron?: string | undefined;
    cleanupMaxAge?: number | undefined;
    checkInterval?: number | undefined;
    useOldSampleIdFormat?: boolean;
    restartPending?: boolean;
    uploadToSynthesis?: string | undefined;
    uploadToSample?: string | undefined;
    expectSampleIdInFolder?: boolean;
}

export interface CharacterizationUploadFilterDto {
    folder?: string | undefined;
    source?: string | undefined;
    userId?: string | undefined;
    sampleId?: string | undefined;
    filename?: string | undefined;
    processDateFrom?: Date | undefined;
    processDateTo?: Date | undefined;
    fileDateFrom?: Date | undefined;
    fileDateTo?: Date | undefined;
    charId?: string | undefined;
    synId?: string | undefined;
    /** Filter by characterization upload status. Omit or null = no filter. */
    filterStatus?: CharacterizationUploadFilterStatusDto | undefined;
    /** True when filter is groupByMissingSample (group records by sample). */
    groupBySample?: boolean;
}

/** Filter preset for characterization upload monitor records. Omit or null = no filter (all records). groupByMissingSample uses same status as sampleNotFound but groups by sample. • **error** – Records with error status (E) • **sampleNotFound** – Records with sample not found (S) • **groupByMissingSample** – Sample not found, grouped by sample (S) • **anyIssue** – Records with any issue (E, S) • **pending** – Records pending (P) • **nothingToDo** – Records with nothing to do (-) • **uploaded** – Records uploaded successfully (OK) */
export enum CharacterizationUploadFilterStatusDto {
    Error = "error",
    SampleNotFound = "sampleNotFound",
    GroupByMissingSample = "groupByMissingSample",
    AnyIssue = "anyIssue",
    Pending = "pending",
    NothingToDo = "nothingToDo",
    Uploaded = "uploaded",
}

export interface CharacterizationUploadRecordDto {
    id?: number;
    collaboratorId?: string | undefined;
    charInstrument?: string | undefined;
    synInstrument?: string | undefined;
    sampleId?: number | undefined;
    sampleLabel?: string | undefined;
    projectLabel?: string | undefined;
    filename?: string | undefined;
    fileDate?: string | undefined;
    synthesisDate?: string | undefined;
    characterizationDate?: string | undefined;
    status?: string | undefined;
    processDate?: string | undefined;
    retries?: number;
    message?: string | undefined;
    source?: string | undefined;
}

export interface CharacterizationUploadStat {
    status?: string | undefined;
    count?: number;
}

export interface CharInstrumentDropdownChoicesDto {
    locations?: string[] | undefined;
    facilities?: string[] | undefined;
}

export interface CheckResultDto {
    valid?: boolean;
    error?: string | undefined;
}

export interface CollaboratorDto {
    id: string;
    validFrom: string;
    validTo: string;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    abbreviation?: string | undefined;
    orcId?: string | undefined;
    email?: string | undefined;
    /** Display/mailto email resolved from the slice email (EPPN fallback when loaded). Populated in list results too,
unlike Email which is admin-detail only, so grids can link a real address instead of guessing one. */
    contactEmail?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    phone?: string | undefined;
    country?: string | undefined;
    institution?: string | undefined;
    position?: string | undefined;
    roleIds: number[];
    roles?: RoleDto[] | undefined;
    faculty?: string | undefined;
    isAdmin: boolean;
    techniques: string[];
    managedInstruments: string[];
    /** Live sign-in identifiers (admin only; replace semantics on update). */
    eppns?: CollaboratorEppnDto[] | undefined;
    /** Microsoft Graph user object id for Teams @mentions (admin only; stored in AzureId column; not sign-in). */
    teamsUserId?: string | undefined;
    settings?: UserSettingsDto | undefined;
    usingSignInAs?: boolean;
    fullName: string;
    canSwitchRoles: boolean;
    selectedRole?: number | undefined;
    inactive: boolean;
}

/** Live sign-in identifier row for admin API. */
export interface CollaboratorEppnDto {
    id?: number | undefined;
    eppn?: string | undefined;
    expiresAt?: Date | undefined;
}

/** Read-only affiliation/profile timeslice for admin history display. */
export interface CollaboratorHistorySliceDto {
    validFrom?: string | undefined;
    validTo?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    position?: string | undefined;
    institution?: string | undefined;
    faculty?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    country?: string | undefined;
}

export interface CombineStartingMaterialsRequest {
    startingMaterials: string[];
    projects: number[];
    creationDate: Date;
    userId: string;
    processType: string;
    techniqueId?: string | undefined;
    instrumentId?: string | undefined;
    recipeTemplateName?: string | undefined;
    materialIds: number[];
    sampleHolder?: string | undefined;
    reportingCategoryId?: number | undefined;
    description?: string | undefined;
}

export interface CommentType extends BaseEnum {
}

export function isCommentType(object: any): object is CommentType {
    return object && object[''] === 'CommentType';
}

export interface CommunicationDto {
    id?: number;
    projectID?: number;
    title?: string | undefined;
    format?: string | undefined;
    participants?: string | undefined;
    text?: string | undefined;
    /** Visibility level. Default: User PI. */
    visibility?: VisibilityDto | undefined;
    lastChangedDate?: Date | undefined;
    status?: StatusDto | undefined;
    lastChangedByUser?: string | undefined;
    createdByUser?: string | undefined;
    date?: Date | undefined;
}

export interface CopyBulkSampleRequest {
    date: Date;
    description?: string | undefined;
    project: string;
    staff: string;
    samplesToCopy: number[];
    numberOfCopies?: number | undefined;
}

export interface CreateActivityRequest {
    id?: number | undefined;
    date?: Date | undefined;
    userId?: string | undefined;
    runtime?: number | undefined;
    /** Visibility: P (On Publication), U (User PI), I (Internal) */
    visibility?: VisibilityDto | undefined;
    /** Activity category (e.g. PROC, CHAR, PROJ) */
    category?: ActivityCategoryDto | undefined;
    /** Activity type (e.g. PREP, SYN, PUB) */
    type?: ActivityTypeDto | undefined;
    desc?: string | undefined;
}

export interface CreateApiKeyRequest {
    /** Name for the API key. Optional for anonymous users - the backend will auto-generate.
Required for signed-in users. */
    name?: string | undefined;
    /** Role for role-based keys (required there). Ignored for user-based keys: they use the user's role. */
    roleId?: number | undefined;
    validTo: Date;
    allowInternalApi?: boolean;
    /** User ID to associate with this API key.
Can only be set on creation, cannot be changed later.
Regular users can only set this to themselves.
Admins can set this to any user. */
    userId?: string | undefined;
    /** Email for identification (used for anonymous user-created keys) */
    email?: string | undefined;
    /** Institution for identification (used for anonymous user-created keys) */
    institution?: string | undefined;
    projects?: ApiProjectAccessDto[] | undefined;
}

export interface CreateBulkGrowthRequest {
    date: Date;
    description?: string | undefined;
    instrument: string;
    label?: string | undefined;
    project: string;
    samples?: number[] | undefined;
    staff: string;
    growthMethod: string;
    template?: number | undefined;
    addSynthesis?: boolean;
    addCompounding?: boolean;
}

export interface CreateBulkSampleRequest {
    date: Date;
    description?: string | undefined;
    growth?: number | undefined;
    material?: number | undefined;
    project: string;
    precompounded?: string[] | undefined;
    sampleLabel?: string | undefined;
    staff: string;
    technique: string;
    template: string;
}

export interface CreateCollaboratorRequest {
    login?: string | undefined;
    eppn?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    abbreviation?: string | undefined;
    orcId?: string | undefined;
    email?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    phone?: string | undefined;
    country?: string | undefined;
    institution?: string | undefined;
    position?: string | undefined;
    faculty?: string | undefined;
    isAdmin: boolean;
    techniques: string[];
    managedInstruments: string[];
    roleIds: number[];
    inactive: boolean;
    id?: string | undefined;
    eppns?: CollaboratorEppnDto[] | undefined;
    /** Microsoft Graph user object id for Teams @mentions (stored in AzureId column; not sign-in). */
    teamsUserId?: string | undefined;
}

/** Body for POST communications. Created-by and audit fields are set server-side. */
export interface CreateCommunicationRequest {
    projectID?: number;
    title?: string | undefined;
    format?: string | undefined;
    participants?: string | undefined;
    text?: string | undefined;
    visibility?: VisibilityDto | undefined;
    date?: Date | undefined;
}

export interface CreateDataPackageRequest {
    projectId?: number | undefined;
    publicationId?: number | undefined;
    label: string;
    description: string;
    samples?: string[] | undefined;
    sampleIds?: number[] | undefined;
    collaboratorIds?: string[] | undefined;
    synthesisInstrumentIds?: string[] | undefined;
    characterizationInstrumentIds?: string[] | undefined;
    keywords?: string[] | undefined;
    activityIds?: number[] | undefined;
}

/** Request to create a multi-sample growth run: N substrates in one run → N samples (many-to-many). Each substrate can be an existing sample (from pool) or a new substrate with material/vendor/lot etc. */
export interface CreateMultiSampleGrowthRequest {
    date: Date;
    /** Optional project to associate the growth run with.
             */
    projectId?: number | undefined;
    /** Researcher/staff key (user ID or abbreviation).
             */
    staffKey: string;
    techniqueId: string;
    instrumentId: string;
    /** Optional growth run label.
             */
    label?: string | undefined;
    description?: string | undefined;
    /** Optional reporting category code.
             */
    reportingCategoryCode?: string | undefined;
    /** Optional synthesis runtime (hours) for the growth-run processing activity.
             */
    runtime?: number | undefined;
    /** Optional recipe template name for the parent SYN activity. When set without Recipe,
an empty recipe is initialized from the template.
             */
    recipeTemplate?: string | undefined;
    /** Optional full recipe payload (e.g. from a recipe favorite). RecipeTemplate must match
recipe.TemplateName when both are provided.
             */
    recipe?: RecipeDto | undefined;
    /** Substrates/samples in the run. Each item is either an existing sample (ExistingSampleId)
or a new substrate (MaterialIds + vendor/lot/orientation/holder/thickness/quality/size).
             */
    substrates: CreateMultiSampleGrowthSubstrateDto[];
}

/** One substrate in a multi-sample growth run. Either use an existing sample (ExistingSampleId) or specify new substrate data (MaterialIds + vendor/lot/orientation/etc.). */
export interface CreateMultiSampleGrowthSubstrateDto {
    /** ID of an existing sample to use as substrate (from pool).
             */
    existingSampleId?: number | undefined;
    /** Material IDs for a new substrate (required when not using ExistingSampleId).
             */
    materialIds?: number[];
    substrateVendor?: string | undefined;
    substrateLot?: string | undefined;
    substrateOrientation?: string | undefined;
    sampleHolder?: string | undefined;
    thickness?: string | undefined;
    quality?: string | undefined;
    size?: string | undefined;
}

/** Request body for project create/update. */
export interface CreateOrUpdateProjectRequestDto {
    id?: number | undefined;
    projectLabel: string;
    type?: string | undefined;
    title?: string | undefined;
    startDate?: Date | undefined;
    submissionDate?: Date | undefined;
    endDate?: Date | undefined;
    /** Project category. Omit or null = not set. */
    category?: ProjectCategoryDto | undefined;
    /** Project lifecycle status. Default: Pending. */
    projectStatus?: ProjectStatusDto | undefined;
    isPublished?: boolean;
    lastChangedDate?: Date | undefined;
    lastChangedByUser?: string | undefined;
    materialIds?: number[] | undefined;
    materials?: string[] | undefined;
    techniques?: string[] | undefined;
    collaborators?: ProjectCollaboratorRequest[] | undefined;
    /** Organization name frozen at award. Admin correction via SetAwardGeography. */
    piInstitution?: string | undefined;
    /** US state / jurisdiction code frozen at award. Admin correction via SetAwardGeography. */
    piState?: string | undefined;
    /** When true, replace stored award geography from PiInstitution / PiState.
FIXME: Currently gated on User.Update as an admin stand-in; prefer a dedicated privilege. */
    setAwardGeography?: boolean;
}

export interface CreateProjectActivityRequest extends CreateActivityRequest {
    projectId: number;
    publication?: PublicationDto | undefined;
}

export function isCreateProjectActivityRequest(object: any): object is CreateProjectActivityRequest {
    return object && object[''] === 'CreateProjectActivityRequest';
}

export interface CreatePublicationRequest {
    title: string;
    year?: number | undefined;
    type: string;
    authors: string;
    journal: string;
    cite: string;
    doi: string;
    description?: string | undefined;
    scienceDriverIds?: number[] | undefined;
    materials?: string[] | undefined;
    materialIds?: number[] | undefined;
    projectIds?: number[] | undefined;
    synthesisInstrumentIds?: string[] | undefined;
    characterizationInstrumentIds?: string[] | undefined;
}

export interface CreateRoleRequest {
    isUser: boolean;
    isFaculty: boolean;
    isResearcher: boolean;
    isInhouse: boolean;
    name: string;
    privileges: PrivilegeDto[];
}

export interface CreateSampleActivityRequest extends CreateActivityRequest {
    sampleId?: number;
    createNickname?: boolean;
    facility?: string | undefined;
    sampleLocation?: string | undefined;
    charId?: string | undefined;
    technique?: string | undefined;
    instrument?: string | undefined;
    recipeTemplate?: string | undefined;
    recipe?: RecipeDto | undefined;
    materials?: ActivityMaterialDto[] | undefined;
    parentActivityId?: number | undefined;
    characterizationTechnique?: string | undefined;
    instrumentDOI?: string | undefined;
}

export function isCreateSampleActivityRequest(object: any): object is CreateSampleActivityRequest {
    return object && object[''] === 'CreateSampleActivityRequest';
}

export interface CreateTheoryActivityRequest extends CreateActivityRequest {
    dataPackageId?: number;
    simulationTechnique?: string | undefined;
    link?: string | undefined;
    version?: string | undefined;
    software?: string | undefined;
}

export function isCreateTheoryActivityRequest(object: any): object is CreateTheoryActivityRequest {
    return object && object[''] === 'CreateTheoryActivityRequest';
}

export interface CurrentUserDto {
    id: string;
    login?: string | undefined;
    eppn?: string | undefined;
    /** Sign-in path for this session: msal (Entra) or shibboleth (InCommon). Omitted for anonymous. */
    authMethod?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName: string;
    abbreviation: string;
    orcId?: string | undefined;
    roleIds: number[];
    roles: RoleWithPrivilegesDto[];
    faculty?: string | undefined;
    isAdmin: boolean;
    country?: string | undefined;
    techniques: string[];
    managedInstruments: string[];
    settings: UserSettingsDto;
    usingSignInAs: boolean;
    fullName: string;
    canSwitchRoles: boolean;
    selectedRole: number;
    phone?: string | undefined;
    email?: string | undefined;
    position?: string | undefined;
    institution?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    /** Indicates if the user has access to any projects (either through global privileges or project-specific collaboration) */
    hasAnyProjectAccess: boolean;
    /** Indicates if the user has access to any samples (either through global privileges or project-specific collaboration) */
    hasAnySampleAccess: boolean;
}

export interface DataPackageCollaboratorDto {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    institution?: string | undefined;
}

export interface DataPackageDoiUpdate {
    dataPackageDoi?: string | undefined;
    publicationDoi?: string | undefined;
}

export interface DataPackageDto {
    id?: number;
    label?: string | undefined;
    description?: string | undefined;
    prePublishId?: string | undefined;
    doi?: string | undefined;
    projectId?: number | undefined;
    projectLabel?: string | undefined;
    publicationId?: number | undefined;
    publicationDoi?: string | undefined;
    keywords?: string[] | undefined;
    collaborators?: DataPackageCollaboratorDto[] | undefined;
    synthesisInstruments?: SynthesisInstrumentDto[] | undefined;
    characterizationInstruments?: CharacterizationInstrumentDto[] | undefined;
    activityIds?: number[] | undefined;
    sampleIds?: number[] | undefined;
    samples?: string[] | undefined;
    lastChangedByUser?: string | undefined;
    lastChangedDate?: Date | undefined;
    /** Lifecycle status: P = Pending, S = Submitted, R = Published, N = New, D = Deleted, H = Hidden. */
    status?: StatusDto | undefined;
    nbSamples?: number | undefined;
    nbActivities?: number | undefined;
    isPublished?: boolean;
    isSnapshot?: boolean;
    percentSnapshotDone?: number | undefined;
    snapshotInProgress?: boolean;
}

export interface DataPackageSearchCriteria {
    synTechniqueId?: string | undefined;
    charTechniqueId?: string | undefined;
    materials?: number[] | undefined;
    elements?: string[] | undefined;
    searchText?: string | undefined;
    collaborator?: string | undefined;
    publicOnly?: boolean;
    topLevelOrPublicOnly?: boolean;
    dataType?: string | undefined;
}

export interface ExistsResult {
    exists?: boolean;
}

export interface ExternalSampleCreationRequest {
    projects: number[];
    label?: string | undefined;
    creationDate: Date;
    description?: string | undefined;
    techniqueId: string;
    size?: string | undefined;
    sampleHolder?: string | undefined;
    thickness?: string | undefined;
    substrate?: number | undefined;
    subSamples?: SubEntry[] | undefined;
    materialIds?: number[] | undefined;
    userId?: string | undefined;
    substrateLot?: string | undefined;
    substrateName?: string | undefined;
    substrateOrientation?: string | undefined;
    substratePurity?: number;
    substrateVendor?: string | undefined;
}

export interface FileCheckDto {
    id?: number;
    exists?: boolean;
}

export interface FileDownloadUser {
    name?: string | undefined;
    institution?: string | undefined;
    email?: string | undefined;
}

/** File metadata and links as returned in JSON (e.g. GET …/files, nested under FileMetaDataDto). Does not include file bytes; use DownloadUrl or ImageUrl (GET those paths for content). */
export interface FileDto {
    id?: number | undefined;
    externalId?: string | undefined;
    filename?: string | undefined;
    filetype?: string | undefined;
    downloadUrl?: string | undefined;
    imageUrl?: string | undefined;
    metaData?: FileMetaDataDto | undefined;
}

export interface FileFilterConfig {
    foldernameSearchString?: string | undefined;
    foldernameRegEx?: string | undefined;
    ignoreFolderLevels?: number | undefined;
    fileNameDatePattern?: string | undefined;
    fileNameDatePatternExact?: string | undefined;
    searchPreviousDateIfNotFound?: boolean | undefined;
    fileNamePattern?: string | undefined;
    fileNameRegEx?: string | undefined;
    fileTypes?: string[] | undefined;
    fileType?: string | undefined;
    canBeZipped?: boolean | undefined;
    synInstrument?: SynthesisInstrumentFilter | undefined;
    charInstrument?: CharacterizationInstrumentFilter | undefined;
}

export interface FileHostingRootConfig {
    provider?: string | undefined;
    siteId?: string | undefined;
    driveId?: string | undefined;
    hostName?: string | undefined;
    sitePath?: string | undefined;
    documentLibrary?: string | undefined;
    name?: string | undefined;
    driveType?: string | undefined;
    rootFolderId?: string | undefined;
    rootFolderName?: string | undefined;
    timeoutInSeconds?: number | undefined;
    limit?: number;
    id?: number | undefined;
}

export interface FileMetaDataConfigDto {
    id?: number | undefined;
    isDefault?: boolean;
    charInstrument?: string | undefined;
    synInstrument?: string | undefined;
    metadataSource?: string | undefined;
    filenameTemplate?: string | undefined;
    fields?: FileMetaDataFieldConfigDto[] | undefined;
}

/** Writable file metadata for a file group (sample, shipping, communication, activity, etc.). Identify the group by Id or by Basename (same as basename on GET). When Id is set, a different Basename updates the stored basename (rename). Omit Fields to leave existing fields unchanged. */
export interface FileMetaDataCreateOrUpdateRequest {
    /** Internal file metadata id when known. */
    id?: number | undefined;
    /** Base filename of the file group (no path); required when Id is not set.
Matches the basename returned by the API for that attachment. */
    basename?: string | undefined;
    description?: string | undefined;
    /** Visibility: P (On Publication), U (User PI), I (Internal). */
    visibility?: VisibilityDto | undefined;
    fields?: FileMetaDataFieldWriteRequest[] | undefined;
}

/** One metadata group for a stored file (fields, visibility, nested Files rows). This is a group of files which are different formats of the same data, e.g. raw data and exported/converted data. Returned by GET …/files endpoints as JSON; use each file’s download URL or GET …/files/{fileId} for bytes. */
export interface FileMetaDataDto {
    id?: number | undefined;
    basename?: string | undefined;
    description?: string | undefined;
    /** True when this file group is the recipe source for the activity (strict recipe upload or legacy MBE/MCV tools). */
    isRecipeSource?: boolean;
    /** Visibility: P (On Publication), U (User PI), I (Internal). Default: U. */
    visibility?: VisibilityDto | undefined;
    lastChangedDate?: Date | undefined;
    status?: StatusDto | undefined;
    lastChangedByUser?: string | undefined;
    fields?: FileMetaDataFieldDto[] | undefined;
    files?: FileDto[] | undefined;
}

export interface FileMetaDataFieldConfigDto {
    id?: number;
    templatePattern?: string | undefined;
    label?: string | undefined;
    type?: string | undefined;
    order?: number | undefined;
}

export interface FileMetaDataFieldDto {
    metadataID?: number | undefined;
    label: string;
    type: string;
    value?: string | undefined;
    order?: number;
}

/** Custom metadata field values clients may set on create or update. */
export interface FileMetaDataFieldWriteRequest {
    label: string;
    /** Column type id (e.g. Text, string, Number, Time). Omit for untyped values. */
    type?: string | undefined;
    value?: string | undefined;
    order?: number;
}

export interface FileSharingConfig {
    name?: string | undefined;
    id?: string | undefined;
    linkValidityDays?: number;
    parallelCopy?: number;
    cleanupCron?: string | undefined;
    sendEmailNotification?: boolean | undefined;
    skipEmailIfCopiedIn?: number | undefined;
    overrideNotificationEmail?: string | undefined;
    restartPending?: boolean;
    checkInterval?: number | undefined;
    checkCron?: string | undefined;
    fullCheckCron?: string | undefined;
    retryCron?: string | undefined;
    cleanupMaxAge?: number | undefined;
}

export interface FileSourceConfig {
    id?: number;
    name?: string | undefined;
    deltaCheck?: string | undefined;
    lastSync?: Date | undefined;
    removeAfterUpload?: boolean;
    errorFolderName?: string | undefined;
    provider?: string | undefined;
    siteId?: string | undefined;
    driveId?: string | undefined;
    driveType?: string | undefined;
    hostName?: string | undefined;
    sitePath?: string | undefined;
    documentLibrary?: string | undefined;
    rootFolderId?: string | undefined;
    rootFolderName?: string | undefined;
    timeoutInSeconds?: number | undefined;
    limit?: number | undefined;
    checkCron?: string | undefined;
    fullCheckCron?: string | undefined;
    retryCron?: string | undefined;
    cleanupCron?: string | undefined;
    cleanupMaxAge?: number | undefined;
    checkInterval?: number | undefined;
    restartPending?: boolean;
}

/** Legacy Fine Uploader POST body: raw upload stream plus inferred name/type. Not serialized in JSON API responses. */
export interface FineUploadFileDto {
    filename?: string | undefined;
    filetype?: string | undefined;
    data?: Stream | undefined;
}

export interface FolderShareLink {
    id?: number;
    userID?: string | undefined;
    externalId?: string | undefined;
    created?: Date;
    lastUpdated?: Date | undefined;
    name?: string | undefined;
    done?: boolean;
    link?: string | undefined;
    percentDone?: number;
    storagePath?: string | undefined;
    storageProvider?: string | undefined;
}

/** • **Synthesis** – Synthesis • **PreparationOnly** – PreparationOnly • **Any** – Any */
export enum GrownByScope {
    Synthesis = "Synthesis",
    PreparationOnly = "PreparationOnly",
    Any = "Any",
}

export interface GrowthRunDto {
    growthId?: number | undefined;
    sampleLabel?: string | undefined;
    projectId?: number;
    projectLabel?: string | undefined;
    projectUser?: string | undefined;
    projectType?: string | undefined;
    technique?: string | undefined;
    staff?: string | undefined;
    date?: Date | undefined;
    description?: string | undefined;
    status?: StatusDto | undefined;
    synthesis?: InstrumentRunDto | undefined;
    compounding?: InstrumentRunDto | undefined;
}

export interface IAutoSubmitConfig {
    researchGroup?: string | undefined;
    submitGrowthRuns?: boolean;
    submitAfter?: number;
    limit?: number;
}

export interface ICharacterizationUploadConfig {
    prio?: number;
    source?: FileHostingRootConfig | undefined;
    filter?: FileFilterConfig | undefined;
    copyToFolder?: string | undefined;
    useFileDate?: boolean;
    useOldSampleIdFormat?: boolean;
    expectSampleIdInFolder?: boolean;
    uploadToSynthesis?: string | undefined;
    uploadToSample?: string | undefined;
}

export interface IFileSharingConfig {
    linkValidityDays?: number;
    parallelCopy?: number;
    sendEmailNotification?: boolean | undefined;
    skipEmailIfCopiedIn?: number | undefined;
    overrideNotificationEmail?: string | undefined;
}

export interface ImportFilterDto {
    source?: string | undefined;
    userId?: string | undefined;
    filename?: string | undefined;
    fileDateFrom?: Date | undefined;
    fileDateTo?: Date | undefined;
    processDateFrom?: Date | undefined;
    processDateTo?: Date | undefined;
    /** Filter by import status. Omit or null = no filter. */
    filterStatus?: ImportFilterStatusDto | undefined;
}

/** Filter preset for import monitor records. Omit or null = no filter (all records). • **error** – Records with error status (E) • **notrelevant** – Records marked not relevant (U) • **pending** – Records pending (P) • **issues** – Records with warnings or errors (W, E) */
export enum ImportFilterStatusDto {
    Error = "error",
    NotRelevant = "notrelevant",
    Pending = "pending",
    Issues = "issues",
}

export interface ImportStat {
    status?: string | undefined;
    count?: number;
}

export interface ImportTaskDto {
    id?: number;
    collaboratorId?: string | undefined;
    filename?: string | undefined;
    fileDate?: string | undefined;
    externalID?: string | undefined;
    status?: string | undefined;
    processDate?: string | undefined;
    retries?: number;
    message?: string | undefined;
}

export interface InstrumentFundingDto {
    id?: number;
    code?: string | undefined;
    label?: string | undefined;
    isUsed?: boolean | undefined;
}

export interface InstrumentRunDto {
    activityId?: number;
    activity?: SampleActivityDto | undefined;
    date?: Date | undefined;
    technique?: string | undefined;
    instrument?: string | undefined;
    growthMethod?: string | undefined;
    runtime?: number | undefined;
    recipe?: string | undefined;
    userId?: string | undefined;
}

export interface ISampleImportConfig {
    source?: FileHostingRootConfig | undefined;
    filter?: FileFilterConfig | undefined;
    instrumentName?: string | undefined;
    enableRestSubmit?: boolean | undefined;
    isRestSubmitEnabled?: boolean;
    alwaysCheckLogFiles?: boolean | undefined;
    recipeFileExtension?: string | undefined;
}

export interface LogFileSource {
    source?: FileHostingRootConfig | undefined;
    filter?: FileFilterConfig | undefined;
}

export interface MarshalByRefObject {
}

export interface MaterialDto {
    id?: number | undefined;
    name?: string | undefined;
    form?: string | undefined;
    externalId?: string | undefined;
    isSubstrate?: boolean;
    isConfidential?: boolean;
    label?: string | undefined;
    /** Indicates whether this material is currently referenced/used.
Serialized as isUsed to match other masterdata DTOs. */
    isUsed?: boolean | undefined;
    /** Legacy field kept for backwards compatibility with older clients.
Prefer IsUsed. */
    aliases?: MaterialDto[] | undefined;
}

export interface NoteDto {
    id?: number | undefined;
    title?: string | undefined;
    text?: string | undefined;
    /** Visibility: P (On Publication), U (User PI), I (Internal). Default: U. */
    visibility?: VisibilityDto | undefined;
    lastChangedDate?: Date | undefined;
    status?: StatusDto | undefined;
    lastChangedByUser?: string | undefined;
}

/** • **Create** – Create • **Read** – Read • **Update** – Update • **Delete** – Delete • **Submit** – Submit • **ResetToPending** – ResetToPending • **Execute** – Execute • **List** – List • **Create** – Create • **Read** – Read • **Update** – Update • **Delete** – Delete • **Submit** – Submit • **ResetToPending** – ResetToPending • **Execute** – Execute • **List** – List */
export enum OperationEnum {
    Create = "Create",
    Read = "Read",
    Update = "Update",
    Delete = "Delete",
    Submit = "Submit",
    ResetToPending = "ResetToPending",
    Execute = "Execute",
    List = "List",
}

export interface PagingResultOfCharacterizationUploadRecordDto {
    recordsFiltered: number;
    recordsTotal: number;
    draw?: number | undefined;
    data: CharacterizationUploadRecordDto[];
}

export interface PagingResultOfDataPackageDto {
    recordsFiltered: number;
    recordsTotal: number;
    draw?: number | undefined;
    data: DataPackageDto[];
}

export interface PagingResultOfImportTaskDto {
    recordsFiltered: number;
    recordsTotal: number;
    draw?: number | undefined;
    data: ImportTaskDto[];
}

export interface PagingResultOfProjectDto {
    recordsFiltered: number;
    recordsTotal: number;
    draw?: number | undefined;
    data: ProjectDto[];
}

export interface PagingResultOfSampleRequestSearchResultDto {
    recordsFiltered: number;
    recordsTotal: number;
    draw?: number | undefined;
    data: SampleRequestSearchResultDto[];
}

export interface PagingResultOfSampleSearchResultDto {
    recordsFiltered: number;
    recordsTotal: number;
    draw?: number | undefined;
    data: SampleSearchResultDto[];
}

export interface PagingResultOfShippingDto {
    recordsFiltered: number;
    recordsTotal: number;
    draw?: number | undefined;
    data: ShippingDto[];
}

export interface PagingResultOfTheoryActivityDto {
    recordsFiltered: number;
    recordsTotal: number;
    draw?: number | undefined;
    data: TheoryActivityDto[];
}

export interface PrivilegeDto {
    id?: PrivilegeEnum;
    name?: string | undefined;
    rights?: string | undefined;
    desc?: string | undefined;
    supportedOperations?: string[] | undefined;
    group?: string | undefined;
}

/** • **AccessUnpublishedData** – AccessUnpublishedData • **UserProject** – UserProject • **InternalProject** – InternalProject • **AccessPendingProject** – AccessPendingProject • **Communication** – Communication • **OwnCommunication** – OwnCommunication • **SampleRequest** – SampleRequest • **SamplesDue** – SamplesDue • **Shipping** – Shipping • **ProjectDecision** – ProjectDecision • **ProjectDocument** – ProjectDocument • **Proposal** – Proposal • **Report** – Report • **Publication** – Publication • **Sample** – Sample • **AccessProcessDevelopmentSample** – AccessProcessDevelopmentSample • **AccessPendingSample** – AccessPendingSample • **CreateSampleForOthers** – CreateSampleForOthers • **AccessUnassignedSample** – AccessUnassignedSample • **ProcessingActivity** – ProcessingActivity • **RecipeFavorite** – RecipeFavorite • **SplitActivity** – SplitActivity • **TransferActivity** – TransferActivity • **StorageActivity** – StorageActivity • **DataPackage** – DataPackage • **SimulationDataSet** – SimulationDataSet • **DataSnapshot** – DataSnapshot • **CharacterizationActivity** – CharacterizationActivity • **CharacterizationData** – CharacterizationData • **OwnCharacterizationData** – OwnCharacterizationData • **TheoryActivity** – TheoryActivity • **Role** – Role • **User** – User • **ResearchGroup** – ResearchGroup • **SynthesisTechnique** – SynthesisTechnique • **SynthesisInstrument** – SynthesisInstrument • **SetInstrumentManager** – SetInstrumentManager • **CharacterizationTechnique** – CharacterizationTechnique • **CharacterizationInstrument** – CharacterizationInstrument • **ConfigureFileMetaData** – ConfigureFileMetaData • **SimulationMethod** – SimulationMethod • **InstrumentFunding** – InstrumentFunding • **Material** – Material • **ReportingCategory** – ReportingCategory • **BulkRawMaterial** – BulkRawMaterial • **ProjectType** – ProjectType • **ApiKeys** – ApiKeys • **Note** – Note • **OwnNote** – OwnNote • **File** – File • **OwnFile** – OwnFile • **SampleReport** – SampleReport • **ImportMonitoring** – ImportMonitoring • **SampleImport** – SampleImport • **CharacterizationUpload** – CharacterizationUpload • **AutoSubmit** – AutoSubmit • **AccessVisibilityInternal** – AccessVisibilityInternal • **AccessVisibilityUser** – AccessVisibilityUser • **AccessVisibilityPublic** – AccessVisibilityPublic • **UseAnySynthesisTechnique** – UseAnySynthesisTechnique • **UseAnySynthesisInstrument** – UseAnySynthesisInstrument • **AccessBudgetData** – AccessBudgetData • **PermanentLink** – PermanentLink • **DownloadRecipe** – DownloadRecipe • **SampleStatistics** – SampleStatistics • **ConfidentialMaterial** – ConfidentialMaterial • **SignInAs** – SignInAs • **ConfigureFileProcessing** – ConfigureFileProcessing */
export enum PrivilegeEnum {
    AccessUnpublishedData = "AccessUnpublishedData",
    UserProject = "UserProject",
    InternalProject = "InternalProject",
    AccessPendingProject = "AccessPendingProject",
    Communication = "Communication",
    OwnCommunication = "OwnCommunication",
    SampleRequest = "SampleRequest",
    SamplesDue = "SamplesDue",
    Shipping = "Shipping",
    ProjectDecision = "ProjectDecision",
    ProjectDocument = "ProjectDocument",
    Proposal = "Proposal",
    Report = "Report",
    Publication = "Publication",
    Sample = "Sample",
    AccessProcessDevelopmentSample = "AccessProcessDevelopmentSample",
    AccessPendingSample = "AccessPendingSample",
    CreateSampleForOthers = "CreateSampleForOthers",
    AccessUnassignedSample = "AccessUnassignedSample",
    ProcessingActivity = "ProcessingActivity",
    RecipeFavorite = "RecipeFavorite",
    SplitActivity = "SplitActivity",
    TransferActivity = "TransferActivity",
    StorageActivity = "StorageActivity",
    DataPackage = "DataPackage",
    SimulationDataSet = "SimulationDataSet",
    DataSnapshot = "DataSnapshot",
    CharacterizationActivity = "CharacterizationActivity",
    CharacterizationData = "CharacterizationData",
    OwnCharacterizationData = "OwnCharacterizationData",
    TheoryActivity = "TheoryActivity",
    Role = "Role",
    User = "User",
    ResearchGroup = "ResearchGroup",
    SynthesisTechnique = "SynthesisTechnique",
    SynthesisInstrument = "SynthesisInstrument",
    SetInstrumentManager = "SetInstrumentManager",
    CharacterizationTechnique = "CharacterizationTechnique",
    CharacterizationInstrument = "CharacterizationInstrument",
    ConfigureFileMetaData = "ConfigureFileMetaData",
    SimulationMethod = "SimulationMethod",
    InstrumentFunding = "InstrumentFunding",
    Material = "Material",
    ReportingCategory = "ReportingCategory",
    BulkRawMaterial = "BulkRawMaterial",
    ProjectType = "ProjectType",
    ApiKeys = "ApiKeys",
    Note = "Note",
    OwnNote = "OwnNote",
    File = "File",
    OwnFile = "OwnFile",
    SampleReport = "SampleReport",
    ImportMonitoring = "ImportMonitoring",
    SampleImport = "SampleImport",
    CharacterizationUpload = "CharacterizationUpload",
    AutoSubmit = "AutoSubmit",
    AccessVisibilityInternal = "AccessVisibilityInternal",
    AccessVisibilityUser = "AccessVisibilityUser",
    AccessVisibilityPublic = "AccessVisibilityPublic",
    UseAnySynthesisTechnique = "UseAnySynthesisTechnique",
    UseAnySynthesisInstrument = "UseAnySynthesisInstrument",
    AccessBudgetData = "AccessBudgetData",
    PermanentLink = "PermanentLink",
    DownloadRecipe = "DownloadRecipe",
    SampleStatistics = "SampleStatistics",
    ConfidentialMaterial = "ConfidentialMaterial",
    SignInAs = "SignInAs",
    ConfigureFileProcessing = "ConfigureFileProcessing",
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions?: { [key: string]: any; };

    [key: string]: any;
}

export interface ProjectActivityDto extends ActivityDto {
    projectId: number;
    projectLabel?: string | undefined;
    publication?: PublicationDto | undefined;
}

export function isProjectActivityDto(object: any): object is ProjectActivityDto {
    return object && object[''] === 'ProjectActivityDto';
}

/** Project category. Used for project create/update. • **R1** – R1 Academic • **NR1** – Non-R1 Academic • **G** – Government • **Ind** – Industry • **Int** – International • **O** – Other */
export enum ProjectCategoryDto {
    R1 = "R1",
    NR1 = "NR1",
    Government = "G",
    Industry = "Ind",
    International = "Int",
    Other = "O",
}

export interface ProjectCollaboratorDto {
    id?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    institution?: string | undefined;
    roleId?: number;
    role?: string | undefined;
}

export interface ProjectCollaboratorRequest {
    id?: string | undefined;
    roleId?: number;
}

export interface ProjectDto {
    id?: number | undefined;
    projectLabel: string;
    /** Project type definition.
Describes how the project is handled (internal vs. external work, granting access to existing data, etc.).
             */
    type?: ProjectTypeDto | undefined;
    /** Human-readable project title or description shown in the UI.
             */
    title?: string | undefined;
    startDate?: Date | undefined;
    submissionDate?: Date | undefined;
    endDate?: Date | undefined;
    /** Institution category for the PI / project owner (e.g. internal, external, industry).
Despite the legacy name "Category", this does NOT categorize the project itself,
but the institution associated with the primary investigator.
             */
    category?: ProjectCategoryDto | undefined;
    /** Project lifecycle status (P, A, X, C). */
    projectStatus?: ProjectStatusDto | undefined;
    isPublished?: boolean;
    lastChangedDate?: Date | undefined;
    lastChangedByUser?: string | undefined;
    materialIds?: number[] | undefined;
    materials?: string[] | undefined;
    status?: StatusDto | undefined;
    techniques?: string[] | undefined;
    user?: string | undefined;
    faculty?: string[] | undefined;
    staff?: string[] | undefined;
    /** Project institution state at award (API name retained). Maps from StateAtAward. */
    piState?: string | undefined;
    /** Project institution name at award (API name retained). Maps from InstitutionAtAward. */
    piInstitution?: string | undefined;
    /** Institution category at award (R1 Academic, Industry, etc.). Maps from InstitutionCategoryAtAward. */
    institutionType?: string | undefined;
    collaborators?: ProjectCollaboratorDto[] | undefined;
    nbSamplesDue?: number | undefined;
    nbSamplesShipped?: number | undefined;
    totalNbSamplesRequested?: number | undefined;
    totalNbSamples?: number | undefined;
    nextSampleDue?: string | undefined;
    unspecifiedNbOfSamples?: boolean;
    nbOfCommunicationEntries?: number;
    lastCommunication?: string | undefined;
    communicationCount?: number;
    recentSampleCount?: number;
    oldSampleCount?: number;
    shippingSampleCount?: number;
    /** Simulation packages of the project the viewer can see (IsSimulationPackage).
             */
    simulationCount?: number;
    /** Setup: the project has no techniques, or any Simulation technique.
Simulations can be added.
             */
    isTheory?: boolean;
    /** Setup: the project has no techniques, or any technique other than Simulation.
Samples can be added.
             */
    isExperimental?: boolean;
    /** Visibility: samples and shippings are shown when the project IsExperimental, or the viewer
can see existing samples or shipments.
The counts are only filled by GET projects/{idOrLabel}; elsewhere this equals IsExperimental.
             */
    showsSamples?: boolean;
    /** Visibility: simulations are shown when the project IsTheory, or the viewer can see existing
simulation packages (SimulationCount).
The count is only filled by GET projects/{idOrLabel}; elsewhere this equals IsTheory.
             */
    showsSimulations?: boolean;
}

export interface ProjectSearchCriteria {
    synTechniqueId?: string | undefined;
    ownProjectsOnly?: boolean | undefined;
    privilege?: string | undefined;
    operation?: string | undefined;
    year?: number | undefined;
    status?: string | undefined;
    statusEnum?: ProjectSearchStatus | undefined;
    type?: string | undefined;
    includeInternal?: boolean;
    includeExternal?: boolean;
    samplesDueBy?: string | undefined;
    prioToProjectsWithSamples?: boolean;
    materials?: number[] | undefined;
    elements?: string[] | undefined;
    searchText?: string | undefined;
    state?: string | undefined;
    institution?: string | undefined;
}

/** Search criteria for project search (v1 API). Used as request body for POST projects/search. */
export interface ProjectSearchCriteriaDto {
    synTechniqueId?: string | undefined;
    ownProjectsOnly?: boolean | undefined;
    privilege?: string | undefined;
    operation?: string | undefined;
    year?: number | undefined;
    /** Optional filter by status. Omit or null = All. */
    status?: ProjectSearchStatusDto | undefined;
    type?: string | undefined;
    includeInternal?: boolean;
    includeExternal?: boolean;
    samplesDueBy?: string | undefined;
    prioToProjectsWithSamples?: boolean;
    materials?: number[] | undefined;
    elements?: string[] | undefined;
    searchText?: string | undefined;
    /** Optional filter: PI state (case-insensitive equality). */
    state?: string | undefined;
    /** Optional filter: PI institution contains (case-insensitive). */
    institution?: string | undefined;
}

export interface ProjectSearchStatus extends BaseEnum {
    projectStatus?: string[] | undefined;
    hasSampleRequestFilter?: boolean;
}

export function isProjectSearchStatus(object: any): object is ProjectSearchStatus {
    return object && object[''] === 'ProjectSearchStatus';
}

/** Filter preset for project search status. Omit or null = All. • **A** – All (Approved + Closed) • **O** – Open (Approved) • **C** – Closed • **D** – Delivered (all samples delivered) • **P** – Partially Delivered • **S** – Samples due • **W** – Pending • **X** – Cancelled */
export enum ProjectSearchStatusDto {
    All = "A",
    Open = "O",
    Closed = "C",
    Delivered = "D",
    PartiallyDelivered = "P",
    SamplesDue = "S",
    Pending = "W",
    Cancelled = "X",
}

/** Project lifecycle status. Distinct from StatusDto (entity workflow). • **P** – Pending • **A** – Approved • **X** – Canceled • **C** – Closed */
export enum ProjectStatusDto {
    Pending = "P",
    Approved = "A",
    Canceled = "X",
    Closed = "C",
}

export interface ProjectTypeDto {
    id: number;
    code?: string | undefined;
    label?: string | undefined;
    isInternal?: boolean;
    prefix?: string | undefined;
    isUsed?: boolean | undefined;
}

export interface PublicationDto {
    id: number;
    title: string;
    year?: number | undefined;
    /** Publication type (I, E, L). */
    type: PublicationTypeDto;
    authors: string;
    journal: string;
    cite: string;
    doi: string;
    description: string;
    scienceDriverIds: number[];
    materials?: MaterialDto[] | undefined;
    projects?: ProjectDto[] | undefined;
    accessibleProjects?: number[] | undefined;
    synthesisInstruments?: SynthesisInstrumentDto[] | undefined;
    characterizationInstruments?: CharacterizationInstrumentDto[] | undefined;
    lastChangedDate: Date;
    lastChangedByUser: string;
    status: StatusDto;
    hasData: boolean;
}

/** Search criteria for publication search. Used as request body for POST publications/search. */
export interface PublicationSearchCriteriaDto {
    materials?: number[] | undefined;
    elements?: string[] | undefined;
    searchText?: string | undefined;
    /** Filter by publication type (I, E, L). Omit or null = no filter. */
    publicationType?: PublicationTypeDto | undefined;
    scienceDriver?: number | undefined;
}

/** Publication type. • **I** – In-House • **E** – External User • **L** – Local User */
export enum PublicationTypeDto {
    InHouse = "I",
    External = "E",
    Local = "L",
}

export interface RecipeDto {
    id?: number | undefined;
    templateName?: string | undefined;
    templateHash?: string | undefined;
    runtimeChangedManualy?: boolean;
    calculatedRuntime?: number;
    groups?: RecipeGroupDto[] | undefined;
}

export interface RecipeFavoriteDto {
    id?: number | undefined;
    technique?: string | undefined;
    instrument?: string | undefined;
    step?: string | undefined;
    template?: string | undefined;
    recipe?: RecipeDto | undefined;
    name?: string | undefined;
}

export interface RecipeGroupDto {
    id?: number | undefined;
    name?: string | undefined;
    color?: string | undefined;
    symbol?: string | undefined;
    rowType?: string | undefined;
    scrolling?: boolean;
    recipeID?: number;
    allowSeveral?: boolean;
    copyLastRow?: boolean;
    comments?: string | undefined;
    commentTypeEnum?: CommentType | undefined;
    columns?: RecipeTemplateColumnDto[] | undefined;
    rows?: RecipeRowDto[] | undefined;
}

export interface RecipeRowDto {
    id?: number | undefined;
    name?: string | undefined;
    symbol?: string | undefined;
    description?: string | undefined;
    comment?: string | undefined;
    repeat?: number | undefined;
    endRepeat?: boolean | undefined;
    definedInTemplate?: boolean;
    calcResultModified?: string[] | undefined;
    formulas?: string[][] | undefined;
    values?: any[][] | undefined;
    dropdownValues?: any[][] | undefined;
    recipeGroupID?: number;
}

export interface RecipeTemplateColumnDto {
    id?: number | undefined;
    symbol?: string | undefined;
    name?: string | undefined;
    unit?: string | undefined;
    type?: string | undefined;
    defaultValue?: string | undefined;
    precision?: number;
    sourceType?: string | undefined;
    source?: string | undefined;
    visibility?: string | undefined;
    visibilityFormula?: string | undefined;
    refColumn?: string | undefined;
    visibilityOp?: string | undefined;
    visibilityVal?: string | undefined;
    updateVisibilities?: boolean;
    values?: any[] | undefined;
    lookupValues?: string | undefined;
    startingMaterialIndex?: number | undefined;
    color?: string | undefined;
    width?: string | undefined;
}

export interface RecipeTemplateDto {
    id?: number | undefined;
    name?: string | undefined;
    definesMaterial?: boolean;
    usesInstrument?: boolean;
    calcRuntime?: string | undefined;
    calcRuntimeFormula?: string | undefined;
    runtimeUnit?: string | undefined;
    techniques?: string[] | undefined;
    step?: string | undefined;
    instrumentTypes?: string[] | undefined;
    instruments?: string[] | undefined;
    sources?: string[] | undefined;
    forSubstrate?: boolean;
    usingUpload?: string | undefined;
    fileFormat?: string | undefined;
    xmlAdapter?: string | undefined;
    fileSuffixes?: string[] | undefined;
    formulaConstants?: any | undefined;
    hash?: string | undefined;
    groups?: RecipeTemplateGroupDto[] | undefined;
}

export interface RecipeTemplateGroupDto {
    id?: number | undefined;
    name?: string | undefined;
    color?: string | undefined;
    symbol?: string | undefined;
    rowType?: string | undefined;
    scrolling?: boolean;
    allowSeveral?: boolean;
    copyLastRow?: boolean;
    comments?: string | undefined;
    regexFirstInclude?: string | undefined;
    regexFirstExclude?: string | undefined;
    filterColumn?: string | undefined;
    columns?: RecipeTemplateColumnDto[] | undefined;
    rows?: RecipeTemplateRowDto[] | undefined;
}

export interface RecipeTemplateRowDto {
    id?: number | undefined;
    name?: string | undefined;
    symbol?: string | undefined;
    description?: string | undefined;
    values?: string[][] | undefined;
    dropdownValues?: any[][] | undefined;
    filter?: string[][] | undefined;
    formulas?: string[][] | undefined;
}

/** Recipe template activity step. Only these three values are accepted by the recipe-templates API. • **PREP** – Preparation • **SYN** – Synthesis • **POST** – Post-treatment */
export enum RecipeTemplateStep {
    PREP = "PREP",
    SYN = "SYN",
    POST = "POST",
}

export interface ReportingCategoryDto {
    id?: number;
    code?: string | undefined;
    label?: string | undefined;
    requiresInternalSamplePrivilege?: boolean;
    isUsed?: boolean | undefined;
}

/** Sample request status. • **O** – Open • **P** – In Process • **S** – Shipped • **L** – Postponed • **C** – Cancelled */
export enum RequestStatusDto {
    Open = "O",
    InProcess = "P",
    Shipped = "S",
    Postponed = "L",
    Cancelled = "C",
}

export interface RoleDto {
    isUser: boolean;
    isFaculty: boolean;
    isResearcher: boolean;
    isInhouse: boolean;
    used?: boolean;
    id: number;
    name: string;
}

export interface RoleWithPrivilegesDto extends RoleDto {
    privileges: PrivilegeDto[];
}

export function isRoleWithPrivilegesDto(object: any): object is RoleWithPrivilegesDto {
    return object && object[''] === 'RoleWithPrivilegesDto';
}

export interface SampleActivityDto extends ActivityDto {
    sampleId?: number;
    facility?: string | undefined;
    sampleLocation?: string | undefined;
    charId?: string | undefined;
    sample?: SampleDto | undefined;
    pieces?: string[] | undefined;
    technique?: string | undefined;
    instrument?: string | undefined;
    recipeTemplate?: string | undefined;
    recipe?: RecipeDto | undefined;
    targetProjects?: number[] | undefined;
    sourceProjects?: number[] | undefined;
    targetProjectLabels?: string[] | undefined;
    sourceProjectLabels?: string[] | undefined;
    materials?: ActivityMaterialDto[] | undefined;
    parentActivityId?: number | undefined;
    inSituCharacterizations?: SampleActivityDto[] | undefined;
    characterizationTechnique?: string | undefined;
    instrumentDOI?: string | undefined;
    isSnapshot?: boolean | undefined;
    recipeTemplateHash?: string | undefined;
}

export function isSampleActivityDto(object: any): object is SampleActivityDto {
    return object && object[''] === 'SampleActivityDto';
}

export interface SampleCopyRequest {
    date: Date;
    desc?: string | undefined;
    instrument: string;
    template: number;
    sampleLabel?: string | undefined;
    substrates?: SampleCopySubstrateLine[] | undefined;
}

export interface SampleCopySubstrateLine {
    no: number;
    template: number;
    substrateLot?: string | undefined;
    substrateName?: string | undefined;
    substrateOrientation?: string | undefined;
    substratePurity?: number;
    substrateVendor?: string | undefined;
    sampleAsSubstrate?: string | undefined;
}

export interface SampleCreationRequest {
    projects: number[];
    label?: string | undefined;
    creationDate: Date;
    description?: string | undefined;
    instrumentId?: string | undefined;
    techniqueId?: string | undefined;
    size?: string | undefined;
    sampleHolder?: string | undefined;
    thickness?: string | undefined;
    sampleAsSubstrate?: string | undefined;
    type?: string | undefined;
    subSamples?: SubEntry[] | undefined;
    userId?: string | undefined;
    substrateLot?: string | undefined;
    substrateName?: string | undefined;
    substrateOrientation?: string | undefined;
    substratePurity?: number;
    substrateVendor?: string | undefined;
}

/** Lightweight data-package pointer on sample GET/search (snapshot ownership, not a full package DTO). */
export interface SampleDataPackageRefDto {
    id?: number;
    label?: string | undefined;
    /** Path key for /data/{RouteKey}: DOI, else pre-publish id, else numeric id. */
    routeKey?: string | undefined;
}

export interface SampleDropdownChoicesDto {
    sizes?: string[] | undefined;
    sampleHolders?: string[] | undefined;
    thicknesses?: string[] | undefined;
    quality?: string[] | undefined;
}

export interface SampleDto {
    id?: number | undefined;
    sampleLabel?: string | undefined;
    refSampleLabel?: string | undefined;
    parentId?: number | undefined;
    parentActivityId?: number | undefined;
    splitFrom?: SampleDto | undefined;
    subSamples?: SampleDto[] | undefined;
    instrumentId?: string | undefined;
    techniqueId?: string | undefined;
    projectIds?: number[] | undefined;
    projectLabels?: string[] | undefined;
    sampleAsSubstrate?: SampleDto[] | undefined;
    shipping?: number | undefined;
    shippingLabelType?: string | undefined;
    size?: string | undefined;
    thickness?: string | undefined;
    sampleHolder?: string | undefined;
    sampleLocation?: string | undefined;
    transferred?: boolean;
    finalized?: boolean;
    shipped?: boolean;
    useAsSubstrate?: boolean;
    quality?: string | undefined;
    description?: string | undefined;
    userId?: string | undefined;
    creationDate?: Date | undefined;
    shippingDate?: Date | undefined;
    substrateLot?: string | undefined;
    substrateOrientation?: string | undefined;
    substrateVendor?: string | undefined;
    substrateName?: string | undefined;
    substratePurity?: number | undefined;
    substrateMaterialIds?: number[] | undefined;
    substrateMaterials?: string[] | undefined;
    materialIds?: number[] | undefined;
    materials?: string[] | undefined;
    notes?: NoteDto[] | undefined;
    files?: FileDto[] | undefined;
    lastChangedDate?: Date | undefined;
    lastChangedByUser?: string | undefined;
    status?: StatusDto | undefined;
    reportingCategory?: ReportingCategoryDto | undefined;
    dataPackageId?: number | undefined;
    /** Snapshot data packages this sample appears in (this package, plus other accessible packages of the same label).
Empty for live samples. */
    dataPackages?: SampleDataPackageRefDto[] | undefined;
    isGrowthRun?: boolean;
    isSnapshot?: boolean;
    hasSubmittedActivities?: boolean;
    hasActivities?: boolean;
    /** Whether the current user may update this sample (detail footer, transfer reporting-category preflight). */
    canUpdateSample?: boolean;
}

export interface SampleFilter {
    instrumentId?: string | undefined;
    madeByUserId?: string | undefined;
    materials?: number[] | undefined;
    dateFrom?: Date | undefined;
    dateTo?: Date | undefined;
    substrateIds?: number[] | undefined;
    qualities?: string[] | undefined;
    size?: string | undefined;
    thickness?: string | undefined;
    sampleHolder?: string | undefined;
    shipped?: string | undefined;
}

export interface SampleImportConfig {
    enabled?: boolean | undefined;
    isActive?: boolean;
    isRestSubmitEnabled?: boolean;
    checkInterval?: number | undefined;
    source?: FileHostingRootConfig | undefined;
    filter?: FileFilterConfig | undefined;
    instrumentName?: string | undefined;
    id?: string | undefined;
    checkCron?: string | undefined;
    fullCheckCron?: string | undefined;
    retryCron?: string | undefined;
    cleanupCron?: string | undefined;
    cleanupMaxAge?: number | undefined;
    projectMapping?: { [key: string]: string; } | undefined;
    reportingCategoryMapping?: { [key: string]: string; } | undefined;
    eventLog?: LogFileSource | undefined;
    measurementLog?: LogFileSource | undefined;
    restartPending?: boolean;
    enableRestSubmit?: boolean | undefined;
    name?: string | undefined;
    alwaysCheckLogFiles?: boolean | undefined;
    recipeFileExtension?: string | undefined;
}

/** Filter preset for sample import records. Omit or null = no filter (all records). • **all** – No filter (all records) • **error** – Records with error (E) • **manual** – Manually changed (M) • **incomplete** – Incomplete (I) • **anyIssue** – Any issue (I, M, E) • **nothingToDo** – Nothing to do (X) • **ok** – OK - created or updated (C, U) • **pending** – Pending (P) • **done** – Done - all terminal states */
export enum SampleImportFilterStatusDto {
    All = "all",
    Error = "error",
    Manual = "manual",
    Incomplete = "incomplete",
    AnyIssue = "anyIssue",
    NothingToDo = "nothingToDo",
    Ok = "ok",
    Pending = "pending",
    Done = "done",
}

/** Partial update of a sample-import monitor row after external recipe_pipeline processing. */
export interface SampleImportOutcomeUpdateDto {
    /** Single-letter status: I, C, U, E, M, X, P (see SampleImportTask). */
    status?: string | undefined;
    message?: string | undefined;
    /** When true, increments the monitor row retry count by one. */
    incrementRetries?: boolean;
}

export interface SampleImportRecordDto {
    id?: number;
    collaboratorId?: string | undefined;
    filename?: string | undefined;
    fileDate?: string | undefined;
    fileVersion?: string | undefined;
    externalId?: string | undefined;
    instrumentId?: string | undefined;
    sampleLabel?: string | undefined;
    projectLabel?: string | undefined;
    sampleID?: number | undefined;
    status?: string | undefined;
    retries?: number;
    processDate?: string | undefined;
    message?: string | undefined;
    sampleDefinitionType?: string | undefined;
}

export interface SampleImportStat {
    status?: string | undefined;
    count?: number;
}

export interface SampleImportSubmitResponseDto {
    id?: number;
    /** True when an existing row with the same definition was returned without re-queueing. */
    unchanged?: boolean;
}

/** • **NoRestriction** – NoRestriction • **MaxOneProject** – MaxOneProject • **MaxOneExternalProject** – MaxOneExternalProject • **ExternalProjectExclusive** – ExternalProjectExclusive */
export enum SampleProjectMultiplicityPolicy {
    NoRestriction = "NoRestriction",
    MaxOneProject = "MaxOneProject",
    MaxOneExternalProject = "MaxOneExternalProject",
    ExternalProjectExclusive = "ExternalProjectExclusive",
}

export interface SampleReportColumnConfigDto {
    id?: number;
    order?: number;
    /** Label, used as column header. */
    label?: string | undefined;
    /** owner of the data to collect: Sample itself, the project or an activity */
    reportObject?: string | undefined;
    /** Attribute.
            
              */
    attribute?: string | undefined;
    /** Xpath to extract data from recipe.
Implies Attribute="recipe" */
    xpath?: string | undefined;
    /** Aggregation if several data points found.
- Sum (if numeric),
- concatWith(", ")
- concatWith("/") */
    aggregation?: string | undefined;
    format?: string | undefined;
    unit?: string | undefined;
    width?: number | undefined;
}

export interface SampleReportColumnDto {
    label?: string | undefined;
    unit?: string | undefined;
    width?: number;
    id?: number;
}

export interface SampleReportColumnGroupDto {
    label?: string | undefined;
    columns?: SampleReportColumnDto[] | undefined;
}

export interface SampleReportConfigDto {
    id?: number;
    synthesisTechnique?: string | undefined;
    synthesisInstrument?: string | undefined;
    label: string;
    searchCriteria?: SampleSearchCriteria | undefined;
    groups: SampleReportGroupConfigDto[];
}

export interface SampleReportDto {
    label?: string | undefined;
    columnGroups?: SampleReportColumnGroupDto[] | undefined;
    rows?: SampleReportRowDto[] | undefined;
}

export interface SampleReportGroupConfigDto {
    id?: number;
    order?: number;
    /** Label of the group */
    label?: string | undefined;
    reportObject?: string | undefined;
    /** XPath expression, if it evaluations to an XML Node, the group is shown */
    condition?: string | undefined;
    /** Value shown if condition is not met (only one column with this value will be shown then) */
    ifFalse?: string | undefined;
    /** Value shown if condition is met (only one column with this value will be shown then) */
    ifTrue?: string | undefined;
    forEach?: boolean;
    columns?: SampleReportColumnConfigDto[] | undefined;
}

export interface SampleReportRowDto {
    id?: string | undefined;
    ref?: string | undefined;
    data?: string[] | undefined;
}

export interface SampleRequestDto {
    id?: number;
    projectId: number;
    projectLabel?: string | undefined;
    userPI?: string | undefined;
    projectStatus?: ProjectStatusDto | undefined;
    /** Sample request status (O, P, S, L, C). */
    requestStatus?: RequestStatusDto | undefined;
    dueDate?: Date | undefined;
    description?: string | undefined;
    title: string;
    count?: number | undefined;
    shippings?: ShippingWithDeliveryDto[] | undefined;
    lastChangedDate?: Date | undefined;
    lastChangedByUser?: string | undefined;
}

/** Optional due filter: calendar days only. When Enabled and OnOrBefore is omitted, the server uses today (UTC date). */
export interface SampleRequestDueSearchOptionsDto {
    enabled?: boolean;
    /** ISO date (yyyy-MM-dd). Compared using calendar dates in UTC. */
    onOrBefore?: string | undefined;
}

/** Request body for POST sample-requests/search. */
export interface SampleRequestSearchCriteriaDto {
    statusSearch?: SampleRequestStatusSearchOptionsDto | undefined;
    dueSearch?: SampleRequestDueSearchOptionsDto | undefined;
    /** Substring match against request title, project label, and description. */
    searchText?: string | undefined;
    projectLabel?: string | undefined;
    projectType?: string | undefined;
    /** Project material ids (project’s configured materials). Matches submitted project; for authenticated users, pending projects they last changed may match too.
Does not include materials inferred from grown/shipped samples. */
    materials?: number[] | undefined;
    restrictToMyProjects?: boolean;
    /** Optional filter: project PI state (case-insensitive equality). */
    state?: string | undefined;
    /** Optional filter: project PI institution contains (case-insensitive). */
    institution?: string | undefined;
}

/** One row in the sample-request search grid: core request fields plus shipping rollups (no full Shippings list). */
export interface SampleRequestSearchResultDto {
    id?: number;
    projectId: number;
    projectLabel?: string | undefined;
    userPI?: string | undefined;
    projectStatus?: ProjectStatusDto | undefined;
    /** End date of the project row used for label / PI / status (single project version, or the submitted version when multiple exist). */
    projectEndDate?: Date | undefined;
    requestStatus?: RequestStatusDto | undefined;
    dueDate?: Date | undefined;
    description?: string | undefined;
    title: string;
    count?: number | undefined;
    lastChangedDate?: Date | undefined;
    lastChangedByUser?: string | undefined;
    /** Total samples on all linked shippings for this request (same scope as AllocatedMaterials — includes requested / not-yet-shipped-out lines). */
    allocatedSamplesCount?: number;
    lastShipmentDate?: Date | undefined;
    /** Rollup over all linked shippings: New while any shipping is not effectively shipped; Submitted when all are shipped or local transfer; null when there are no shippings. */
    shipmentStatus?: StatusDto | undefined;
    /** Distinct material names from samples on all linked shippings (requested or shipped), earmarked for this request. */
    allocatedMaterials?: string[] | undefined;
    /** PI state code from the PI collaborator history slice (latest validity row by ValidFrom),
aligned with project-search PI geography. */
    piState?: string | undefined;
    /** PI institution from the same history slice as PiState. */
    piInstitution?: string | undefined;
}

/** Status filter for POST sample-requests/search: either Preset or a single StatusId. */
export interface SampleRequestStatusSearchOptionsDto {
    preset?: SampleRequestStatusSearchPresetDto | undefined;
    /** When set, only this request status id is returned (e.g. O, P, S, L, C). Preset must be omitted. */
    statusId?: string | undefined;
}

/** Preset filters for sample-request status (API). Mirrors . • **Open** – Open • **AllExceptCancelled** – AllExceptCancelled • **AllIncludingCancelled** – AllIncludingCancelled */
export enum SampleRequestStatusSearchPresetDto {
    Open = "Open",
    AllExceptCancelled = "AllExceptCancelled",
    AllIncludingCancelled = "AllIncludingCancelled",
}

export interface SampleRequestWithDelivery {
    requestId: number;
    partialDelivery?: boolean;
}

export interface SampleRequestWithDeliveryDto {
    requestId: number;
    request?: SampleRequestDto | undefined;
    partialDelivery?: boolean;
}

export interface SampleSearchCriteria {
    addedAfter?: Date | undefined;
    addedBefore?: Date | undefined;
    grownAfter?: Date | undefined;
    grownBefore?: Date | undefined;
    reportingCategory?: string | undefined;
    shippedAfter?: Date | undefined;
    shippedBefore?: Date | undefined;
    shipped?: string | undefined;
    description?: string | undefined;
    elements?: string[] | undefined;
    materials?: number[] | undefined;
    materialNames?: string[] | undefined;
    excludeSampleIds?: number[] | undefined;
    techniqueId?: string | undefined;
    instrumentId?: string | undefined;
    characterizationTechniqueId?: string | undefined;
    characterizationInstrumentId?: string | undefined;
    projectId?: string | undefined;
    researchGroup?: string | undefined;
    grownByUserId?: string | undefined;
    grownByResearchGroup?: string | undefined;
    grownByScope?: GrownByScope | undefined;
    addedByUserId?: string | undefined;
    addedByResearchGroup?: string | undefined;
    sampleLabel?: string | undefined;
    refSampleLabel?: string | undefined;
    substrateLot?: string | undefined;
    substrateOrientation?: string | undefined;
    substrateVendor?: string | undefined;
    substrateName?: string | undefined;
    substratePurity?: number;
    sampleId?: string | undefined;
    showShippable?: boolean | undefined;
    onlyPending?: boolean | undefined;
    onlySubmitted?: boolean | undefined;
    onlyMarkedAsSubstrate?: boolean | undefined;
    includeSplitPieces?: boolean;
    includeFinalized?: boolean | undefined;
    withCharacterization?: string | undefined;
    status?: string | undefined;
    multiSampleGrowthOnly?: boolean | undefined;
    onlyPreparedMaterials?: boolean | undefined;
    specimenType?: string | undefined;
    kind?: SampleSearchKind | undefined;
}

/** • **Active** – Active • **Snapshot** – Snapshot • **Both** – Both */
export enum SampleSearchKind {
    Active = "Active",
    Snapshot = "Snapshot",
    Both = "Both",
}

/** Lightweight DTO for sample search results containing only fields needed for list/overview displays, plus calculated properties like synthesis/characterization data. */
export interface SampleSearchResultDto {
    id: number;
    sampleLabel: string;
    refSampleLabel?: string | undefined;
    /** Parent sample ID when this sample is part of a multi-sample growth run; null otherwise. */
    parentId?: number | undefined;
    /** Parent sample label (growth run label) when this sample is part of a multi-sample growth run; null otherwise. */
    parentLabel?: string | undefined;
    projectIds: number[];
    projectLabels: string[];
    /** When true, reporting category may be edited in list/grid UIs: no projects (unassigned)
or all associated projects are internal (in-house). False for user-project samples.
Submitted samples may still be recategorized. */
    reportingCategoryRequired: boolean;
    /** Whether the current user may update this sample (e.g. inline reporting category in search grids).
Computed with the same authorization rules as PATCH …/reporting-category. */
    canUpdateSample: boolean;
    size?: string | undefined;
    thickness?: string | undefined;
    sampleHolder?: string | undefined;
    transferred?: boolean;
    finalized?: boolean;
    shipped?: boolean;
    useAsSubstrate?: boolean;
    quality?: string | undefined;
    userId: string;
    creationDate: Date;
    /** Calculated field: User who added the sample to inventory.
Derived from inventory activity user if exists, otherwise falls back to sample's userId. */
    addedBy: string;
    substrateLot?: string | undefined;
    substrateOrientation?: string | undefined;
    substrateVendor?: string | undefined;
    substrateName?: string | undefined;
    substratePurity?: number | undefined;
    substrateMaterialIds: number[];
    substrateMaterials: string[];
    materialIds: number[];
    materials: string[];
    description?: string | undefined;
    /** Calculated field: Last activity for the sample */
    lastActivity?: SampleActivityDto | undefined;
    /** Calculated field: Users who grew this sample */
    grownByUsers: string[];
    /** Calculated field: Synthesis techniques used */
    synthesisTechniques: string[];
    /** Calculated field: Synthesis instruments used */
    synthesisInstruments: string[];
    /** Calculated field: Growth/synthesis dates */
    growthDates: Date[];
    characterizationTechniques: string[];
    characterizationInstruments: string[];
    lastChangedDate: Date;
    lastChangedByUser: string;
    status: StatusDto;
    reportingCategory?: ReportingCategoryDto | undefined;
    /** True when the representative row is a SampleSnapshot. */
    isSnapshot?: boolean;
    /** Owning snapshot data package when IsSnapshot; otherwise null. */
    dataPackageId?: number | undefined;
    /** Snapshot data packages for this representative (this package; search does not expand siblings). */
    dataPackages: SampleDataPackageRefDto[];
    /** v2 only: /api/v2/samples/{id} for the representative. */
    detailUrl?: string | undefined;
}

export interface SampleStatisticsDto {
    count?: number;
    technique?: string | undefined;
    instrument?: string | undefined;
    faculty?: string | undefined;
    researcher?: string | undefined;
    substrate?: string | undefined;
    status?: string | undefined;
    materials?: string | undefined;
    materialIds?: number[] | undefined;
    characterizations?: SampleStatLineDto[] | undefined;
}

export interface SampleStatLineDto {
    id?: string | undefined;
    count?: number;
}

export interface SampleWithLabel {
    sampleId: number;
    labelType?: string | undefined;
}

export interface SampleWithLabelDto {
    sampleId: number;
    sample?: SampleDto | undefined;
    labelType?: string | undefined;
}

export interface ScienceDriverDto {
    id?: number;
    name?: string | undefined;
    label?: string | undefined;
    description?: string | undefined;
}

export interface ShippingContact {
    name?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    address?: string | undefined;
}

export interface ShippingContactDto {
    name?: any | undefined;
    phone?: any | undefined;
    email?: any | undefined;
    address?: any | undefined;
}

export interface ShippingDto {
    id?: number;
    projectId: number;
    researcher?: string | undefined;
    researcherPhone?: string | undefined;
    researcherEmail?: string | undefined;
    address?: string | undefined;
    returnAddress?: string | undefined;
    date?: Date | undefined;
    budget?: string | undefined;
    contactName?: string | undefined;
    contactEmail?: string | undefined;
    contactPhone?: string | undefined;
    localTransfer?: boolean;
    shippingType?: string | undefined;
    trackingID?: string | undefined;
    /** Optional richtext comment for the shipping request. */
    comment?: string | undefined;
    samples: SampleWithLabelDto[];
    sampleRequests: SampleRequestWithDeliveryDto[];
    lastChangedDate?: Date | undefined;
    lastChangedByUser?: string | undefined;
    status?: StatusDto | undefined;
    shipped?: boolean;
    projectLabel?: string | undefined;
}

export interface ShippingRequest {
    projectId: number;
    researcher?: string | undefined;
    researcherPhone?: string | undefined;
    researcherEmail?: string | undefined;
    address?: string | undefined;
    returnAddress?: string | undefined;
    date?: Date | undefined;
    budget?: string | undefined;
    contactName?: string | undefined;
    contactEmail?: string | undefined;
    contactPhone?: string | undefined;
    localTransfer?: boolean;
    shippingType?: string | undefined;
    trackingID?: string | undefined;
    comment?: string | undefined;
    status?: string | undefined;
    samples?: SampleWithLabel[] | undefined;
    sampleRequests?: SampleRequestWithDelivery[] | undefined;
    recipientProjectId?: number | undefined;
    targetProjectId?: number | undefined;
}

/** Search criteria for shipping records. Used as request body for shipping search. */
export interface ShippingSearchCriteriaDto {
    /** Filter by project ID (text or numeric) */
    projectId?: string | undefined;
    /** Filter by sender user ID */
    senderId?: string | undefined;
    /** Filter by receiver (text) */
    receiver?: string | undefined;
    /** Filter by local transfer (true) vs shipping (false). Null = all. */
    localTransfer?: boolean | undefined;
    /** Filter by date - from */
    dateFrom?: Date | undefined;
    /** Filter by date - to */
    dateTo?: Date | undefined;
    /** Filter by tracking number */
    trackingNumber?: string | undefined;
    /** Filter by status. Omit or null = no filter. */
    status?: ShippingSearchStatusDto | undefined;
}

/** Filter preset for shipping search status. Omit or null = no filter. • **shipped** – Done: Shipped=true (shipping) or Status=S (local transfer) • **Pending** – Status=P and not shipped • **Submitted** – Status=S, not yet shipped (regular) / done (local) • **initiated** – Not done yet • **P** – Pending (wire code P) • **S** – Submitted (wire code S) */
export enum ShippingSearchStatusDto {
    Shipped = "shipped",
    Pending = "Pending",
    Submitted = "Submitted",
    Initiated = "initiated",
    P = "P",
    S = "S",
}

export interface ShippingWithDeliveryDto {
    request?: ShippingDto | undefined;
    partialDelivery?: boolean;
}

export interface SimulationDataSetDto {
    id?: number;
    simulationMethod: string;
    filename: string;
    elements: string;
    fileLink: string;
    mainAuthor: string;
    year: number;
    doi?: string | undefined;
    publication?: PublicationDto | undefined;
}

export interface SimulationDataSetUpdateRequest {
    id: number;
    simulationMethod: string;
    elements: string;
    mainAuthor: string;
    year: number;
    doi?: string | undefined;
}

/** Shared lifecycle status for entities using Tools.Enums.Status. • **P** – Pending • **S** – Submitted • **R** – Published • **N** – New • **D** – Deleted • **H** – Hidden */
export enum StatusDto {
    Pending = "P",
    Submitted = "S",
    Published = "R",
    New = "N",
    Deleted = "D",
    Hidden = "H",
}

export interface Stream extends MarshalByRefObject {
    canTimeout?: boolean;
    readTimeout?: number;
    writeTimeout?: number;
}

export function isStream(object: any): object is Stream {
    return object && object[''] === 'Stream';
}

export interface SubEntry {
    sampleAsSubstrate?: string | undefined;
    substrateLot?: string | undefined;
    substrateName?: string | undefined;
    substrateOrientation?: string | undefined;
    substratePurity?: number;
    substrateVendor?: string | undefined;
}

export interface SubstrateDropdownChoicesDto {
    orientations?: string[] | undefined;
    vendors?: string[] | undefined;
    lots?: string[] | undefined;
    granularities?: string[] | undefined;
    names?: string[] | undefined;
}

export interface SubstrateDto {
    substrateName: string;
    substrateVendor?: string | undefined;
    substrateLot?: string | undefined;
    substratePurity?: number | undefined;
    substrateOrientation?: string | undefined;
    substrateMaterials?: string[] | undefined;
    substrateMaterialIds?: number[] | undefined;
}

export interface SynthesisInstrumentDto {
    id?: string | undefined;
    name?: string | undefined;
    location?: string | undefined;
    description?: string | undefined;
    facility?: string | undefined;
    instrumentType?: string | undefined;
    synthesisTechniques?: string[] | undefined;
    techniqueLabel?: string | undefined;
    recipeTemplate?: string | undefined;
    faculty?: string | undefined;
    instrumentFunding?: InstrumentFundingDto | undefined;
    metadataConfig?: FileMetaDataConfigDto | undefined;
    recipeTemplates?: RecipeTemplateDto[] | undefined;
    instrumentManagers?: string[] | undefined;
    doi?: string | undefined;
}

export interface SynthesisInstrumentFilter {
    researchGroup?: string | undefined;
    technique?: string | undefined;
    ids?: string | undefined;
    excludeIds?: string | undefined;
}

export interface SynthesisInstrumentTypeDto {
    id?: string | undefined;
    label?: string | undefined;
    synthesisTechniques?: string[] | undefined;
}

export interface SynthesisTechniqueDto {
    id?: string | undefined;
    name?: string | undefined;
    growOnSubstrate?: boolean;
    parentTechnique?: string | undefined;
    subTechniques?: SynthesisTechniqueDto[] | undefined;
    instrumentTypes?: string[] | undefined;
}

export interface SysDto {
    orgName: string;
    dataManagerEmail?: string | undefined;
    logoPath?: string | undefined;
    authorExplanation?: string | undefined;
    /** Path of the LiST user guide served by this API, relative to the API base (/docs/); the client joins
it with its browser-facing API URL, like file downloadUrls. Target of the Help menu and the
contextual help buttons. Null when the guide was not built into this deployment.
             */
    documentationUrl?: string | undefined;
    /** Organization-specific documentation (appsettings Systemconfig:Wiki), shown as an extra Help menu
entry: an absolute URL, or a path relative to the API base (e.g. /docs/org/2dcc/). Null when not
configured.
             */
    orgDocumentationUrl?: string | undefined;
    bugReport?: string | undefined;
    enableShibboleth: boolean;
    /** Current server environment label (e.g. Testing, Staging, Production).
             */
    environment?: string | undefined;
    /** Name of the database this server is connected to, with a locality suffix (e.g. 2DCC@Local or
2DCC@Server). The suffix only indicates local vs remote; the host/URL is never exposed.
Only populated outside of production deployments; null in production.
             */
    databaseName?: string | undefined;
    allowAnonymous: boolean;
    sessionTimeoutInHours?: number | undefined;
    msalConfig: AzureAdConfig;
    theme?: ThemeConfig | undefined;
    /** Policy for how many projects (and non-internal projects) may be linked to a sample; mirrors appsettings Systemconfig:SampleProjectMultiplicity. */
    sampleProjectMultiplicity: SampleProjectMultiplicityPolicy;
    /** When false, background configs loaded on this server have schedules cleared (cron/interval/retry/cleanup). */
    scheduleBackgroundJobs?: boolean;
    /** When false, per-config RestartPending is forced off when configs are loaded (no pending replay on startup). */
    restartPendingOnStartup?: boolean;
    /** From build.json / branch.json at deploy (branch, short hash, build time, version). */
    build?: BuildInfoDto | undefined;
}

export interface ThemeConfig {
    primaryMain: string;
    secondaryMain: string;
}

export interface TheoryActivityDto extends ActivityDto {
    projectId?: number | undefined;
    projectLabel?: string | undefined;
    dataPackageId?: number;
    dataPackageLabel?: string | undefined;
    simulationTechnique?: string | undefined;
    link?: string | undefined;
    version?: string | undefined;
    software?: string | undefined;
    isSnapshot?: boolean;
}

export function isTheoryActivityDto(object: any): object is TheoryActivityDto {
    return object && object[''] === 'TheoryActivityDto';
}

export interface TheoryActivitySearchCriteria {
    techniqueId?: string | undefined;
    projectId?: string | undefined;
    searchTerm?: string | undefined;
    software?: string | undefined;
    softwareVersion?: string | undefined;
    description?: string | undefined;
    createdByUserId?: string | undefined;
    researchGroup?: string | undefined;
    dateAfter?: Date | undefined;
    dateBefore?: Date | undefined;
    status?: string | undefined;
    onlyPending?: boolean | undefined;
    onlySubmitted?: boolean | undefined;
    dataPackageId?: number | undefined;
}

export interface UpdateActivityRequest {
    id?: number | undefined;
    date?: Date | undefined;
    userId?: string | undefined;
    runtime?: number | undefined;
    /** Visibility: P (On Publication), U (User PI), I (Internal) */
    visibility?: VisibilityDto | undefined;
    /** Activity type (e.g. PREP, SYN, PUB) */
    type?: ActivityTypeDto | undefined;
    desc?: string | undefined;
}

export interface UpdateBulkPreparationRequest {
    id?: number;
    sampleId?: number;
    sampleLabel?: string | undefined;
    materialId?: number | undefined;
    recipe?: RecipeDto | undefined;
}

export interface UpdateCollaboratorRequest extends CreateCollaboratorRequest {
    /** Slice start (admin edit of a specific row). Omit to update the current open slice. */
    validFrom?: string | undefined;
    /** Slice end (admin edit of a specific row). Omit to update the current open slice. */
    validTo?: string | undefined;
    /** When affiliation/profile changes, start the new slice at this date (defaults to now). */
    effectiveFrom?: string | undefined;
}

export function isUpdateCollaboratorRequest(object: any): object is UpdateCollaboratorRequest {
    return object && object[''] === 'UpdateCollaboratorRequest';
}

/** Body for PUT communications/{id}. Only content fields are persisted; ID must match the route. */
export interface UpdateCommunicationRequest {
    id?: number;
    title?: string | undefined;
    format?: string | undefined;
    participants?: string | undefined;
    text?: string | undefined;
    date?: Date | undefined;
}

export interface UpdateDataPackageRequest extends CreateDataPackageRequest {
    id: number;
}

export function isUpdateDataPackageRequest(object: any): object is UpdateDataPackageRequest {
    return object && object[''] === 'UpdateDataPackageRequest';
}

/** Self-service profile update (signed-in user, own record only). */
export interface UpdateProfileRequest {
    email?: string | undefined;
    middleName?: string | undefined;
    position?: string | undefined;
    orcId?: string | undefined;
    phone?: string | undefined;
    institution?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    country?: string | undefined;
    /** When affiliation/address changes, start the new timeslice on this date (defaults to now). */
    effectiveFrom?: string | undefined;
}

export interface UpdateProjectActivityRequest extends UpdateActivityRequest {
}

export function isUpdateProjectActivityRequest(object: any): object is UpdateProjectActivityRequest {
    return object && object[''] === 'UpdateProjectActivityRequest';
}

export interface UpdatePublicationRequest extends CreatePublicationRequest {
    id: number;
}

export function isUpdatePublicationRequest(object: any): object is UpdatePublicationRequest {
    return object && object[''] === 'UpdatePublicationRequest';
}

export interface UpdateRoleRequest {
    id: number;
    isUser: boolean;
    isFaculty: boolean;
    isResearcher: boolean;
    isInhouse: boolean;
    name: string;
    privileges: PrivilegeDto[];
}

export interface UpdateSampleActivityRequest extends UpdateActivityRequest {
    facility?: string | undefined;
    sampleLocation?: string | undefined;
    charId?: string | undefined;
    technique?: string | undefined;
    instrument?: string | undefined;
    recipeTemplate?: string | undefined;
    recipe?: RecipeDto | undefined;
    materials?: ActivityMaterialDto[] | undefined;
    characterizationTechnique?: string | undefined;
    instrumentDOI?: string | undefined;
}

export function isUpdateSampleActivityRequest(object: any): object is UpdateSampleActivityRequest {
    return object && object[''] === 'UpdateSampleActivityRequest';
}

export interface UpdateTheoryActivityRequest extends UpdateActivityRequest {
    link?: string | undefined;
    version?: string | undefined;
    software?: string | undefined;
}

export function isUpdateTheoryActivityRequest(object: any): object is UpdateTheoryActivityRequest {
    return object && object[''] === 'UpdateTheoryActivityRequest';
}

export interface UserSettingsDto {
    userID?: string | undefined;
    showLastProject?: boolean;
    lastProjectID?: number | undefined;
    showLastSample?: boolean;
    showShippedSamples?: boolean;
    nbOfRecentDays?: number;
    lastSampleID?: number | undefined;
    sortNewestSampleFirst?: boolean;
    projectSearchCriteria?: ProjectSearchCriteria | undefined;
    sampleSearchCriteria?: SampleSearchCriteria | undefined;
    sampleFilter?: SampleFilter | undefined;
}

/** Visibility level for activities, notes, and files. • **P** – On Publication (visible when project is published) • **U** – User PI (visible to project PI only) • **I** – Internal (visible to project collaborators) */
export enum VisibilityDto {
    OnPublication = "P",
    UserPI = "U",
    Internal = "I",
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}

/* tslint:disable */
/* eslint-disable */
// @ts-ignore